<template>
	<div class="container-fluid" :key="atualizaDb">
		<div class="no-print">
			<div v-if="!visualizar">
				<fl-cabecalho-db-piloto
					:cabecalho-status="cabecalho"
					:form-id="form.id"
					@volta-lista="voltaLista"
					@click-print="clickPrint"
				/>

				<!-- FORM -->
			</div>
			<div v-if="!visualizar">
				<flCabecalhoForm
					class="print-titulo-form-20"
					:texto="_traducao('global', 'aeronave')"
				/>
				<fl-informacoes-aeronave :aeronave="aeronave" :trecho="trecho" />
				<flCabecalhoForm
					class="print-titulo-form-20"
					:texto="_traducao('global', 'manutencao')"
				/>
				<fl-informacoes-manutencao :formulario="form" />
				<fl-informacoes-ciclos-totais
					:formulario="form"
					v-if="editar"
					:aeronave="aeronave"
				/>
			</div>

			<!-- ORIGEM DO VOO -->
			<div v-if="!visualizar">
				<flCabecalhoForm
					class="print-titulo-form-20"
					:texto="dbComercial ?
							_traducao('global', 'programacaoVoo') :
							_traducao('global', 'despachoAeronaves')"
				/>

				<div class="row">
					<div class="col-xs-12 form-group">
						<button
							class="btn btn-info"
							type="button"
							@click="clickSetaTipoDiario()"
						>
							<span v-if="despacho == ''"
								><i class="fa fa-fw fa-plus"></i
								>{{ dbComercial ?
									_traducao('global', 'adicionarProgramacaoVoo').toUpperCase() :
									_traducao('global', 'adicionarDespacho').toUpperCase()
								}}
							</span>
							<span v-if="despacho != ''"
								><i class="fa fa-fw fa-refresh"></i
								>{{ dbComercial ?
									_traducao('global', 'alterarProgramacaoVoo').toUpperCase() :
									_traducao('global', 'alterarDespacho').toUpperCase()
								}}
							</span>
						</button>
					</div>
				</div>

				<!-- DESPACHO -->
				<div v-if="despacho != ''">
					<div class="row">
						<div class="col-xs-6 col-md-2 form-group">
							<label>{{ _traducao('global', 'codigo') }}:</label>
							<br />
							<p>{{ despacho.numero }}</p>
						</div>

						<div class="col-xs-6 col-md-2 form-group">
							<label>{{ _traducao('global', 'data') }}:</label>
							<br />
							<p>{{ despacho.data_inicio | dataTempo }}</p>
						</div>

						<div class="col-md-4 col-xs-12 form-group">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<br />
							<p>{{ despacho.historico }}</p>
						</div>

						<div
							class="col-xs-12 col-md-4"
							:class="{'has-error': erro.finalizar_despacho != ''}"
						>
							<label>
								{{ dbComercial ?
								   _traducao('global', 'desejaEncerrarEssaProgramacaoVoo') :
								   _traducao('global', 'desejaEncerrarEsseDespacho')
								}}
							</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									@click="
										form.finalizar_despacho = '1'
										erro.finalizar_despacho = ''
									"
									:class="{'btn-info': form.finalizar_despacho == '1'}"
									class="btn btn-default btn-sm"
								>
									{{ _traducao('global', 'sim') }}
								</button>
								<button
									type="button"
									@click="
										form.finalizar_despacho = '0'
										erro.finalizar_despacho = ''
									"
									:class="{'btn-info': form.finalizar_despacho == '0'}"
									class="btn btn-default btn-sm"
								>
									{{ _traducao('global', 'nao') }}
								</button>
							</div>
							<p class="help-block" v-if="erro.finalizar_despacho">
								{{ erro.finalizar_despacho }}
							</p>
						</div>
					</div>

					<div v-if="despacho.id_ordem_missao != null && !dbComercial">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'ordemDeMissao')"
						/>

						<div class="row">
							<div class="col-xs-6 col-md-2 form-group">
								<label>{{ _traducao('global', 'codigo') }}:</label>
								<br />
								<p>{{ despacho.ordem_codigo }}</p>
							</div>

							<div class="col-xs-6 col-md-2 form-group">
								<label>{{ _traducao('global', 'data') }}:</label>
								<br />
								<p>{{ despacho.ordem_data_inicio | dataTempo }}</p>
							</div>

							<div class="col-md-4 col-xs-12 form-group">
								<label>{{ _traducao('global', 'descricao') }}:</label>
								<br />
								<p v-html="despacho.ordem_descricao"></p>
							</div>

							<div
								class="col-md-4 col-xs-12"
								:class="{'has-error': erro.finalizar_ordem != ''}"
								v-if="exibeFinalizarOrdemMissao == '1'"
							>
								<label
									>*
									{{
										_traducao('global', 'desejaEncerrarEssaOrdemDeMissao')
									}}</label
								>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.finalizar_ordem = '1'
											erro.finalizar_ordem = ''
										"
										:disabled="edicao && form.finalizar_ordem == 1"
										:class="{'btn-info': form.finalizar_ordem == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.finalizar_ordem = '0'
											erro.finalizar_ordem = ''
										"
										:class="{'btn-info': form.finalizar_ordem == '0'}"
										:disabled="edicao && form.finalizar_ordem == 1"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.finalizar_ordem">
									{{ erro.finalizar_ordem }}
								</p>
							</div>
						</div>
					</div>

					<div v-if="despacho.id_solicitacao != null">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'solicitaUsoAeronave')"
						/>

						<div class="row">
							<div class="col-xs-6 col-md-2 form-group">
								<label>{{ _traducao('global', 'codigo') }}:</label>
								<br />
								<p>{{ despacho.solicitacao_codigo }}</p>
							</div>

							<div class="col-md-10 col-xs-12">
								<label>{{ _traducao('global', 'descricao') }}:</label>
								<br />
								<p>{{ despacho.solicitacao_descricao }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!visualizar">
				<div class="row" v-if="aeronave.tipo == 'A'">
					<div class="col-xs-12">
						<flCabecalhoForm :texto="'APU'" />
						<div class="row">
							<div v-for="apu in aeronave.apu_aeronave" :key="'1' + apu.id">
								<div
									class="col-xs-12 col-md-2"
									v-if="aeronave.apu_aeronave.length > 0"
								>
									<label>Horímetro APU:</label><br />
									<money
										type="text"
										v-model="form.horimetro_apu"
										v-bind="_vpercem(1)"
										class="input-sm form-control"
									></money>
								</div>
							</div>
						</div>
						<div class="row" v-if="aeronave.apu_aeronave.length == 0">
							<div class="col-xs-12">
								<p>Essa aeronave não possui APU.</p>
							</div>
						</div>
					</div>
				</div>

				<!-- EXIBE O FORM SE O TIPO DO VOO FOR DIFERENTE DE VAZIO -->
				<div v-if="exibeForm">
					<!-- TRECHO  -->
					<div class="row" :class="{'form-group': aeronave.tipo == 'A'}">
						<div class="col-xs-12">
							<flCabecalhoForm
								class="print-titulo-form-20"
								:texto="_traducao('global', 'trecho')"
							/>
							<!-- DE -->
							<div class="row">
								<div
									class="col-xs-12 col-md-4 form-group"
									:class="{'has-error': erro.de != ''}"
								>
									<label>* {{ _traducao('menuVoo', 'menuVde') }}:</label>

									<a
										href="#"
										@click.prevent="clickInverter()"
										style="position: absolute; right: 16px"
									>
										<i class="fa fa-retweet fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'inverter') }}
									</a>

									<a
										href="#"
										@click.prevent="preencherRotaer(form.de, 'de')"
										v-if="form.de == 'ZZZZ'"
										style="position: absolute; right: 80px"
									>
										<i class="fa fa-magnet fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'carregarPosicaoDoVoo') }}
									</a>

									<v-select
										v-model="form.de_select"
										label="sigla"
										class="form-control input-sm"
										:options="rotaER"
									></v-select>
									<p class="help-block" v-if="erro.de != ''">{{ erro.de }}</p>
								</div>

								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.de != ''"
									:class="{'has-error': erro.nome_estado_de != ''}"
								>
									<label>* {{ _traducao('global', 'estado') }}:</label>
									<select
										v-model="form.nome_estado_de"
										@change="blurCarregaCidades('de', true)"
										:disabled="form.de != 'ZZZZ'"
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in estados"
											:value="item.sigla"
											:key="'2' + item.sigla.toUpperCase()"
										>
											{{ item.sigla.toUpperCase() }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_estado_de != ''">
										{{ erro.nome_estado_de }}
									</p>
								</div>
								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.de != ''"
									:class="{'has-error': erro.nome_cidade_de != ''}"
								>
									<label>* {{ _traducao('global', 'cidade') }}:</label>
									<span class="pull-right" v-if="loadDe">
										<i class="fa fa-fw fa-refresh fa-spin"></i>
										{{ _traducao('global', 'carregando') }}...</span
									>
									<input
										type="text"
										disabled="disabled"
										v-if="form.de != 'ZZZZ'"
										class="form-control input-sm"
										v-model="form.nome_cidade_de"
									/>
									<select
										v-model="form.nome_cidade_de"
										v-if="form.de == 'ZZZZ'"
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in cidadesDe"
											:value="item.descricao"
											:key="'3' + item.descricao.toUpperCase()"
										>
											{{ item.descricao.toUpperCase() }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_cidade_de != ''">
										{{ erro.nome_cidade_de }}
									</p>
								</div>
								<div class="col-xs-12 col-md-2 form-group">
									<label> Latitude:</label>
									<input
										v-model="form.lat_inicio"
										type="text"
										class="form-control input-sm"
										:disabled="form.de != 'ZZZZ'"
										:v-mask="`mascaraLatitude()`"
										placeholder="DGGºMM'SS"
									/>
								</div>

								<div class="col-xs-12 col-md-2 form-group">
									<label> Longitude:</label>
									<input
										v-model="form.lng_inicio"
										:disabled="form.de != 'ZZZZ'"
										type="text"
										class="form-control input-sm"
										v-mask="'S000º00\'00'"
										placeholder="DGGGºMM'SS"
									/>
								</div>
							</div>

							<!-- PARA -->
							<div class="row" style="margin-top 16px">
								<div
									class="col-xs-12 col-md-4 form-group"
									:class="{'has-error': erro.para != ''}"
								>
									<label>* {{ _traducao('menuVoo', 'menuVpara') }}:</label>

									<a
										href="#"
										@click.prevent="clickCopiarDe()"
										style="position: absolute; right: 16px"
									>
										<i class="fa fa-hand-o-up fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'copiar') }}
									</a>

									<a
										href="#"
										@click.prevent="preencherRotaer(form.para, 'para')"
										v-if="form.para == 'ZZZZ'"
										style="position: absolute; right: 80px"
									>
										<i class="fa fa-magnet fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'carregarPosicaoDoVoo') }}
									</a>

									<v-select
										v-model="form.para_select"
										label="sigla"
										class="form-control input-sm"
										:options="rotaER"
									></v-select>
									<p class="help-block" v-if="erro.para != ''">
										{{ erro.para }}
									</p>
								</div>

								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.para != ''"
									:class="{'has-error': erro.nome_estado_para != ''}"
								>
									<label>* {{ _traducao('global', 'estado') }}:</label>
									<select
										v-model="form.nome_estado_para"
										@change="blurCarregaCidades('para', true)"
										:disabled="form.para != 'ZZZZ'"
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in estados"
											:value="item.sigla"
											:key="'4' + item.sigla.toUpperCase()"
										>
											{{ item.sigla.toUpperCase() }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_estado_para != ''">
										{{ erro.nome_estado_para }}
									</p>
								</div>

								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.para != ''"
									:class="{'has-error': erro.nome_cidade_para != ''}"
								>
									<label>* {{ _traducao('global', 'cidade') }}:</label>
									<span class="pull-right" v-if="loadPara">
										<i class="fa fa-fw fa-refresh fa-spin"></i>
										{{ _traducao('global', 'carregando') }}...</span
									>
									<input
										type="text"
										disabled="disabled"
										v-if="form.para != 'ZZZZ'"
										class="form-control input-sm"
										v-model="form.nome_cidade_para"
									/>
									<select
										v-model="form.nome_cidade_para"
										v-if="form.para == 'ZZZZ'"
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in cidadesPara"
											:value="item.descricao"
											:key="'5' + item.descricao.toUpperCase()"
										>
											{{ item.descricao.toUpperCase() }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_cidade_para != ''">
										{{ erro.nome_cidade_para }}
									</p>
								</div>

								<div class="col-xs-12 col-md-2 form-group">
									<label> {{ _traducao('global', 'latitude') }}:</label>
									<input
										v-model="form.lat_fim"
										:disabled="form.para != 'ZZZZ'"
										type="text"
										class="form-control input-sm"
										:v-mask="`mascaraLatitudeFinal()`"
										placeholder="DGGºMM'SS"
									/>
								</div>

								<div class="col-xs-12 col-md-2 form-group">
									<label> {{ _traducao('global', 'longitude') }}:</label>
									<input
										v-model="form.lng_fim"
										:disabled="form.para != 'ZZZZ'"
										type="text"
										class="form-control input-sm"
										v-mask="'S000º00\'00'"
										placeholder="DGGGºMM'SS"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- MOTOR E HORARIO  -->
					<div class="row">
						<div class="col-xs-12 col-md-4">
							<flCabecalhoForm
								class="print-titulo-form-20"
								:texto="_traducao('global', 'horario')"
							/>

							<div class="row">
								<!-- ACIONAMENTO -->
								<div
									class="col-xs-6 form-group"
									:class="{'has-error': erro.acionamento != ''}"
								>
									<label>* {{ label_acionamento }}:</label>
									<flDateTime
										@v-model="(val) => setaAcionamento(val)"
										:value="form.acionamento"
										name="dtOrdemInicio"
										:lang="_getLangDp"
										:max-date="maxDate"
										time="HH:mm"
										:disabled="this.editar"
										:format="_formatDate"
									/>
									<p class="help-block" v-if="erro.acionamento != ''">
										{{ erro.acionamento }}
									</p>
									<label
										v-show="form.acionamento_utc != ''"
										style="position: absolute"
										>UTC: {{ form.acionamento_utc }}</label
									>
								</div>

								<!-- DECOLAGEM -->
								<div
									class="col-xs-6 form-group"
									:class="{'has-error': erro.decolagem != ''}"
								>
									<label>* {{ _traducao('global', 'decolagem') }}:</label>
									<flDateTime
										@v-model="(val) => setaDecolagem(val)"
										:value="form.decolagem"
										name="dtOrdemInicio"
										:lang="_getLangDp"
										:max-date="maxDate"
										time="HH:mm"
										:disabled="this.editar"
										:format="_formatDate"
									/>
									<p class="help-block" v-if="erro.decolagem != ''">
										{{ erro.decolagem }}
									</p>
									<label
										v-show="form.decolagem_utc != ''"
										style="position: absolute"
										>UTC: {{ form.decolagem_utc }}</label
									>
								</div>
							</div>

							<!-- POUSO/CORTE -->
							<div class="row" style="margin-top: 16px">
								<div
									class="col-xs-6 form-group"
									:class="{'has-error': erro.pouso != ''}"
								>
									<label>* {{ _traducao('global', 'pouso') }}:</label>
									<flDateTime
										@v-model="(val) => setaPouso(val)"
										:value="form.pouso"
										name="dtOrdemPouso"
										:lang="_getLangDp"
										time="HH:mm"
										:disabled="this.editar"
										:max-date="maxDate"
										:format="_formatDate"
									/>
									<p class="help-block" v-if="erro.pouso != ''">
										{{ erro.pouso }}
									</p>
									<label
										v-show="form.pouso_utc != ''"
										style="position: absolute"
										>UTC: {{ form.pouso_utc }}</label
									>
								</div>

								<div
									class="col-xs-6 form-group"
									:class="{'has-error': erro.corte != ''}"
								>
									<label>* {{ _traducao('global', 'corte') }}:</label>
									<flDateTime
										@v-model="(val) => setaCorte(val)"
										:value="form.corte"
										name="dtOrdemPouso"
										:lang="_getLangDp"
										time="HH:mm"
										:disabled="this.editar"
										:max-date="maxDate"
										:format="_formatDate"
									/>
									<p class="help-block" v-if="erro.corte != ''">
										{{ erro.corte }}
									</p>
									<label
										v-show="form.corte_utc != ''"
										style="position: absolute"
										>UTC: {{ form.corte_utc }}</label
									>
								</div>
							</div>
						</div>

						<!-- HORIMETRO MOTOR/CELULA -->
						<div class="col-xs-12 col-md-8">
							<div class="row">
								<div class="col-md-6">
									<flCabecalhoForm
										class="print-titulo-form-20"
										:texto="this.horasDeAcionamentoCorte"
									/>

									<div class="row">
										<!-- HORIMETRO CELULA INICIAL/FINAL -->
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': erro.horimetro_inicial != ''}"
										>
											<label>{{ _traducao('global', 'inicial') }}:</label>
											<money
												type="text"
												v-model="form.horimetro_inicial"
												disabled="disabled"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
											<p class="help-block" v-if="erro.horimetro_inicial != ''">
												{{ erro.horimetro_inicial }}
											</p>
										</div>

										<div class="col-xs-12 col-md-6 form-group">
											<label>{{ _traducao('global', 'final') }}:</label>
											<money
												type="text"
												v-model="form.horimetro_final"
												disabled="disabled"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
											<p class="help-block" v-if="erro.horimetro_final != ''">
												{{ erro.horimetro_final }}
											</p>
										</div>
									</div>
								</div>

								<div class="col-md-6">
									<flCabecalhoForm
										class="print-titulo-form-20"
										:texto="_traducao('global', 'horasDecolagemPouso')"
									/>

									<div class="row">
										<!-- HORIMETRO MOTOR INICIAL/FINAL -->
										<div class="col-xs-12 col-md-6 form-group">
											<label>{{ _traducao('global', 'inicial') }}:</label>
											<money
												type="text"
												v-model="form.horimetro_inicial_manutencao"
												disabled="disabled"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
											<p
												class="help-block"
												v-if="erro.horimetro_inicial_manutencao != ''"
											>
												{{ erro.horimetro_inicial_manutencao }}
											</p>
										</div>

										<div class="col-xs-12 col-md-6 form-group">
											<label>{{ _traducao('global', 'final') }}:</label>
											<money
												type="text"
												v-model="form.horimetro_final_manutencao"
												disabled="disabled"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
											<p
												class="help-block"
												v-if="erro.horimetro_final_manutencao != ''"
											>
												{{ erro.horimetro_final_manutencao }}
											</p>
											<span class="text-info" v-if="form.alteradoPeloMecanico">
												<i class="fa fa-fw fa-info-circle"></i
												>{{ _traducao('global', 'editadoMecanico') }}</span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xs-12 text-primary" style="margin-top: 5px">
							<i class="fa fa-info-circle"></i>
							{{ _traducao('global', 'preenchimentoMotorHorario') }}
						</div>
					</div>

					<!-- TEMPO DE VOO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'tempoDeVoo')"
						/>

						<div class="row">
							<!-- TEMPO VOO PILOTO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.tempo_voo_piloto != ''}"
							>
								<label>{{ labelTempoAcionamentoCorte }}:</label>
								<flDateTime
									v-model="tempoVooPiloto"
									:value="tempoVooPiloto"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
									disabled
								/>
								<p class="help-block" v-if="erro.tempo_voo_piloto != ''">
									{{ erro.tempo_voo_piloto }}
								</p>
								<label v-show="form.tempo_voo_piloto != ''"
									>{{ _traducao('global', 'tempo') }}:
									{{ form.tempo_voo_piloto }}</label
								>
							</div>

							<!-- TEMPO VOO MANUTENÇÃO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.tempo_voo_motor != ''}"
							>
								<label>{{ _traducao('global', 'totalDecolagemPouso') }}:</label>
								<flDateTime
									v-model="tempoVooMotor"
									:value="tempoVooMotor"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
									disabled
								/>
								<p class="help-block" v-if="erro.tempo_voo_motor != ''">
									{{ erro.tempo_voo_motor }}
								</p>
								<label v-show="form.tempo_voo_motor != ''"
									>{{ _traducao('global', 'tempo') }}:
									{{ form.tempo_voo_motor }}</label
								>
							</div>

							<!-- VFR DIURNO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.vfr_diurno != ''}"
							>
								<label>{{ _traducao('global', 'diurno') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_vfr_diurno = val
											validaTempoDeVoo('D')
										}
									"
									:value="form.hora_vfr_diurno"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.vfr_diurno != ''">
									{{ erro.vfr_diurno }}
								</p>
								<label v-show="form.vfr_diurno != ''"
									>{{ _traducao('global', 'decimo') }}:
									{{ form.vfr_diurno }}</label
								>
							</div>

							<!-- VFR  NOTURNO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.vfr_noturno != ''}"
							>
								<label>{{ _traducao('global', 'noturno') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_vfr_noturno = val
											validaTempoDeVoo('N')
										}
									"
									:value="form.hora_vfr_noturno"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.vfr_noturno != ''">
									{{ erro.vfr_noturno }}
								</p>
								<label v-show="form.vfr_noturno != ''"
									>{{ _traducao('global', 'decimo') }}:
									{{ form.vfr_noturno }}</label
								>
							</div>

							<!-- IFR -->
							<div
								v-if="validaVfr == false"
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.ifr != ''}"
							>
								<label>IFR:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_ifr = val
											validaTempoDeVoo('IFR')
										}
									"
									:value="form.hora_ifr"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.ifr != ''">{{ erro.ifr }}</p>
								<label v-show="form.ifr != ''"
									>{{ _traducao('global', 'decimo') }}: {{ form.ifr }}</label
								>
							</div>

							<!-- IFR -->
							<div
								v-if="validaVfr == true"
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.ifr != ''}"
							>
								<label>IFR Real:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_ifr = val
											validaTempoDeVoo('IFR')
										}
									"
									:value="form.hora_ifr"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.ifr != ''">{{ erro.ifr }}</p>
								<label v-show="form.ifr != ''"
									>{{ _traducao('global', 'decimo') }}: {{ form.ifr }}</label
								>
							</div>

							<div
								v-if="validaVfr == true"
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.vfr != ''}"
							>
								<label>VFR:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_vfr = val
											validaTempoDeVoo('VFR')
										}
									"
									:value="form.hora_vfr"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.vfr != ''">{{ erro.vfr }}</p>
								<label v-show="form.vfr != ''"
									>{{ _traducao('global', 'decimo') }}: {{ form.vfr }}</label
								>
							</div>

							<div v-if="validaVfr == false">
								<!-- NAVEGACAO -->
								<div
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': erro.navegacao != ''}"
								>
									<label>{{ _traducao('global', 'navegacao') }}:</label>
									<flDateTime
										@v-model="
											(val) => {
												form.hora_navegacao = val
												validaTempoDeVoo('NA')
											}
										"
										:value="form.hora_navegacao"
										name="dtOrdemInicio"
										:lang="_getLangDp"
										:format="'HH:mm'"
									/>
									<!-- <money type="text" v-model="form.navegacao" v-bind="_vpercem(1)" class="input-sm form-control"></money> -->
									<label v-show="form.navegacao != ''"
										>{{ _traducao('global', 'decimo') }}:
										{{ form.navegacao }}</label
									>
									<p class="help-block" v-if="erro.navegacao != ''">
										{{ erro.navegacao }}
									</p>
								</div>
							</div>
						</div>

						<div class="row">
							<div
								class="col-xs-4 col-md-2 form-group"
								:class="{'has-error': erro.ifr_simulado != ''}"
							>
								<label>{{ _traducao('global', 'ifrSimulado') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_ifr_simulado = val
											validaTempoDeVoo('IFRS')
										}
									"
									:value="form.hora_ifr_simulado"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<label v-show="form.ifr_simulado != ''">
									{{ _traducao('global', 'decimo') }}
									{{ form.ifr_simulado }}
								</label>
								<p class="help-block" v-if="erro.ifr_simulado != ''">
									{{ erro.ifr_simulado }}
								</p>
							</div>

							<div
								v-if="validaVfr == true"
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.navegacao != ''}"
							>
								<label>{{ _traducao('global', 'navegacao') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_navegacao = val
											validaTempoDeVoo('NA')
										}
									"
									:value="form.hora_navegacao"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<!-- <money type="text" v-model="form.navegacao" v-bind="_vpercem(1)" class="input-sm form-control"></money> -->
								<label v-show="form.navegacao != ''"
									>{{ _traducao('global', 'decimo') }}:
									{{ form.navegacao }}</label
								>
								<p class="help-block" v-if="erro.navegacao != ''">
									{{ erro.navegacao }}
								</p>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12 text-primary">
								<i class="fa fa-info-circle"></i>
								{{ _traducao('global', 'preenchimentoPeriodo') }}
							</div>
						</div>
					</div>

					<!-- DADOS DE MONITORAMENTO -->
					<div v-if="mostraDadosMotor">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'dadosDeMonitoramento')"
						/>

						<div
							class="row"
							v-for="dadosMonitoramento in form.monitoramento_motor"
							:key="dadosMonitoramento.id"
						>
							<div class="col-sm-12">
								<h4>{{ dadosMonitoramento.descricao }}</h4>
								<hr />
							</div>

							<div class="col-xs-6 col-md-2 col-lg-4 coldcolform-group">
								<label>{{ _traducao('global', 'altitude') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.altitude"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-4 form-group">
								<label>OAT (ºC):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.oat"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-4 form-group">
								<label>IAS:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.ias"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>{{ _traducao('global', 'numberMotor') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									disabled
									v-model="dadosMonitoramento.serial_number"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>Np (RPM):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.rpm"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>Ng/NH (%):</label>
								<money
									type="text"
									v-bind="_vpercem(1)"
									class="input-sm form-control"
									v-model="dadosMonitoramento.ng"
								></money>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>NL:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.nl"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>Fuel Flow:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.fuel_flow"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>ITT/TB (ºC):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.itt"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>TQ (ft-lbs):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.tq"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>{{ _traducao('global', 'abastecimentoOleo') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.abastecimento_oleo"
								/>
							</div>
						</div>
					</div>

					<!-- VERIFICAÇÃO DO VOR -->
					<div v-if="mostraVor">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'verificacaoDoVor')"
						/>

						<div class="row">
							<div class="col-xs-6 col-md-2 col-lg-12 form-group">
								<label>{{ _traducao('global', 'verificacaoDoVor') }}?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="form.verificacao_vor = '1'"
										:class="{
											'btn-info': form.verificacao_vor == '1'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="form.verificacao_vor = '0'"
										:class="{
											'btn-info': form.verificacao_vor == '0'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<div v-if="form.verificacao_vor == '1'">
									<div class="row" style="margin-top: 10px">
										<div class="col-xs-6 col-md-2 form-group">
											<label>VOR:</label>
											<input
												v-model="form.vor"
												class="input-sm form-control"
												type="text"
												maxlength="3"
											/>
										</div>
										<div class="col-xs-6 col-md-2 form-group">
											<label>{{ _traducao('global', 'radial') }}:</label>
											<input
												v-model="form.radial_vor"
												class="input-sm form-control"
												type="number"
												step="10"
												min="0"
												max="360"
											/>
										</div>
										<div class="col-xs-6 col-md-2 form-group">
											<label
												>{{ _traducao('global', 'afastamentoVor') }}:</label
											>
											<input
												v-model="form.afastamento_vor"
												class="input-sm form-control"
												type="number"
												step="10"
											/>
										</div>
										<div class="col-xs-6 col-md-2 form-group">
											<label>{{ _traducao('global', 'erroVor') }}:</label>
											<input
												v-model="form.erro_vor"
												class="input-sm form-control"
												type="number"
												step="10"
												min="0"
												max="360"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- DADOS DO VOO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'dadosDoVoo')"
						/>

						<div class="row">
							<!-- COMBUSTIVEL -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.combustivel != ''}"
							>
								<label>* {{ _traducao('global', 'combustivel') }}:</label>
								<money
									type="text"
									v-model="form.combustivel"
									v-bind="_vpercem(0)"
									class="input-sm form-control"
								></money>
								<p class="help-block" v-if="erro.combustivel != ''">
									{{ erro.combustivel }}
								</p>
							</div>

							<!-- UNIDADE -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.unidade_combustivel != ''}"
							>
								<label>* {{ _traducao('global', 'relacao') }}:</label>
								<select
									class="form-control input-sm"
									v-model="form.unidade_combustivel"
								>
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option value="%">%</option>
									<option value="Litros">
										{{ _traducao('global', 'litros') }}
									</option>
									<option value="Libras">
										{{ _traducao('global', 'libras') }}
									</option>
									<option value="Galão">
										{{ _traducao('global', 'galao') }}
									</option>
									<option value="Kg">Kg</option>
								</select>
								<p class="help-block" v-if="erro.unidade_combustivel != ''">
									{{ erro.unidade_combustivel }}
								</p>
							</div>

							<!-- PARTIDAS -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.partidas != ''}"
								v-show="habilitaPartida"
							>
								<label>{{ _traducao('global', 'partidas') }}:</label>
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									:disabled="form.nome_mecanico_assinou != ''"
									@click.prevent="form.partidas += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									class="pass-btn-menos-btn btn-link text-center"
									:disabled="
										form.partidas == 0 || form.nome_mecanico_assinou != ''
									"
									@click.prevent="form.partidas -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.partidas"
									:style="
										form.nome_mecanico_assinou == ''
											? 'cursor:default;background:#FFF;'
											: ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
								<p class="help-block" v-if="erro.partidas != ''">
									{{ erro.partidas }}
								</p>
							</div>

							<!-- POUSOS -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.pousos != ''}"
							>
								<label>{{ _traducao('global', 'pousos') }}:</label>
								<button
									type="button"
									:disabled="form.nome_mecanico_assinou != ''"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pousos += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="
										form.pousos == 0 || form.nome_mecanico_assinou != ''
									"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pousos -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pousos"
									:style="
										form.nome_mecanico_assinou == ''
											? 'cursor:default;background:#FFF;'
											: ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
								<p class="help-block" v-if="erro.pousos != ''">
									{{ erro.pousos }}
								</p>
							</div>

							<!-- GUINCHO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_guincho == '1'"
							>
								<label>{{ _traducao('global', 'guincho') }}:</label>
								<br />
								<button
									type="button"
									:disabled="form.nome_mecanico_assinou != ''"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.guincho += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="
										form.guincho == 0 || form.nome_mecanico_assinou != ''
									"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.guincho -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.guincho"
									:style="
										form.nome_mecanico_assinou == ''
											? 'cursor:default;background:#FFF;'
											: ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- GANCHO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_gancho == '1'"
							>
								<label>{{ _traducao('global', 'gancho') }}:</label>
								<br />
								<button
									type="button"
									:disabled="form.nome_mecanico_assinou != ''"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.gancho += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="
										form.gancho == 0 || form.nome_mecanico_assinou != ''
									"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.gancho -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.gancho"
									:style="
										form.nome_mecanico_assinou == ''
											? 'cursor:default;background:#FFF;'
											: ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<div class="row">
							<!-- PAX  -->
							<div v-if="!Boolean(Number(disablePaxPob))">
								<div
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': erro.pax != ''}"
								>
									<label>PAX:</label>
									<input
										type="number"
										:disabled="disablePaxPob"
										v-model.lazy="form.pax"
										class="form-control input-sm"
										@change="
											form.pob = form.tripulacao.length + Math.abs(form.pax)
										"
									/>
									<p class="help-block" v-if="erro.pax != ''">{{ erro.pax }}</p>
								</div>
								<!-- POB -->
								<div class="col-xs-6 col-md-2 form-group">
									<label>POB:</label>
									<input
										type="number"
										disabled
										v-model="form.pob"
										class="form-control input-sm"
									/>
								</div>
							</div>
							<div v-else>
								<div
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': erro.pax != ''}"
								>
									<label>PAX:</label>
									<input
										type="number"
										disabled
										:value="form.passageiro.length"
										class="form-control input-sm"
									/>
									<p class="help-block" v-if="erro.pax != ''">{{ erro.pax }}</p>
								</div>
								<!-- POB -->
								<div class="col-xs-6 col-md-2 form-group">
									<label>POB:</label>
									<input
										type="number"
										disabled
										:value="form.passageiro.length + form.tripulacao.length"
										class="form-control input-sm"
									/>
								</div>
							</div>

							<div class="col-xs-6 col-md-2 form-group">
								<label>
									Milhas de Navegação:
									<i
										class="fa fa-info-circle"
										v-tooltip="
											'Considera-se como voo de navegação os realizados fora de um raio de 27 NM (50 km) do aeródromo de partida. Tratando-se de voo de navegação, conforme anteriormente definido, deve-se preencher esse campo com a distância (em milhas náuticas) percorrida entre os aeródromos de origem e destino. No caso de sobrevoo ou toque e arremetida (TGL) em aeródromo intermediário, deve-se especificá-lo no campo \“Observações\”.'
										"
									></i>
								</label>
								<!-- <input
									disabled
									v-model="form.milhas_navegacao"
									class="form-control input-sm"
								/> -->
								<money
									v-model="form.milhas_navegacao"
									v-bind="_vpercem(1)"
									class="form-control text-right input-sm"
								></money>
							</div>

							<!-- flir -->
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_flir == '1'"
								:class="{'has-error': erro.flir != ''}"
							>
								<label>* {{ _traducao('global', 'usoDe') }} FLIR:</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.flir = '1'
											erro.flir = ''
										"
										:class="{'btn-info': form.flir == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.flir = '0'
											erro.flir = ''
										"
										:class="{'btn-info': form.flir == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.flir != ''">{{ erro.flir }}</p>
							</div>
							<!-- OVN
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_onv == '1'"
								:class="{'has-error': erro.ovn != ''}"
							>
								<label>* {{ _traducao('global', 'usoDe') }} OVN:</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.ovn = '1'
											erro.ovn = ''
										"
										:class="{'btn-info': form.ovn == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.ovn = '0'
											erro.ovn = ''
										"
										:class="{'btn-info': form.ovn == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.ovn != ''">{{ erro.ovn }}</p>
							</div>-->
						</div>

						<div v-if="aeronave.ciclo_total == '1'">
							<flCabecalhoForm
								v-if="form.trecho_motor.length != 0"
								class="print-titulo-form-20"
								:texto="form.trecho_motor.length > 1 ? 'Motores' : 'Motor'"
							/>

							<!-- NUMERO DO VOO -->
							<div class="row" v-if="aeronave.numero_voo == '1'">
								<div
									class="col-xs-12 col-md-2 form-group"
									:class="{'has-error': erro.numero_voo != ''}"
								>
									<label>* {{ _traducao('global', 'numeroDeVoo') }}:</label>
									<input
										type="number"
										v-model="form.numero_voo"
										class="form-control input-sm"
									/>
									<p class="help-block" v-if="erro.numero_voo != ''">
										{{ erro.numero_voo }}
									</p>
								</div>
							</div>

							<div
								class="row"
								v-for="trechoMotor in form.trecho_motor"
								:key="'6' + trechoMotor.id"
							>
								<!-- SERIAL -->
								<div class="col-xs-6 col-md-2 form-group">
									<label>Serial Number:</label>
									<input
										type="text"
										disabled="disabled"
										v-model="trechoMotor.serial_number"
										class="form-control input-sm"
									/>
								</div>

								<!-- CICLO NG -->
								<div
									v-if="trechoMotor.tipo_aeronave == '2'"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_ng != ''}"
								>
									<label>* {{ _traducao('conversao', 'ciclo') }} N1:</label>
									<money
										type="text"
										v-model="trechoMotor.ciclo_ng"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_ng != ''">
										{{ trechoMotor.erro_ciclo_ng }}
									</p>
								</div>
								<!-- CICLO NF -->
								<div
									v-if="trechoMotor.tipo_aeronave == '2'"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_nf != ''}"
								>
									<label>* {{ _traducao('conversao', 'ciclo') }} N2:</label>
									<money
										type="text"
										v-model="trechoMotor.ciclo_nf"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_nf != ''">
										{{ trechoMotor.erro_ciclo_nf }}
									</p>
								</div>
								<!-- CICLO NP -->
								<div
									v-if="trechoMotor.tipo_aeronave == '2' && exibeNp == true"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_np != ''}"
								>
									<label>* {{ _traducao('conversao', 'ciclo') }} NP:</label>
									<money
										type="text"
										v-model="trechoMotor.ciclo_np"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_np != ''">
										{{ trechoMotor.erro_ciclo_np }}
									</p>
								</div>

								<div
									class="col-xs-6 col-md-2 form-group"
								>
									<label>{{ _traducao('global', 'horasMotor') }}:
									<i
										class="fa fa-info-circle"
										v-tooltip="_traducao('global', 'horasMotorInformativo')"
									>
									</i>
									</label>
									<input
										:value="trechoMotor.total_horimetro ? trechoMotor.total_horimetro : 'N/A'"
										type="decimal"
										class="form-control text-right input-sm"
										disabled
									/>
								</div>

								<div
									v-if="trechoMotor.tipo_aeronave == '1'"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_nf != ''}"
								>
									<label
										>* {{ _traducao('menuManutencao', 'menuMasaFixa') }}:</label
									>
									<money
										type="text"
										v-model="trechoMotor.ciclo_nf"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_nf != ''">
										{{ trechoMotor.erro_ciclo_nf }}
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- DADOS DO VOO -->
					<div>
						<div class="row print-titulo-form-20">
							<div class="col-md-12 col-xs-12 color" style="font-size: 14px">
								<button
									type="button"
									class="btn no-print btn-xs btn-danger pull-right"
									v-show="exibirRemover()"
									@click="limpardb()"
								>
									Remover
								</button>
								<p style="margin-top: 0px">Dados Abastecimento</p>
								<hr
									class="border-color"
									style="margin-top: 2px; margin-bottom: 10px"
								/>
							</div>
						</div>
						<!-- <flCabecalhoForm
							class="print-titulo-form-20"
							:texto="'Dados Abastecimento'"
						/> -->

						<div class="row">
							<!-- COMBISTIVEL -->
							<input-text
								class="col-xs-12 col-sm-3 form-group"
								:label="_traducao('global', 'numeroDeCE')"
								v-model="form.numero_ce"
								@blur="verificaCe()"
							/>
							<input-decimal
								class="col-xs-12 col-sm-3 form-group"
								:label="_traducao('global', 'volume')"
								v-model="form.volume"
							/>
							<div v-if="!movimentacaoCombustivel.exibeOrigem">
								<input-select
									class="col-xs-12 col-sm-3 form-group"
									:label="_traducao('global', 'unidadeDeArmazenamentoDeOrigem')"
									:opcoes-objeto="unidadesArmazenamento"
									v-model="form.id_unidade_armazenamento"
								/>
							</div>
							<div v-if="movimentacaoCombustivel.exibeOrigem">
								<input-text
									class="col-xs-12 col-sm-3 form-group"
									:label="_traducao('global', 'fornecedor')"
									v-model="movimentacaoCombustivel.origem"
									:disabled="movimentacaoCombustivel.exibeOrigem"
								/>
							</div>
						</div>
					</div>

					<!-- ÓLEO LUBRIFICANTE -->
					<div v-if="habilitaOleoLubrificante == true">
						<div class="row print-titulo-form-20">
							<div class="col-md-12 col-xs-12 color" style="font-size: 14px">
								<p>{{ _traducao('global', 'oleoLubrificante') }}</p>
								<hr
									class="border-color"
									style="margin-top: 2px; margin-bottom: 10px"
								/>
							</div>
						</div>

						<div class="form-group">
							<label>{{ _traducao('global', 'adicaoOleoLubrificante') }}</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									class="btn btn-default btn-sm"
									:class="{'btn-info': form.adicao_oleo_lubrificante == '1'}"
									@click="form.adicao_oleo_lubrificante = '1'"
									v-model="form.adicao_oleo_lubrificante"
								>
									{{ _traducao('global', 'sim') }}
								</button>
								<button
									type="button"
									class="btn btn-default btn-sm"
									:class="{'btn-info': form.adicao_oleo_lubrificante == '0'}"
									@click="form.adicao_oleo_lubrificante = '0'"
									v-model="form.adicao_oleo_lubrificante"
								>
									{{ _traducao('global', 'nao') }}
								</button>
							</div>
						</div>

						<div v-if="form.adicao_oleo_lubrificante == true">
							<div class="row">
								<div class="col-sm-2 form-group">
									<label>{{ _traducao('global', 'fornecedor') }}:</label>
									<select
										class="form-control"
										v-model="form.fornecedor_oleo_lubrificante"
									>
										<option
											v-for="fornecedor in fornecedores"
											:value="fornecedor.id"
										>
											{{ fornecedor.razao_social }}
										</option>
									</select>
								</div>
								<div class="col-sm-2 form-group">
									<label>{{ _traducao('global', 'numeroDaCE') }}:</label>
									<input
										class="form-control"
										type="text"
										v-model="form.numero_ce_oleo_lubrificante"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_1 != null &&
										dadosOleoLubrificante.campo_lubrificacao_1 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_1 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_1"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_2 != null &&
										dadosOleoLubrificante.campo_lubrificacao_2 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_2 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_2"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_3 != null &&
										dadosOleoLubrificante.campo_lubrificacao_3 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_3 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_3"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_4 != null &&
										dadosOleoLubrificante.campo_lubrificacao_4 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_4 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_4"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_5 != null &&
										dadosOleoLubrificante.campo_lubrificacao_5 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_5 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_5"
									/>
								</div>
							</div>

							<div class="row">
								<div class="col-sm-12 form-group">
									<label>{{ _traducao('global', 'observacoes') }}:</label>
									<textarea
										class="form-control input-sm"
										type="text"
										rows="2"
										v-model="form.observacoes_oleo_lubrificante"
									>
									</textarea>
								</div>
							</div>
							<div
								class="text-info"
								v-if="edicao_mecanico_oleo_lubrificante == '1'"
							>
								<p>
									<i
										class="fa fa-info-circle"
										v-tooltip="
											`${_traducao('global', 'dadosOleoEdicaoMecanico')}`
										"
									>
									</i>
									{{ _traducao('global', 'editadoMecanico') }}
								</p>
							</div>
						</div>
					</div>

					<!-- Performance Motor -->
					<div v-if="form.quantidadeMotores != 0">
						<div v-if="habilitaPerformanceMotor == true">
							<div>
								<flCabecalhoForm
									class="print-titulo-form-20"
									:texto="'Performance Motor'"
								/>
							</div>

							<div class="row">
								<div class="col-md-4 form-group">
									<div class="row">
										<!-- PERFORMANCE MOTOR -->
										<div class="col-xs-6 col-md-6 form-group">
											<label>{{ _traducao('global', 'horario') }}:</label>
											<flDateTime
												@v-model="
													(val) => (form.horario_performance_motor = val)
												"
												:value="form.horario_performance_motor"
												name="dtPerformance"
												:lang="_getLangDp"
												time="HH:mm"
												:format="_formatDate"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>FL:</label>
											<money
												type="text"
												v-model="form.performance_fl"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
								</div>
								<div class="col-md-4 form-group">
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>TAT:</label>
											<money
												type="text"
												v-model="form.performance_tat"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>IAS:</label>
											<money
												type="text"
												v-model="form.performance_ias"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
								</div>
								<div class="col-md-4 form-group">
									<div class="col-xs-6 col-md-6 form-group">
										<label>TAS:</label>
										<money
											type="text"
											v-model="form.performance_tas"
											v-bind="_vpercem(2)"
											class="input-sm form-control"
										></money>
									</div>

									<div class="col-xs-6 col-md-6 form-group">
										<label>*Usou o boost? </label>
										<div
											class="btn-group no-print print-button-group"
											role="group"
											style="display: block"
										>
											<div class="btn-group print-button-group" role="group">
												<flSimNao
													v-model="form.performance_boost"
													:disabled="solicitacao_aprovada"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-4 form-group">
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<input-text
												:label="'Motor Esquerdo'"
												v-model="sn_motor_esquerdo"
												v-if="form.quantidadeMotores == 2"
												:disabled="true"
											/>
											<input-text
												:label="'Motor'"
												v-model="sn_motor_esquerdo"
												v-if="form.quantidadeMotores == 1"
												:disabled="true"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group"></div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>Torque:</label>
											<money
												type="text"
												v-model="form.performance_torque_esq"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NP:</label>
											<money
												type="text"
												v-model="form.performance_np_esq"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>ITT:</label>
											<money
												type="text"
												v-model="form.performance_itt_esq"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NH/N1:</label>
											<money
												type="text"
												v-model="form.performance_nh_esq"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>F/Flow:</label>
											<money
												type="text"
												v-model="form.performance_flow_esq"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NL:</label>
											<money
												type="text"
												v-model="form.performance_nl_esq"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
								</div>

								<div
									v-if="form.quantidadeMotores == 2"
									style="border-left: 1px solid #2196f3"
									class="col-md-4 form-group"
								>
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<input-text
												:label="'Motor Direito'"
												v-model="sn_motor_direito"
												:disabled="true"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group"></div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>Torque:</label>
											<money
												type="text"
												v-model="form.performance_torque_dir"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NP:</label>
											<money
												type="text"
												v-model="form.performance_np_dir"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>ITT:</label>
											<money
												type="text"
												v-model="form.performance_itt_dir"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NH/N1:</label>
											<money
												type="text"
												v-model="form.performance_nh_dir"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>F/Flow:</label>
											<money
												type="text"
												v-model="form.performance_flow_dir"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NL:</label>
											<money
												type="text"
												v-model="form.performance_nl_dir"
												v-bind="_vpercem(2)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- TRIPULAÇÃO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'tripulacao')"
						/>

						<div class="row">
							<div
								class="col-lg-3 col-md-4 col-xs-12"
								v-for="(item, index) in form.tripulacao"
								:key="index"
							>
								<div
									class="trecho-borda"
									style="margin-bottom: 10px; min-height: 280px"
								>
									<div class="row no-print">
										<div class="col-xs-12">
											<div
												style="
													margin-top: 0px;
													margin-bottom: 0px;
													font-size: 16px;
												"
											>
												<div v-if="index == 0">
													<span v-show="form.voo_instrucao == '0'">{{
														_traducao('global', 'pilotoComando').toUpperCase()
													}}</span>
													<span v-show="form.voo_instrucao == '1'">{{
														_traducao(
															'global',
															'pilotoEmInstrucao'
														).toUpperCase()
													}}</span>
													<div class="dropup" style="float: right">
														<a
															href="#"
															id="dropdownMenu1"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="true"
														>
															<i class="fa fa-fw fa-refresh"></i>
														</a>
														<ul
															class="dropdown-menu"
															aria-labelledby="dropdownMenu1"
														>
															<li :class="{active: form.voo_instrucao == '0'}">
																<a
																	@click.prevent="
																		trocarPiloto(
																			'0',
																			'piloto em comando',
																			index,
																			false,
																			false
																		)
																	"
																	href="#"
																	>{{
																		_traducao(
																			'global',
																			'pilotoComando'
																		).toUpperCase()
																	}}</a
																>
															</li>
															<li :class="{active: form.voo_instrucao == '1'}">
																<a
																	@click.prevent="
																		trocarPiloto(
																			'1',
																			'piloto em instrução',
																			index,
																			false,
																			false
																		)
																	"
																	href="#"
																	>{{
																		_traducao(
																			'global',
																			'pilotoEmInstrucao'
																		).toUpperCase()
																	}}</a
																>
															</li>
														</ul>
													</div>
												</div>
												<div v-else>
													<span> {{ item.funcao.toUpperCase() }} </span>
												</div>
												<br />
												<a
													href="#"
													class="pull-right"
													v-if="index >= 1"
													@click.prevent="
														form.tripulacao.splice(index, 1)
														form.pob--
													"
													style="color: red; font-size: 14px; margin-top: 2px"
												>
													<i class="fa fa-fw fa-trash-o"></i
													>{{ _traducao('global', 'remover') }}
												</a>

												<p
													class="pull-right"
													v-if="index == 0"
													style="
														color: #f9f9f9;
														font-size: 14px;
														margin-top: 2px;
														margin-bottom: 0px;
													"
												>
													<span>{{
														_traducao('global', 'piloto').toUpperCase()
													}}</span>
												</p>
											</div>
										</div>

										<div v-if="item.funcao == ''">
											<div
												class="col-xs-12 form-group"
												:class="{'has-error': item.erroFuncao != ''}"
												style="margin-top: 70px; margin-bottom: 97px"
											>
												<label>
													<span class="no-print">*</span>
													{{
														_traducao('global', 'escolhaAFuncaoTripulante')
													}}:</label
												>
												<select
													class="form-control input-sm"
													v-model="item.funcao"
													@change="
														carregaUsuariosTripulacao(
															item.funcao,
															index,
															true,
															false
														)
													"
												>
													<option value="">
														{{ _traducao('global', 'escolha').toUpperCase() }}
													</option>
													<option
														v-for="funcao of listaDeFuncoes"
														:key="'8' + funcao.id"
														:value="funcao.descricao"
													>
														{{ funcao.nome }}
													</option>
												</select>
												<p class="help-block" v-show="item.erroFuncao != ''">
													{{ item.erroFuncao }}
												</p>
											</div>
										</div>

										<div v-if="item.funcao != ''">
											<!-- nome -->
											<div
												class="col-xs-12 form-group"
												:class="{'has-error': item.erroUsuario != ''}"
											>
												<label
													><span class="no-print" v-show="index != 1">*</span>
													{{ _traducao('global', 'nome') }}:</label
												>
												<template v-if="utilizaTrigrama">
													<select
														v-if="_isMobile"
														v-model="item.trigrama"
														@blur="
															carregaANACTrigrama(
																item.usuarios,
																item.trigrama,
																index
															)
														"
														class="form-control input-sm"
													>
														<option
															v-for="item in item.usuarios"
															:key="item.id + 'usuario'"
															:value="item.trigrama"
														>
															{{ item.trigrama }} - {{ item.nome }}
														</option>
													</select>
													<flSelect
														:list="item.usuarios"
														v-if="!_isMobile"
														v-show="!item.load"
														:value="
															item.trigrama == ''
																? ''
																: item.trigrama + ' - ' + item.nome
														"
														@v-model="
															(t) =>
																carregaANACTrigrama(item.usuarios, t, index)
														"
														:return="'trigrama'"
														:label="'descricao'"
													/>
												</template>
												<template v-else>
													<select
														v-model="item.id_usuario"
														@blur="
															carregaANAC(item.usuarios, item.id_usuario, index)
														"
														class="form-control input-sm"
													>
														<option
															v-for="item in item.usuarios"
															:key="'10' + item.id"
															:value="item.id"
														>
															{{ item.nome }}
														</option>
													</select>
												</template>

												<flCarregando v-show="item.load" />
												<p class="help-block" v-show="item.erroUsuario != ''">
													{{ item.erroUsuario }}
												</p>
											</div>

											<!-- anac -->
											<div class="col-xs-12 form-group">
												<label>ANAC:</label>
												<input
													type="text"
													v-model="item.anac"
													disabled="disabled"
													class="form-control input-sm"
												/>
											</div>

											<!-- base -->
											<div class="col-xs-12 form-group">
												<label>Base:</label>
												<input
													type="text"
													v-model="item.base_contratual"
													disabled="disabled"
													class="form-control input-sm"
												/>
											</div>

											<!-- apresentacao -->
											<div
												class="col-xs-12 form-group"
												:class="{'has-error': item.erroApresentacao != ''}"
											>
												<label
													>* {{ _traducao('global', 'apresentacao') }}:</label
												>
												<a
													href="#"
													class="pull-right"
													v-if="index > 0"
													@click.prevent="
														item.apresentacao = form.tripulacao[0].apresentacao
													"
												>
													{{ _traducao('global', 'copiar') }}
												</a>
												<div>
													<flDateTime
														@v-model="(val) => (item.apresentacao = val)"
														:value="item.apresentacao"
														name="dtOrdemInicio"
														:lang="_getLangDp"
														time="HH:mm"
														:format="_formatDate"
													/>
												</div>
												<p
													class="help-block"
													v-if="item.erroApresentacao != ''"
												>
													{{ item.erroApresentacao }}
												</p>
											</div>

											<div
												v-if="
													aeronave.habilita_ovn && aeronave.habilita_ovn != '0'
												"
												class="row col-xs-12"
											>
												<div
													class="col-xs-5 form-group"
													:class="{'has-error': item.erroUsoOvn != ''}"
												>
													<label
														><span class="no-print"> *</span>
														{{ _traducao('global', 'usoDeOvn') }}:</label
													>
													<br />
													<div
														class="btn-group print-button-group"
														role="group"
													>
														<button
															type="button"
															@click="selectOvnTrue(item)"
															:class="{'btn-info': item.uso_ovn}"
															class="btn btn-default btn-sm"
														>
															{{ _traducao('global', 'sim') }}
														</button>
														<button
															type="button"
															@click="
																selectOvnFalse(item)
																item.tempoOvn = 0
																item.id_ovn = null
																item.erroTempoOvn = ''
																item.erroDataCadastro = ''
																item.erroIdOvn = ''
															"
															:class="{'btn-info': !item.uso_ovn}"
															class="btn btn-default btn-sm"
														>
															{{ _traducao('global', 'nao') }}
														</button>
													</div>
													<p class="help-block" v-if="item.erroUsoOvn != ''">
														{{ item.erroUsoOvn }}
													</p>
												</div>
												<div
													v-if="item.uso_ovn == true"
													class="col-xs-7 form-group"
													:class="{'has-error': item.erroIdOvn != ''}"
												>
													<label
														><span class="no-print"> *</span>
														{{ _traducao('global', 'sn') }}:</label
													>
													<div
														:class="{
															'has-error':
																item.erroDataCadastro &&
																item.erroDataCadastro != ''
														}"
													>
														<select
															v-model="item.id_ovn"
															class="form-control input-sm"
														>
															<option value="">
																{{
																	_traducao('global', 'escolha').toUpperCase()
																}}
															</option>
															<option
																v-for="item in ovns"
																:key="item.sn"
																:value="item.id"
															>
																{{ item.sn }}
															</option>
														</select>
														<p
															class="help-block"
															v-if="
																item.erroDataCadastro &&
																item.erroDataCadastro != ''
															"
														>
															{{ item.erroDataCadastro }}
														</p>
														<p class="help-block" v-if="item.erroIdOvn != ''">
															{{ item.erroIdOvn }}
														</p>
													</div>
												</div>
												<div
													v-if="item.uso_ovn == true"
													class="col-xs-7 form-group"
													:class="{
														'has-error':
															item.erroTempoOvn && item.erroTempoOvn != ''
													}"
												>
													<label>* {{ _traducao('global', 'tempoUso') }}</label>
													<money
														type="text"
														v-model="item.tempoOvn"
														v-bind="_vpercem(1)"
														class="input-sm form-control"
													></money>
													<p
														class="help-block"
														v-if="item.erroTempoOvn && item.erroTempoOvn != ''"
													>
														{{ item.erroTempoOvn }}
													</p>
												</div>
											</div>

											<!-- OVN -->
											<!--<div
												class="col-xs-12 form-group"
												v-show="form.ovn == '1' && aeronave.tipo == 'H'"
												:class="{'has-error': item.erroOVN != ''}"
											>
												<label>{{ _traducao('global', 'codigo') }} OVN:</label>
												<input
													type="text"
													v-model="item.codigo_ovn"
													class="form-control input-sm"
												/>
												<p class="help-block" v-show="item.erroOVN != ''">
													{{ item.erroOVN }}
												</p>
											</div>-->

											<div
												class="col-xs-12 form-group"
												:class="{'has-error': erro.instrutor_voo != ''}"
											>
												<p
													class="help-block"
													v-if="erro.instrutor_voo != '' && index == 0"
												>
													{{ erro.instrutor_voo }}
												</p>
											</div>
										</div>
									</div>

									<div class="row" v-if="index == 0 && !_isMobile">
										<div
											class="inveter-tripulacao"
											v-tooltip="'Inverter Tripulação'"
											@click="inveterPilotoCopiloto()"
										>
											<span style="font-size: 11px; text-center">
												<i class="fa fa-arrow-right"></i><br />
												<i class="fa fa-arrow-left"></i>
											</span>
										</div>
									</div>
								</div>
								<div
									class="row"
									v-if="index == 0 && _isMobile"
									style="margin-bottom: 10px"
								>
									<div class="col-xs-12 text-center">
										<a
											href="#"
											class="btn btn-link"
											@click.prevent="inveterPilotoCopiloto()"
										>
											<span style="font-size: 11px">
												<i class="fa fa-arrow-down"></i>
												<i class="fa fa-arrow-up"></i>
											</span>
											INVETER DADOS DO PILOTO E COPILOTO
										</a>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-md-4 col-xs-12">
								<div
									class="trecho-borda text-center add"
									@click="clickAddTripulante()"
									style="
										margin-bottom: 10px;
										min-height: 280px;
										cursor: pointer;
										display: flex;
										align-items: center;
										justify-content: center;
									"
								>
									<h3>
										{{ _traducao('global', 'adicionar').toUpperCase() }} <br />
										{{ _traducao('global', 'tripulacao').toUpperCase() }}
										<BR />
										<i class="fa fa-fw fa-plus"></i>
									</h3>
								</div>
							</div>
							<div class="col-xs-12 text-primary" style="margin-top: 5px">
								<i class="fa fa-info-circle"></i>
								{{ _traducao('global', 'oPrimeiroAssina') }}
							</div>
						</div>
					</div>

					<!-- PASSAGEIROS -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="
								labelPassageiro == 1
									? _traducao('global', 'passageiros')
									: _traducao('global', 'passageiros') +
									  '/' +
									  _traducao('global', 'vitimas')
							"
						/>

						<div class="dropdown">
							<a
								style="
									margin-bottom: 5px;
									cursor: pointer;
									position: absolute;
									top: -40px;
									left: 80px;
								"
								v-show="form.passageiro.length > 0"
								title="Imprimir Passageiro"
								class="dropdown dropdown-toggle"
								type="button"
								id="dropdownMenuButton"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<i
									class="icon-imprimir"
									style="font-size: 18px; color: #2196f3"
									aria-hidden="true"
								></i>
							</a>
							<div
								class="dropdown-menu pull-right"
								aria-labelledby="dropdownMenuButton"
								style="
									position: absolute;
									left: 80px;
									top: -20px;
									background: rgba(999, 999, 999, 1);
									border: none;
									width: 80px !important;
									box-shadow: none;
									margin-right: 14%;
									padding: 10px;
									border: 1px solid #ccc;
								"
							>
								<a
									href="#"
									@click.prevent="
										clickPrintPassageiro(form, 'imprimir_passageiro', form.id)
									"
									style="display: block"
								>
									<i
										class="fa fa-print"
										style="color: #2196f3; font-size: 12px"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'simples') }}
								</a>
								<a
									href="#"
									@click.prevent="
										clickPrintPassageiro(
											form,
											'imprimir_passageiro_completo',
											form.id
										)
									"
									style="display: block"
								>
									<i
										class="fa fa-print"
										style="color: #2196f3; font-size: 12px"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'completo') }}
								</a>
							</div>
						</div>
						<div class="row">
							<div
								class="col-lg-3 col-md-4 col-xs-12"
								v-for="(item, index) in form.passageiro"
								:key="index"
							>
								<!-- PASSAGEIRO -->
								<div
									class="trecho-borda"
									style="margin-bottom: 10px; min-height: 230px"
									v-if="item.tipo == 'P'"
								>
									<div class="row">
										<div class="col-xs-12">
											<label style="color: #1976d2" v-if="labelPassageiro == 1">
												{{ _traducao('global', 'passageiro').toUpperCase() }}
											</label>
											<label style="color: #1976d2" v-else
												>{{
													_traducao('global', 'passageiro').toUpperCase()
												}}/{{
													_traducao('global', 'vitima').toUpperCase()
												}}</label
											>
											<a
												href="#"
												class="pull-right"
												@click.prevent="
													form.passageiro.splice(index, 1)
													removePass(index, 1)
												"
												style="color: red; font-size: 14px; margin-top: 2px"
											>
												<i class="fa fa-fw fa-trash-o"></i
												>{{ _traducao('global', 'remover') }}
											</a>
										</div>
									</div>

									<div class="row no-print">
										<!-- nome -->
										<div
											class="col-xs-12 form-group"
											:class="{'has-error': item.nomeErro}"
										>
											<label
												><span class="no-print">*</span>
												{{ _traducao('global', 'nome') }}:</label
											>
											<div class="input-group" style="display: flex">
												<vue-select
													ref="scrollPassageiros"
													class="form-control input-sm"
													label="nome"
													:filterable="false"
													@input="(val) => carregarPassageiro(val, index)"
													:value="item"
													:options="listaFiltrada"
													@open="onOpen()"
													@close="onClose()"
													@search="(query) => buscaServeSide(query)"
													style="max-height: 100px"
												>
													<template #list-footer>
														<li
															ref="loadPassageiro"
															class="loader"
															v-show="hasNextPage"
														>
															{{
																_traducao('global', 'carregandoMaisOpcoes')
															}}...
														</li>
													</template>
													<template #no-options>
														<li @click.prevent="">
															{{ _traducao('global', 'semPassageiros') }}
														</li>
													</template>
												</vue-select>
												<button
													type="button"
													class="btn btn-sm btn-info input-group-append"
													style="margin-left: 5px"
													@click="abrirCadastroPassageiro(index)"
												>
													<i class="fa fa-plus fa-fw"></i>
												</button>
												<p class="help-block" v-show="item.nomeErro">
													{{ item.nomeErro }}
												</p>
											</div>
										</div>
									</div>
									<div class="row">
										<!-- orgao -->
										<div
											class="col-xs-6 form-group"
											:class="{'has-error': item.orgaoErro}"
											v-if="enableOrgao"
										>
											<label>
												<span class="no-print">*</span>
												{{ centrodeCusto }}:</label
											>
											<input
												type="text"
												v-model="item.orgao"
												class="form-control input-sm"
											/>
											<p class="help-block" v-show="item.orgaoErro">
												{{ item.orgaoErro }}
											</p>
										</div>

										<!-- cargo -->
										<div
											class="col-xs-6 form-group"
											:class="{'has-error': item.cargoErro}"
											v-if="enableCargo"
										>
											<label>
												<span class="no-print">*</span>
												{{
													_traducao('menuSolicitaApoio', 'menuCargo')
												}}:</label
											>
											<input
												type="text"
												v-model="item.cargo"
												class="form-control input-sm"
											/>
											<p class="help-block" v-show="item.cargoErro">
												{{ item.cargoErro }}
											</p>
										</div>
									</div>
									<div class="row">
										<!-- CPF -->
										<div
											class="col-xs-6 form-group"
											:class="{'has-error': item.cpfErro}"
										>
											{{ passCpfObrigatorio ? '*' : '' }}
											<label
												>{{
													_traducao('menuAGnovoUsuario', 'menuAGcpf')
												}}:</label
											>
											<input
												type="text"
												v-model="item.cpf"
												v-mask="_vdocumento"
												class="form-control input-sm"
											/>
											<p class="help-block" v-show="item.cpfErro">
												{{ item.cpfErro }}
											</p>
										</div>

										<!-- telefone -->
										<div
											class="col-xs-6 form-group"
											:class="{'has-error': item.telefoneErro}"
										>
											<label>{{ _traducao('global', 'telefone') }}:</label>
											<input
												type="text"
												v-model="item.telefone"
												v-mask="_vtelefone"
												class="form-control input-sm"
											/>
											<p class="help-block" v-show="item.telefoneErro">
												{{ item.telefoneErro }}
											</p>
										</div>
									</div>
								</div>

								<!-- VITIMA -->
								<div
									class="trecho-borda"
									style="margin-bottom: 10px; min-height: 230px"
									v-if="item.tipo == 'V'"
								>
									<div class="row">
										<div class="col-xs-12">
											<label style="color: #1976d2">{{
												_traducao('global', 'vitima').toUpperCase()
											}}</label>

											<a
												href="#"
												class="pull-right"
												@click.prevent="form.passageiro.splice(index, 1)"
												style="color: red; font-size: 14px; margin-top: 2px"
											>
												<i class="fa fa-fw fa-trash-o"></i
												>{{ _traducao('global', 'remover') }}
											</a>
										</div>
									</div>
									<div class="row">
										<!-- nome -->
										<div class="col-xs-9 form-group">
											<label>{{ _traducao('global', 'nome') }}:</label>
											<input
												type="text"
												v-model="item.nome"
												class="form-control input-sm"
											/>
										</div>

										<!-- SEXO -->
										<div
											class="col-xs-3 form-group"
											style="padding-left: 0"
											:class="{'has-error': item.sexoErro}"
										>
											<label
												><span class="no-print">*</span>
												{{
													_traducao('menuAGcadAluno', 'menuAGalunoSexo')
												}}:</label
											><br />
											<div
												class="btn-group"
												role="group btn-block"
												style="width: 100%"
											>
												<button
													type="button"
													@click="item.sexo = 'F'"
													style="width: 50%; margin-top: 0px"
													class="btn btn-sm btn-block btn-default"
													:class="{'btn-success': item.sexo == 'F'}"
												>
													F
												</button>
												<button
													type="button"
													@click="item.sexo = 'M'"
													style="width: 50%; margin-top: 0px"
													class="btn btn-sm btn-block btn-default"
													:class="{'btn-success': item.sexo == 'M'}"
												>
													M
												</button>
											</div>
											<p class="help-block" v-show="item.sexoErro">
												{{ item.sexoErro }}
											</p>
										</div>
									</div>

									<div class="row">
										<!-- DATA DE NASCIMENTO -->
										<div class="col-xs-6 form-group">
											<label
												>{{ _traducao('global', 'dataNascimento') }}:</label
											>
											<flDateTime
												@v-model="
													(val) => {
														item.data_nascimento = val
														alteraIdade(val)
													}
												"
												:value="item.data_nascimento"
												name="dataNascimento"
												:lang="_getLangDp"
												:format="_formatDate"
											/>
										</div>
										<!-- IDADE APARENTE -->
										<div
											class="col-xs-6 form-group"
											:class="{'has-error': item.idadeErro}"
										>
											<label>
												<span class="no-print">*</span>
												{{ _traducao('global', 'idadeAparente') }}:</label
											>
											<input
												type="text"
												v-model="item.idade_aparente"
												class="form-control input-sm"
											/>
											<p class="help-block" v-show="item.idadeErro">
												{{ item.idadeErro }}
											</p>
										</div>
									</div>

									<div class="row">
										<!-- CPF -->
										<div class="col-xs-6 form-group">
											<label>{{ _traducao('menuMatricula', 'cpf') }}:</label>
											<input
												type="text"
												v-model="item.cpf"
												v-mask="_vdocumento"
												class="form-control input-sm"
											/>
										</div>

										<!-- TELEFONE -->
										<div class="col-xs-6 form-group">
											<label>{{ _traducao('global', 'telefone') }}:</label>
											<input
												type="text"
												v-mask="_vtelefone"
												v-model="item.telefone"
												class="form-control input-sm"
											/>
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-md-4 col-xs-12">
								<div
									class="trecho-borda text-center add"
									@click="clickAddPassageiro('P')"
									style="
										margin-bottom: 10px;
										min-height: 230px;
										cursor: pointer;
									"
								>
									<h3 style="margin-top: 60px" v-if="labelPassageiro == 1">
										{{ _traducao('global', 'adicionar').toUpperCase() }} <br />
										{{ _traducao('global', 'passageiro').toUpperCase() }}
										<BR />
										<i class="fa fa-fw fa-plus"></i>
									</h3>
									<h3 style="margin-top: 60px" v-else>
										{{ _traducao('global', 'adicionar').toUpperCase() }} <br />
										{{ _traducao('global', 'passageiro').toUpperCase() }}/{{
											_traducao('global', 'vitima').toUpperCase()
										}}
										<BR />
										<i class="fa fa-fw fa-plus"></i>
									</h3>
								</div>
							</div>
							<!-- <div class="col-lg-3 col-md-4 col-xs-12"> -->
							<!-- <div -->
							<!-- class="trecho-borda text-center add" -->
							<!-- @click="clickAddPassageiro('V')" -->
							<!-- style=" -->
							<!-- margin-bottom: 10px; -->
							<!-- min-height: 230px; -->
							<!-- cursor: pointer; -->
							<!-- " -->
							<!-- > -->
							<!-- <h3 style="margin-top: 60px"> -->
							<!-- {{ _traducao('global', 'adicionar').toUpperCase() }} <br /> -->
							<!-- {{ _traducao('global', 'vitima').toUpperCase() }} -->
							<!-- <BR /> -->
							<!-- <i class="fa fa-fw fa-plus"></i> -->
							<!-- </h3> -->
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>

					<!-- CARGA TRANSPORTADA -->
					<div>
						<!-- CARGA TRANSPORTADA -->
						<div>
							<flCargaTransportada
								ref="cargaTransportada"
								:form="form"
								:solicitacao_aprovada="false"
								:carga-array="form.cargaArray"
								:passageiros="form.passageiro"
								:possuiTrechos="false"
							/>
						</div>
					</div>

					<!-- DISCREPANCIAS -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'discrepanciasTecnicas')"
						/>
						<div
							class="row"
							v-for="(item, index) in form.discrepancia"
							:key="item.id + 'discrepancia'"
						>
							<!-- nome -->
							<div class="col-md-4 col-xs-12 form-group">
								<div class="row">
									<div
										class="col-xs-12 form-group"
										:class="{'has-error': item.erroUsuario != ''}"
									>
										<label
											><span class="no-print">*</span>
											{{ _traducao('global', 'nome') }}:</label
										>
										<a
										href="#"
										class="pull-right"
										v-if="item.id == 0"
										@click.prevent="form.discrepancia.splice(index, 1)"
										style="color: red; font-size: 14px; margin-top: 2px"
									>
										<i class="fa fa-fw fa-trash-o"></i
										>{{ _traducao('global', 'remover') }}
									</a>
										<template v-if="utilizaTrigrama">
											<select
												v-if="_isMobile"
												v-model="item.trigrama"
												@blur="
													getANAC(_pilotos_mecanicos, item.trigrama, index)
												"
												class="form-control input-sm"
											>
												<option
													v-for="p in _pilotos_mecanicos"
													:key="p.id + 'pmecanicos'"
													:value="p.trigrama"
												>
													{{ p.trigrama }} - {{ p.nome }}
												</option>
											</select>
											<v-select
												v-if="!_isMobile"
												:value="item.trigrama"
												@input="
													({trigrama}) =>
														getANAC(_pilotos_mecanicos, trigrama, index)
												"
												class="form-control input-sm"
												label="descricao"
												:options="_pilotos_mecanicos"
											></v-select>
										</template>
										<template v-else>
											<select
												v-model="item.id_usuario"
												@blur="
													getANAC(_pilotos_mecanicos, item.id_usuario, index)
												"
												class="form-control input-sm"
											>
												<option
													v-for="p in _pilotos_mecanicos"
													:key="p.id + 'pmech'"
													:value="p.id_usuario"
												>
													{{ p.nome }}
												</option>
											</select>
										</template>

										<p class="help-block" v-show="item.erroUsuario != ''">
											{{ item.erroUsuario }}
										</p>
									</div>

									<!-- anac -->
									<div class="col-xs-12 form-group">
										<label>ANAC:</label>
										<input
											type="text"
											class="form-control input-sm"
											v-model="item.anac"
											disabled="disabled"
										/>
									</div>

									<div class="col-xs-12 form-group">
										<label>ATA SPEC 100:</label>
										<v-select
											:options="listaAtas"
											label="descricao_completa"
											v-model="item.ata"
											class="form-control input-sm"
										></v-select>
									</div>
								</div>
							</div>

							<!-- descricao -->
							<div
								class="col-md-8 col-xs-12"
								:class="{'has-error': item.erroDescricao != ''}"
							>
								<label>* {{ _traducao('global', 'descricao') }}:</label>
								<textarea
									v-model="item.descricao"
									class="form-control input-sm"
									rows="13"
								></textarea>
								<p class="help-block" v-show="item.erroDescricao != ''">
									{{ item.erroDescricao }}
								</p>
							</div>

							<!-- acoes tomadas -->
							<div class="col-xs-12">
								<div
									v-if="item.acao_discrepancia.length > 0"
									style="
										border: 1px solid #ddd;
										padding: 8px;
										margin-top: 4px;
										margin-bottom: 8px;
									"
								>
									<!-- <hr style="margin-bottom:4px; margin-top:4px" /> -->
									<div class="row" v-if="item.acao_discrepancia.length > 0">
										<div class="col-xs-12 text-center">
											<strong>{{
												_traducao('global', 'acoesTomadas').toUpperCase()
											}}</strong>
										</div>
									</div>
									<hr style="margin-bottom: 4px; margin-top: 4px" />

									<div
										v-for="itAcao in item.acao_discrepancia"
										:key="itAcao.id + 'itacao'"
									>
										<div class="row">
											<div class="col-xs-2">
												<strong>{{ _traducao('global', 'acao') }}:</strong>
												<br />
												<span v-if="itAcao.tipo_acao == 'C'">{{
													_traducao('global', 'acaoCorretiva').toUpperCase()
												}}</span>
												<span v-if="itAcao.tipo_acao == 'P'">{{
													_traducao('global', 'acaoPreventiva').toUpperCase()
												}}</span>
												<span v-if="itAcao.tipo_acao == 'M'">{{
													_traducao('global', 'monitoramento').toUpperCase()
												}}</span>
												<span v-if="itAcao.tipo_acao == 'I'">{{
													_traducao(
														'global',
														'indisponibilizarAeronave'
													).toUpperCase()
												}}</span>
											</div>
											<div class="col-xs-3">
												<strong>Nome - ANAC:</strong> <br />
												{{ itAcao.nome }} - {{ itAcao.codigo_anac }}
											</div>
											<div class="col-xs-3">
												<strong>Data:</strong> <br />
												{{ itAcao.data_cadastro | dataTempo }}
											</div>
											<div class="col-xs-4">
												<strong>Descrição:</strong> <br />
												{{ itAcao.descricao_acao }}
											</div>
										</div>
									</div>

									<div v-if="item.data_conclusao">
										<hr style="margin-bottom: 4px; margin-top: 4px" />
										<div class="row">
											<div class="col-xs-12 text-center">
												<strong>{{
													_traducao('global', 'conclusao').toUpperCase()
												}}</strong>
											</div>
										</div>
										<hr style="margin-bottom: 4px; margin-top: 4px" />

										<div class="row">
											<div class="col-xs-2">
												<strong>{{ _traducao('global', 'data') }}:</strong
												><br />
												{{ item.data_conclusao | dataTempo }}
											</div>
											<div class="col-xs-3">
												<strong
													>{{ _traducao('global', 'nome') }} - ANAC:</strong
												>
												<br />
												{{ item.nome_usuario_conclusao }} -
												{{ item.anac_usuario_conclusao | na }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12" style="margin-top: 10px">
								<button
									class="btn btn-info btn-sm"
									type="button"
									@click="clickAddDiscrepancia()"
								>
									<i class="fa fa-fw fa-plus"></i
									>{{
										_traducao('global', 'adicionarDiscrepancia').toUpperCase()
									}}
								</button>
							</div>
						</div>
					</div>

					<!-- OCORRÊNCIAS -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'ocorrencias')"
						/>
						<div
							v-for="(item, index) in form.ocorrencias"
							:key="item.id + 'ocorrencias'"
						>
							<div class="row">
								<!-- data -->
								<div
									class="col-md-3 col-xm-12 form-group"
									:class="{'has-error': item.erro_data != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'data') }}:</label
									>
									<a
										href="#"
										class="pull-right"
										v-if="item.id == 0"
										@click.prevent="form.ocorrencias.splice(index, 1)"
										style="color: red; font-size: 14px; margin-top: 2px"
									>
										<i class="fa fa-fw fa-trash-o"></i
										>{{ _traducao('global', 'remover') }}
									</a>
									<flDateTime
										@v-model="(val) => (item.data = val)"
										:value="item.data"
										name="dtOrdemInicio"
										:lang="_getLangDp"
										time="HH:mm"
										:format="_formatDate"
									/>
									<!-- <input type="text" class="form-control input-sm" v-model="item.data"> -->
									<p class="help-block" v-show="item.erro_data != ''">
										{{ item.erro_data }}
									</p>
								</div>

								<!-- LOCAL -->
								<div
									class="col-md-9 col-xm-12 form-group"
									:class="{'has-error': item.erro_local != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'local') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="_traducao('global', 'tooltipLocalOcorrencia')"
										></i
									></label>
									<input
										type="text"
										class="form-control input-sm"
										v-model="item.local"
									/>
									<p class="help-block" v-show="item.erro_local != ''">
										{{ item.erro_local }}
									</p>
								</div>
							</div>
							<div class="row">
								<!-- CódiGo classificacao -->
								<div
									class="col-md-3 col-xm-12 form-group"
									:class="{'has-error': item.erro_codigo_classificacao != ''}"
								>
									<label
										><span class="no-print">*</span
										>{{ _traducao('global', 'codigoClassificacao') }}:</label
									>
									<select
										class="form-control input-sm"
										v-model="item.codigo_classificacao"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option value="HTSAN">
											HTSAN - {{ _traducao('global', 'saudeESanitarias') }}
										</option>
										<option value="AVSEC">
											AVSEC - {{ _traducao('global', 'segurancaRelativa') }}
										</option>
										<option value="PBSEC">
											PBSEC - {{ _traducao('global', 'segurancaPublica') }}
										</option>
										<option value="OTR">
											OTR - {{ _traducao('global', 'outrasClassificacao') }}
										</option>
									</select>
									<p
										class="help-block"
										v-show="item.erro_codigo_classificacao != ''"
									>
										{{ item.erro_codigo_classificacao }}
									</p>
								</div>

								<!-- Qualificação civil -->
								<div
									class="col-md-9 col-xm-12 form-group"
									:class="{'has-error': item.erro_qualificacao_civil != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'qualificacaoCivil') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="
												_traducao('global', 'tooltipQualificacaoCivil')
											"
										></i
									></label>
									<input
										type="text"
										class="form-control input-sm"
										v-model="item.qualificacao_civil"
									/>
									<p
										class="help-block"
										v-show="item.erro_qualificacao_civil != ''"
									>
										{{ item.erro_qualificacao_civil }}
									</p>
								</div>
							</div>

							<div class="row">
								<!-- DESCRIÇÃO DOS FATOS -->
								<div
									class="col-md-12 col-xm-12 form-group"
									:class="{'has-error': item.erro_descricao_fatos != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'descricaoDosFatos') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="_traducao('global', 'tooltipDescricaoFatos')"
										></i
									></label>
									<textarea
										type="text"
										class="form-control input-sm"
										v-model="item.descricao_fatos"
									></textarea>
									<p
										class="help-block"
										v-show="item.erro_descricao_fatos != ''"
									>
										{{ item.erro_descricao_fatos }}
									</p>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12" style="margin-top: 10px">
								<button
									class="btn btn-info btn-sm"
									type="button"
									@click="clickAddOcorrencia()"
								>
									<i class="fa fa-fw fa-plus"></i>
									{{ _traducao('global', 'adicionarOcorrencia').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>

					<!-- DADOS MISSAO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="dbComercial ? _traducao('global', 'dadosProgramacaoVoo') : _traducao('global', 'dadosDaMissao')"
						/>

						<div class="row">
							<div
								class="col-xs-12 col-md-2 form-group"
								:class="{'has-error': erro.base != ''}"
							>
								<label>* {{ _traducao('global', 'base') }}:</label>
								<select v-model="form.base" class="form-control input-sm">
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option
										v-for="item in bases"
										:key="item.descricao"
										:value="item.id"
									>
										{{ item.descricao }}
									</option>
								</select>
								<p class="help-block" v-if="erro.base">{{ erro.base }}</p>
							</div>

							<div
								class="col-xs-12 col-md-2 form-group"
								:class="{'has-error': erro.numero_chamada != ''}"
								v-if="exibeRedsSamu"
							>
								<label>{{ this.numeroOcorrenciaSamu }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									v-model="form.numero_chamada"
								/>
								<p class="help-block" v-if="erro.chamada != ''">
									{{ erro.numero_chamada }}
								</p>
							</div>

							<div
								class="col-xs-12 col-md-2 form-group"
								:class="{'has-error': erro.numero_bo != ''}"
								v-if="exibeRedsSamu"
							>
								<label
									><span v-if="this.form.ocorrencia193Obrigatoria">*</span>
									{{ this.numeroOcorrencia193 }}:</label
								>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="100"
									v-model="form.numero_bo"
								/>
								<p class="help-block" v-if="erro.numero_bo != ''">
									{{ erro.numero_bo }}
								</p>
							</div>

							<div
								v-if="exibeObjetivosMissao == '1'"
								class="col-xs-12 col-md-6 form-group"
								:class="{'has-error': erro.objetivo_alcancado != ''}"
							>
								<label
									>*
									{{ _traducao('global', 'objetivosMissaoAlcancados') }}</label
								>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.objetivo_alcancado = 'S'
											erro.objetivo_alcancado = ''
										"
										:class="{'btn-info': form.objetivo_alcancado == 'S'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.objetivo_alcancado = 'P'
											erro.objetivo_alcancado = ''
										"
										:class="{'btn-info': form.objetivo_alcancado == 'P'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'parcial') }}
									</button>
									<button
										type="button"
										@click="
											form.objetivo_alcancado = 'N'
											erro.objetivo_alcancado = ''
										"
										:class="{'btn-info': form.objetivo_alcancado == 'N'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.objetivo_alcancado">
									{{ erro.objetivo_alcancado }}
								</p>
							</div>
						</div>

						<hr />

						<!-- SE FOR PMSP -->
						<div class="row" v-if="_idCliente == 14">
							<!-- AUTO LOCALIZACAO -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Auto Localização:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.auto_localizado += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.auto_localizado == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.auto_localizado -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.auto_localizado"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- ARMAS APREENDIDAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Armas Apreendidas:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.arma_apreendida += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.arma_apreendida == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.arma_apreendida -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.arma_apreendida"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PESSOAS DETIDAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Pessoas Detidas:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pessoa_detida += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pessoa_detida == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pessoa_detida -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pessoa_detida"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PESSOAS SALVAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Pessoas Salvas:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pessoa_salva += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pessoa_salva == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pessoa_salva -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pessoa_salva"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- VALOR RECUPERADO -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Valor Recuperado:</label>
								<br />
								<money
									type="text"
									v-model="form.valor_recuperado"
									v-bind="_vpercem(2)"
									class="form-control text-right input-sm"
								></money>
							</div>

							<div class="col-xs-12">
								<hr />
							</div>
						</div>

						<!-- TIPO DE MISSAO E DESCRICAO -->
						<div class="row">
							<div
								v-if="!homologadoAnac"
								class="col-xs-12 col-md-4 form-group"
								:class="{'has-error': erro.tipo_natureza != ''}"
							>
								<label>* {{ _traducao('global', 'naturezaDoVoo') }}:</label>
								<v-select
									v-model="form.tipo_natureza"
									class="form-control input-sm"
									label="label"
									:options="tiposDeNaturezas"
								></v-select>

								<p class="help-block" v-if="erro.tipo_natureza != ''">
									{{ erro.tipo_natureza }}
								</p>
							</div>

							<div
								class="col-xs-12 col-md-4 form-group"
								:class="{'has-error': erro.tipo_missao != ''}"
							>
								<label
									>*
									{{
										!homologadoAnac
											? _traducao('global', 'tipoMissao')
											: labelTipoMissao
									}}:</label
								>
								<v-select
									v-model="form.tipo_missao"
									class="form-control input-sm"
									label="descricao"
									:options="__tiposDeMissoes"
								></v-select>

								<p class="help-block" v-if="erro.tipo_missao != ''">
									{{ erro.tipo_missao }}
								</p>
							</div>

							<div
								v-if="habilitaDescMissao"
								class="col-xs-12 col-md-4 form-group"
								:class="{'has-error': erro.descricao != ''}"
							>
								<label
									>*
									{{
										!homologadoAnac
											? _traducao('menuAGtipoMissao', 'menuAGdescMissao2')
											: labelDescMissao
									}}:</label
								>
								<v-select
									v-model="form.descricao"
									class="form-control input-sm"
									label="descricao"
									:options="descricoes"
								></v-select>
								<p class="help-block" v-if="erro.descricao != ''">
									{{ erro.descricao }}
								</p>
							</div>
						</div>

						<!-- TRANSPLANTE DE ORGÃOS E TECIDOS -->
						<div
							class="row"
							v-if="form.tipo_missao"
							v-show="
								form.tipo_missao.descricao ==
									'TRANSPORTE DE ÓRGÃOS E TECIDOS' ||
								form.tipo_missao.descricao == 'SAÚDE / SOCORRO'
							"
						>
							<!-- CORACAO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'coracao') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.coracao += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.coracao == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.coracao -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.coracao"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- RIM -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'rim') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.rim += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.rim == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.rim -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.rim"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- FIGADO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'figado') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.figado += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.figado == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.figado -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.figado"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- CORNEA -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'cornea') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.cornea += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.cornea == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.cornea -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.cornea"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- ESCLERO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'esclero') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.esclero += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.esclero == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.esclero -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.esclero"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PANCREAS -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'pancreas') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pancreas += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pancreas == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pancreas -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pancreas"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- BAÇO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'baco') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.baco += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.baco == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.baco -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.baco"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<!-- MEIO AMBIENTE, BUSCA E SALVAMENTO E COMBATE A INCÊNCIDO -->
						<div class="row">
							<!-- BASE ORIGEM -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
							>
								<label>{{ _traducao('global', 'baseDeOrigem') }}:</label>
								<br />
								<select
									v-model="form.base_origem"
									class="form-control input-sm"
								>
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option
										v-for="it in basesOperacao"
										:value="it.descricao"
										:key="it.descricao"
									>
										{{ it.descricao }}
									</option>
								</select>
							</div>

							<!-- BRIGADISTAS -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
							>
								<label>{{ _traducao('global', 'brigadistas') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.brigadista += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.brigadista == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.brigadista -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.brigadista"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
								:class="{'has-error': erro.existe_unidade_conservacao != ''}"
							>
								<label>* Unidade de Conservação?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.existe_unidade_conservacao = '1'
											erro.existe_unidade_conservacao = ''
										"
										:class="{
											'btn-info': form.existe_unidade_conservacao == '1'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.existe_unidade_conservacao = '0'
											erro.existe_unidade_conservacao = ''
										"
										:class="{
											'btn-info': form.existe_unidade_conservacao == '0'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p
									class="help-block"
									v-if="erro.existe_unidade_conservacao != ''"
								>
									{{ erro.existe_unidade_conservacao }}
								</p>
							</div>

							<!-- UNIDADE DE CONSERVAÇÃO -->
							<div
								class="col-xs-12 col-md-6 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
							>
								<div
									class="row"
									v-for="un in form.unidade_conservacao"
									:key="un.id"
								>
									<div
										v-if="form.existe_unidade_conservacao == '1'"
										class="col-xs-12 form-group"
										:class="{'has-error': un.erro != ''}"
									>
										<label
											>*
											{{ _traducao('global', 'unidadeDeConservacao') }}:</label
										>
										<a
											href="#"
											class="pull-right"
											@click.prevent="form.unidade_conservacao.splice(idxUn, 1)"
											v-if="idxUn > 0"
											style="color: red; font-size: 12px"
										>
											<i class="fa fa-fw fa-trash-o"></i
											>{{ _traducao('global', 'remover').toUpperCase() }}
										</a>

										<v-select
											v-model="un.obj"
											class="form-control input-sm"
											:options="unidadesConservacao"
											label="sigla"
										></v-select>

										<p class="help-block" v-if="un.erro != ''">{{ un.erro }}</p>
									</div>
								</div>

								<div class="row" v-if="form.existe_unidade_conservacao == '1'">
									<div class="col-xs-12" style="margin-top: 10px">
										<button
											class="btn btn-info btn-sm"
											type="button"
											@click="
												form.unidade_conservacao.push({obj: '', erro: ''})
											"
										>
											<i class="fa fa-fw fa-plus"></i>ADICIONAR UNIDADE
										</button>
									</div>
								</div>
							</div>

							<!-- BUSCA E SALVAMENTO -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'"
							>
								<label>{{ _traducao('global', 'socorridos') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.socorrido += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.socorrido == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.socorrido -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.socorrido"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<hr />

						<!-- CLASSIFICAÇÃO E SUBCLASSIFICAÇÃO -->
						<div v-if="_idCliente != 41 && exibeClassificacao">
							<div class="row">
								<div
									class="col-xs-12 col-md-12 form-group"
									:class="{'has-error': erro.subclassificacao != ''}"
								>
									<label
										>* {{ _traducao('global', 'classificacaoESub') }}:</label
									>
									<v-select
										v-model="form.subclassificacao"
										class="form-control input-sm"
										:options="subclassificacoes"
										label="_descricao"
									></v-select>
									<p class="help-block" v-if="erro.subclassificacao != ''">
										{{ erro.subclassificacao }}
									</p>
								</div>
							</div>
							<hr />
						</div>

						<!-- CONTEXTO OPERATIVO -->
						<div v-show="exibeContextoOperativo">
							<div class="row">
								<div
									class="col-xs-12 form-group"
									:class="{'has-error': erro.houve_contexto != ''}"
								>
									<label
										>* {{ _traducao('global', 'haContextoOperativo') }}</label
									>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.houve_contexto = '1'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '1'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.houve_contexto = '0'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '0'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.houve_contexto != ''">
										{{ erro.houve_contexto }}
									</p>
								</div>
							</div>
							<div class="row" v-if="form.houve_contexto == '1'">
								<div
									class="col-xs-12 col-md-6 form-group"
									:class="{'has-error': erro.contexto_operativo != ''}"
								>
									<label
										>* {{ _traducao('global', 'contextoOperativo') }}</label
									>
									<v-select
										v-model="form.contexto_operativo"
										class="form-control input-sm"
										:options="contextos"
										label="descricao"
									></v-select>
									<p class="help-block" v-if="erro.contexto_operativo != ''">
										{{ erro.contexto_operativo }}
									</p>
								</div>
							</div>
							<hr />
						</div>

						<!-- ORGÃOS APOIADOS E UNIDADES -->
						<div class="form-group">
							<label v-show="form.orgao.length == 0"
								>* {{ centrodeCusto }}:</label
							>
							<div v-for="(itOrgao, idxOrgao) in form.orgao" :key="itOrgao.id">
								<div class="row">
									<div
										class="col-xs-2 col-md-2 form-group"
										:class="{'has-error': itOrgao.erroTempoVoo != ''}"
										v-if="_idCliente == 14"
									>
										<label>* {{ _traducao('global', 'tempoDeVoo') }}:</label>
										<money
											type="text"
											v-model="itOrgao.tempo_voo"
											v-bind="_vpercem(2)"
											class="input-sm form-control"
										></money>
										<p class="help-block" v-if="itOrgao.erroTempoVoo != ''">
											{{ itOrgao.erroTempoVoo }}
										</p>
									</div>

									<!-- orgao -->
									<div
										class="col-xs-6 col-md-6 form-group"
										:class="{'has-error': itOrgao.erroOrgao != ''}"
									>
										<label>* {{ centrodeCusto }}:</label>
										<a
											href="#"
											class="pull-right btn-remover-orgao"
											@click.prevent="form.orgao.splice(idxOrgao, 1)"
											type="button"
										>
											<i class="fa fa-trash fa-fw"></i
											>{{ _traducao('global', 'remover') }}
										</a>

										<form>
											<div :class="idxOrgao == 0 ? 'input-group' : ''">
												<v-select
													v-model="form.orgao[idxOrgao].orgao"
													class="form-control"
													:options="orgaos"
													label="sigla"
												></v-select>
												<span class="input-group-btn" v-if="idxOrgao == 0">
													<button
														class="btn btn-info btn-sm btn-md"
														@click="abreModalOap"
													>
														<i class="fa fa-plus fa-fw"></i>
													</button>
												</span>
											</div>
										</form>

										<p class="help-block" v-if="itOrgao.erroOrgao != ''">
											{{ itOrgao.erroOrgao }}
										</p>
									</div>

									<!-- unidades -->
									<div
										class="col-xs-6 col-md-6 form-group"
										v-if="form.orgao[idxOrgao].orgao != ''"
									>
										<div v-if="form.orgao[idxOrgao].orgao.unidade.length > 0">
											<div
												class="form-group"
												:class="{'has-error': unid.erroUnidade != ''}"
												v-for="(unid, indexUnid) in form.orgao[idxOrgao]
													.unidade"
												:key="unid.id"
											>
												<label>{{ _traducao('global', 'unidade') }}:</label>
												<a
													href="#"
													class="pull-right btn-remover-orgao"
													@click.prevent="
														form.orgao[idxOrgao].unidade.splice(indexUnid, 1)
													"
													type="button"
												>
													<i class="fa fa-trash fa-fw"></i
													>{{ _traducao('global', 'remover') }}
												</a>
												<div :style="{'z-index': 1000 - indexUnid}">
													<v-select
														v-show="!loadUnidade"
														v-model="
															form.orgao[idxOrgao].unidade[indexUnid].unidade
														"
														class="form-control input-sm"
														:options="form.orgao[idxOrgao].orgao.unidade"
														label="descricao"
													></v-select>
												</div>
												<p class="help-block" v-if="unid.erroUnidade != ''">
													{{ unid.erroUnidade }}
												</p>
											</div>

											<div>
												<span v-if="form.orgao[idxOrgao].unidade.length == 0">
													<label style="color: #f9f9f9"
														>{{ _traducao('global', 'unidades') }}:</label
													>
													<br />
												</span>
												<button
													@click="
														form.orgao[idxOrgao].unidade.push({
															unidade: '',
															erroUnidade: ''
														})
													"
													class="btn btn-info btn-sm"
													type="button"
												>
													<i class="fa fa-plus fa-fw"></i
													>{{
														_traducao(
															'global',
															'adicionarUnidade'
														).toUpperCase()
													}}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" :class="{'has-error': erro.orgao}">
								<div class="col-xs-12">
									<button
										class="btn btn-info btn-sm"
										type="button"
										@click="clickAddOrgao"
									>
										<i class="fa fa-plus fa-fw"></i
										>{{ centrodeCusto.toUpperCase() }}
									</button>

									<p class="help-block" v-if="erro.orgao != ''">
										{{ erro.orgao }}
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- OBSERVACAO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'observacao')"
						/>

						<div class="row">
							<div class="col-xs-12">
								<textarea
									v-model="form.observacao"
									class="form-control input-sm"
									rows="5"
								></textarea>
							</div>
						</div>
					</div>

					<!-- LISTA SOLICITACAO DE EDICAO -->
					<div v-if="solicitacaoEdicao.length > 0 && !editar">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="'Solicitações de Edição'"
						/>
						<fl-lista-solicitacoes-db :lista="solicitacaoEdicao" />
					</div>

					<!-- BTN SALVAR -->
					<div
						class="row"
						v-if="editar"
						style="margin-top: 20px; margin-bottom: 30px"
					>
						<div class="col-xs-12 text-info form-group" v-if="assinar">
							<span v-if="!assinarESalvar">
								<i class="fa fa-fw fa-info-circle"></i>
								{{ _traducao('global', 'nenhumaAlteracao') }}.
							</span>
							<span v-if="assinarESalvar">
								<i class="fa fa-fw fa-info-circle"></i>
								{{ _traducao('global', 'todasAlteracoesSalvas') }}.
							</span>
						</div>
						<div class="col-md-3 col-xs-12 form-group">
							<button
								class="btn btn-block"
								:class="assinarESalvar ? 'btn-danger' : 'btn-primary'"
								v-if="assinar"
								@click="assinarESalvar = !assinarESalvar"
								type="button"
							>
								<span v-if="!assinarESalvar">
									<i class="fa fa-fw fa-pencil"></i>
									{{ _traducao('global', 'editarDiario').toUpperCase() }}
								</span>
								<span v-if="assinarESalvar">
									<i class="fa fa-fw fa-times"></i>
									{{ _traducao('global', 'cancelarDiario').toUpperCase() }}
								</span>
							</button>
						</div>
						<div class="col-md-5"></div>
						<div
							class="col-xs-12 col-md-4"
							:class="{
								'has-error':
									erro.diurnoNortuno != '' ||
									(erro.ifrVfr != '' && validaVfr == true)
							}"
						>
							<button
								class="btn btn-block btn-success pull-left"
								type="button"
								v-if="assinar"
								@click="clickExibeModalSalvar()"
								:disabled="validaDisabledSalvar"
							>
								<i class="fa fa-fw fa-check"></i>
								{{ _traducao('global', 'assinar').toUpperCase() }}
							</button>

							<button
								class="btn btn-block btn-success pull-right"
								type="button"
								v-if="!assinar"
								@click="clickExibeModalSalvar()"
								:disabled="validaDisabledSalvar"
							>
								<i class="fa fa-fw fa-check"></i>
								{{ _traducao('global', 'salvar').toUpperCase() }}
							</button>

							<!-- <button
								class="btn btn-block btn-success pull-right"
								type="button"
								v-show="assinarESalvar"
								@click="$refs.modalSalvarModificacoes.modalShow(50)"
							>
								<i class="fa fa-fw fa-check"></i>
								{{ _traducao('global', 'salvarAlteracoes').toUpperCase() }}
							</button> -->
							<p class="help-block" v-if="erro.diurnoNortuno != ''">
								{{ erro.diurnoNortuno }}
							</p>
						</div>
					</div>

					<div
						class="row"
						v-if="!editar && !preencher"
						style="margin-top: 20px; margin-bottom: 30px"
					>
						<div class="col-md-8">
							<p class="text-info">
								<i class="fa fa-fw fa-info-circle"></i>
								Após a assinatura do piloto, tem um prazo para edição de 15
								dias, esse prazo se encerrou, para editar, abra uma solicitação.
							</p>
						</div>
						<div
							class="col-xs-12 col-md-4"
							:class="{'has-error': erro.diurnoNortuno != ''}"
						>
							<button
								@click="clickSolicitarEdicao()"
								class="btn btn-block btn-info pull-right"
							>
								<i class="fa fa-fw fa-unlock"></i> SOLICITAR EDIÇÃO
							</button>
						</div>
					</div>

					<div
						v-if="!editar && preencher"
						style="margin-top: 20px; margin-bottom: 30px"
						:class="{
							'has-error': erro.diurnoNortuno != ''
						}"
					>
						<div class="row">
							<div class="col-md-8"></div>
							<div class="col-md-4 col-xs-12">
								<button
									class="btn btn-success btn-block pull-right"
									type="button"
									@click="clickExibeModalSalvar()"
									:disabled="validaDisabledSalvar"
								>
									<i class="fa fa-fw fa-check"></i
									>{{ _traducao('global', 'finalizar').toUpperCase() }}
								</button>
								<p class="help-block" v-if="erro.diurnoNortuno != ''">
									{{ erro.diurnoNortuno }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- PRINT DA SOLICITACAO -->
		<div class="print">
			<div class="col-xs-12">
				<flPrintDiario
					name="diario"
					ref="printDiario"
					:cabecalho="false"
					:voo="false"
				/>
			</div>
		</div>

		<div v-if="visualizar">
			<div class="container-fluid no-print">
				<!-- cabecalho -->
				<div class="fl-cabecalho" v-show="cabecalho">
					<div class="row">
						<div class="col-md-4 col-xs-12">
							<i class="icon icon-diario_bordo"></i>
							<h3>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h3>
							<h4>
								{{ _traducao('global', 'pilotoECopiloto').toUpperCase() }}
							</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<i class="icon icon-vizualizar icon-sub"></i>
							<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
							<h4>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<button
								@click="voltaLista()"
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'voltar')"
							>
								<i
									class="icon-left"
									style="font-size: 18px"
									aria-hidden="true"
								></i>
							</button>

							<button
								v-if="form.nome_arquivo == ''"
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'imprimir')"
								style="margin-right: 20px"
								@click="clickPrintVisualizar()"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</button>

							<a
								v-if="form.nome_arquivo != ''"
								:href="form.nome_arquivo"
								target="_blank"
								class="btn btn-default pull-right btn-lg"
								style="margin-right: 20px"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</a>
						</div>
					</div>
				</div>
			</div>

			<!-- exibe o html caso não tenha pdf ainda -->
			<div class="col-xs-12">
				<ul
					v-if="form.nome_arquivo != ''"
					class="nav nav-tabs no-print"
					style="margin-top: 10px"
					role="tablist"
				>
					<li :class="{active: tab == 'SISTEMA'}">
						<a href="#" @click.prevent="tab = 'SISTEMA'">{{
							_traducao('global', 'sistema').toUpperCase()
						}}</a>
					</li>
					<li :class="{active: tab == 'PDF'}">
						<a href="#" @click.prevent="tab = 'PDF'">PDF</a>
					</li>
				</ul>
				<!-- <a :href="form.nome_arquivo" download="iPhone User's Guide.PDF">click me</a> -->
				<flPrintDiario
					name="visualizar"
					:exibe-historico-visualizar="exibeHistoricoVisualizar"
					v-show="tab == 'SISTEMA'"
					ref="printVisualizar"
					:cabecalho="false"
					:voo="voo"
					:is-visualizar-diario-operador-ou-piloto="
						isVisualizarDiarioOperadorOuPiloto
					"
				/>

				<!-- exibe o pdf caso já tenha -->
				<embed
					type="application/pdf"
					:src="form.nome_arquivo"
					ref="pdfDocument"
					v-show="tab == 'PDF'"
					width="100%"
					:height="_height - 130"
				/>
			</div>
		</div>

		<!-- MODAL INCISOS RESOLUCAO 457, 457 -->
		<modal ref="modalDiario">
			<button
				type="button"
				class="close"
				@click="$refs.modalDiario.modalHide()"
			>
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title" v-if="tipoDBModal == 'I'">
				INCISOS XIII A XVII DO ART. 4º DA RESOLUÇÃO 457
			</h4>

			<h4 class="modal-title" v-if="tipoDBModal == 'C'">
				{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />
			<flPrintDiario
				name="diario"
				ref="diarioModal"
				:cabecalho="false"
				:voo="false"
			/>

			<div class="row text-center" v-if="tipoDBModal == 'I'">
				<div class="col-xs-12">
					<button
						class="btn btn-info"
						@click="clickExibeModalDiario('C', true)"
					>
						VER DIÁRIO DE BORDO COMPLETO
					</button>
				</div>
			</div>

			<div class="row text-center" v-if="tipoDBModal == 'C'">
				<div class="col-xs-12">
					<button
						class="btn btn-info"
						@click="clickExibeModalDiario('I', true)"
					>
						VER INCISOS XIII A XVII DO ART. 4º DA RESOLUÇÃO 457
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL COM A ESCOLA DA AERONAVE A SER SUBISTITIDA -->
		<modal ref="modalAero" @modal-fechou="() => carregaDadosAero()">
			<div style="min-height: 400px">
				<button
					type="button"
					class="close"
					@click="$refs.modalAero.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaAeronave').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-md-1 col-xs-12 text-info">
						<i
							class="fa fa-fw fa-info-circle fa-3x"
							style="margin-top: 18px"
						></i>
					</div>
					<div class="col-md-10 col-xs-12 form-group">
						<h4 class="text-info" style="line-height: 30px">
							{{ _traducao('global', 'naoEncontramosSuaAero') }}
						</h4>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th>{{ _traducao('cadAeronave', 'prefixo') }}</th>
										<th>{{ _traducao('cadAeronave', 'codinome') }}</th>
										<th>{{ _traducao('cadAeronave', 'tipo') }}</th>
										<th>{{ _traducao('cadAeronave', 'modelo') }}</th>
									</tr>
								</thead>
								<tbody v-if="aerosImport.length > 0">
									<tr
										style="cursor: pointer"
										class="table-hover-tr"
										@click="clickSetaAero(item)"
										v-for="item in aerosImport"
										:key="item.id"
									>
										<td>{{ item._aero.prefixo }}</td>
										<td>{{ item._aero.codinome }}</td>
										<td>{{ item._aero.modelo }}</td>
										<td>
											<span v-show="item._aero.tipo == 'A'">{{
												_traducao('cadAeronave', 'aviao')
											}}</span>
											<span v-show="item._aero.tipo == 'H'">{{
												_traducao('cadAeronave', 'helicoptero')
											}}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA ESCOLHER O PASSAGEIRO -->
		<modal name="modal-ordem-escolha-passageiros">
			<div>
				<button
					type="button"
					class="close"
					@click="_escondeModal('modal-ordem-escolha-passageiros')"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{
						_traducao('global', 'selecioneOsPassageirosTrecho').toUpperCase()
					}}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											PASSAGEIROS
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ _traducao('global', 'orgao') }}</th>
										<th>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
										<th>{{ _traducao('global', 'telefone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										class="table-hover-tr"
										style="cursor: pointer"
										@click="clickSelecionaPassageiro(index)"
										:class="{'bk-success': item.selecionado}"
										v-for="(item, index) in passageirosSelecao"
										:key="item.id"
									>
										<td>{{ item.nome | na }}</td>
										<td>{{ item.sigla_orgao | na }}</td>
										<td>{{ item.cargo | na }}</td>
										<td>{{ item.cpf | na }}</td>
										<td>
											{{ item.telefone | na
											}}<i
												v-if="item.selecionado"
												class="text-success pull-right fa fa-fw fa-check-circle"
											></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12">
						<button
							class="btn btn-success pull-right"
							@click="exibeOrgaoPassageiro()"
						>
							<i class="fa fa-fw fa-check"></i> OK
						</button>
					</div>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA ESCOLHER AS CARGAS -->
		<modal name="modal-ordem-escolha-cargas">
			<div>
				<button
					type="button"
					class="close"
					@click="_escondeModal('modal-ordem-escolha-cargas')"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{
						_traducao('global', 'selecioneAsCargasTransportadas').toUpperCase()
					}}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											CARGAS
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'tipo') }}</th>
										<th>{{ _traducao('global', 'descricao') }}</th>
										<th>{{ _traducao('global', 'peso') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										class="table-hover-tr"
										style="cursor: pointer"
										@click="clickSelecionaCarga(idx)"
										:class="{'bk-success': carga.selecionado}"
										v-for="(carga, idx) in cargas"
										:key="carga.id"
									>
										<td>{{ carga.descricao_tipo_carga | na }}</td>
										<td>{{ carga.descricao | na }}</td>
										<td>
											{{ carga.peso | na
											}}<i
												v-if="carga.selecionado"
												class="text-success pull-right fa fa-fw fa-check-circle"
											></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12">
						<button
							class="btn btn-success pull-right"
							@click="clickImportaCargas()"
						>
							<i class="fa fa-fw fa-check"></i> OK
						</button>
					</div>
				</div>
			</div>
		</modal>

		<flOrigemVoo
			ref="origemVoo"
			@selecionou-ordem="(data) => ordemSelecionada(data)"
			@selecionou-despacho="(data) => despachoSelecionado(data)"
		/>

		<!-- MODAL COM A VOLTA PRA LISTA -->
		<modal name="modal-ordem-tempo-expirado">
			<h4 class="modal-title">
				{{ _traducao('global', 'tempoDePreenchimento').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-12 text-center">
					<h3>
						{{ _traducao('global', 'desejaContinuarAPrrencher') }}
					</h3>
				</div>
			</div>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-6">
					<button
						class="btn pull-left btn-default"
						type="button"
						@click="voltaLista()"
					>
						<i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i
						>{{ _traducao('global', 'voltar') }}
					</button>
				</div>
				<div class="col-xs-6">
					<button
						class="btn pull-right btn-success"
						type="button"
						@click="clickContinuaPreenchendo()"
					>
						<i class="fa fa-fw fa-check"></i
						>{{ _traducao('global', 'continuar') }}
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA SALVAR MODIFICACOES -->
		<modal ref="modalSalvarModificacoes">
			<h4 class="modal-title">
				{{ _traducao('global', 'editarTrecho').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row">
				<h3 class="text-center">
					<i class="fa fa-fw fa-info-circle"></i>
					{{ _traducao('global', 'desejaAtualizarTrecho') }} <BR />
					<strong>{{ trecho.numero_diario }}</strong>
				</h3>
			</div>

			<div class="row" style="margin-top: 10px">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ label_acionamento.toUpperCase() }}</strong>
					</p>
					<p>{{ form.acionamento }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{
							_traducao('global', 'decolagem').toUpperCase()
						}}</strong>
					</p>
					<p>{{ form.decolagem }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'pouso').toUpperCase() }}</strong>
					</p>
					<p>{{ form.pouso }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'corteVoo').toUpperCase() }}</strong>
					</p>
					<p>{{ form.corte }}</p>
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-xs-12 text-center">
					<p class="text-info">
						<strong>{{
							_traducao('global', 'horimetro').toUpperCase()
						}}</strong>
					</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'inicial').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_inicial | horimetro }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'final').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_final | horimetro }}</p>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<button
						class="btn btn-success pull-right"
						type="button"
						@click="clickSalvar()"
					>
						<i class="fa fa-fw fa-check"></i>
						{{ _traducao('global', 'atualizar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA CONFIRMAR A SALVACAO -->
		<modal
			ref="modalConfirmacao"
			@modal-fechou="() => (assinarESalvar ? modalCarregaAssinatura() : '')"
		>
			<button
				type="button"
				class="close"
				@click="
					revisar = true
					$refs.modalConfirmacao.modalHide()
				"
			>
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title" v-if="!assinar && !editar">
				{{ _traducao('global', 'finalizarTracho').toUpperCase() }}
			</h4>
			<h4 class="modal-title" v-if="!assinar && editar">
				{{ _traducao('global', 'editarTrecho').toUpperCase() }}
			</h4>
			<h4 class="modal-title" v-if="assinar">
				{{ _traducao('global', 'assinarTrecho').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-12 text-center text-info">
					<h3 v-if="!assinar && !editar">
						<i class="fa fa-fw fa-info-circle"></i>
						{{ _traducao('global', 'desejaFinalizarTrecho') }}<BR />
						<strong>{{ trecho.numero_diario }}</strong>
					</h3>
					<h3 v-if="!assinar && editar">
						<i class="fa fa-fw fa-info-circle"></i>
						{{ _traducao('global', 'desejaAtualizarTrecho') }} <BR />
						<strong>{{ trecho.numero_diario }}</strong>
					</h3>
					<h3 v-if="assinar">
						<i class="fa fa-fw fa-info-circle"></i>
						{{ _traducao('global', 'desejaAssinarEsseTrecho') }}?<BR />
						<strong>{{ trecho.numero_diario }}</strong>
					</h3>
				</div>
			</div>

			<div class="row" style="margin-top: 10px">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ label_acionamento.toUpperCase() }}</strong>
					</p>
					<p>{{ form.acionamento }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{
							_traducao('global', 'decolagem').toUpperCase()
						}}</strong>
					</p>
					<p>{{ form.decolagem }}</p>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'pouso').toUpperCase() }}</strong>
					</p>
					<p>{{ form.pouso }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'corteVoo').toUpperCase() }}</strong>
					</p>
					<p>{{ form.corte }}</p>
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-xs-12 text-center">
					<p class="text-info">
						<strong>{{
							_traducao('global', 'horas').toUpperCase()
						}}</strong>
					</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'inicial').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_inicial | horimetro }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'final').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_final | horimetro }}</p>
				</div>
			</div>

			<hr />

			<div class="row" v-if="editar && form.id_assinatura_piloto != ''">
				<div class="col-xs-12 text-center">
					<h3 class="text-danger">
						<i class="fa fa-fw fa-warning">{{
							_traducao('global', 'seraNecessarioAssinatura')
						}}</i
						>.
					</h3>
				</div>
			</div>

			<div class="row" v-if="assinar">
				<div class="col-xs-12">
					<div class="checkbox pull-right">
						<label style="line-height: 20px">
							<input type="checkbox" v-model="cienteAssinatura" />
							{{ _traducao('global', 'estouCienteQuanto').toUpperCase()
							}} <a
								href="#"
								@click.prevent="clickExibeModalDiario('I', false)"
								>{{ _traducao('global', 'incisoss').toUpperCase() }}</a
							>
							{{ _traducao('global', 'doArtigo').toUpperCase() }}.
						</label>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<button
						class="btn btn-default"
						type="button"
						@click="
							revisar = true
							$refs.modalConfirmacao.modalHide()
						"
					>
						{{ _traducao('global', 'revisar').toUpperCase() }}
					</button>

					<button
						v-if="!editar && !assinar"
						class="btn btn-success pull-right"
						type="button"
						@click="clickSalvar()"
					>
						<i class="fa fa-fw fa-check"></i
						>{{ _traducao('global', 'finalizar').toUpperCase() }}
					</button>

					<button
						v-if="editar && !assinar"
						class="btn btn-success pull-right"
						type="button"
						@click="clickSalvar()"
					>
						<i class="fa fa-fw fa-check"></i
						>{{ _traducao('global', 'atualizar').toUpperCase() }}
					</button>

					<button
						v-if="assinar"
						:disabled="!cienteAssinatura"
						class="btn btn-success pull-right"
						type="button"
						@click="modalCarregaAssinatura()"
					>
						<i class="fa fa-fw fa-check"></i
						>{{ _traducao('global', 'assinarEFinalizar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>

		<flModalAssinatura
			ref="assinatura"
			@assinado="(assinatura) => validaAssinatura(assinatura)"
		/>

		<flModalSolicitacaoEdicao
			ref="modalSolicitacaoEdicao"
			@solicitacao-salva="solicitacaoSalva"
		/>

		<fl-modal-motivo-assinatura ref="modalMotivoAssinatura" />

		<!-- MODAL DE ORGÃOS APOIADOS -->
		<modal ref="orgaosApoiadosModal">
			<div :key="atualizaModal">
				<button
					type="button"
					class="close"
					@click="$refs.orgaosApoiadosModal.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>

				<flOrgaosApoiados :eh-modal="true" />
			</div>
		</modal>
		<!-- MODAL DE PASSAGEIROS -->
		<modal ref="formCadastroPassageiro">
			<div class="row">
				<div class="col-xs-12">
					<h4>
						{{ _traducao('global', 'cadastroPassageiros').toUpperCase() }}
						<button
							type="button"
							class="close"
							@click="$refs.formCadastroPassageiro.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
				</div>
				<flFormCadastroPassageiro
					ref="componenteCadastroPassageiro"
					:is-not-modal="false"
					@passageiro-salvo="carregarPassageiroRecemSalvo"
				/>
			</div>
		</modal>
		<movimentacoes-combustivel
			ref="movimentacoesCombustivel"
			@selecionou-movimentacao="(data) => movimentacaoSelecionado(data)"
		/>
	</div>
</template>

<script>
import $click from './mixins/click.js'
import $carrega from './mixins/carrega.js'
import $tabela from '../../../../../mixins/tabela.js'
import flPrintDiario from '../print/main.vue'
import flOrigemVoo from './origem-voo.vue'
import flModalSolicitacaoEdicao from '../../components/solicitacao-edicao/modal-solicitacao.vue'
import flListaSolicitacoesDb from '../../components/solicitacao-edicao/lista-solicitacoes-db.vue'
import flModalMotivoAssinatura from '../../components/solicitacao-edicao/modal-motivo-assinatura.vue'
import flCabecalhoDbPiloto from './components/cabecalho-db-piloto.vue'
import flInformacoesAeronave from './components/informacoes-aeronave.vue'
import flInformacoesManutencao from './components/informacoes-manutencao.vue'
import flInformacoesCiclosTotais from './components/informacoes-ciclos-totais.vue'
import flDateTime from '@/modules/components/datetime/main.vue'
import flFormCadastroPassageiro from '@/modules/layout/admin-geral/cadastro-passageiros/form/main.vue'
import movimentacoesCombustivel from './components/informacoes-movimentacoes-combustivel.vue'

export default {
	mixins: [$click, $carrega, $tabela],

	components: {
		flFormCadastroPassageiro,
		flPrintDiario,
		flOrigemVoo,
		flModalSolicitacaoEdicao,
		flListaSolicitacoesDb,
		flModalMotivoAssinatura,
		flCabecalhoDbPiloto,
		flInformacoesAeronave,
		flInformacoesManutencao,
		flInformacoesCiclosTotais,
		flDateTime,
		movimentacoesCombustivel
	},

	props: {
		exibeHistoricoVisualizar: {
			type: Boolean,
			default: false,
			required: false
		},

		visualizar: {
			type: Boolean,
			default: false,
			required: false
		},

		cabecalho: {
			type: Boolean,
			default: true,
			required: false
		},

		voo: {
			type: Boolean,
			default: true,
			required: false
		},

		isVisualizarDiarioOperadorOuPiloto: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data() {
		return {
			flagComponenteCarga: $cliente.get('componente_carga_solicitacao'),
			exibeFinalizarOrdemMissao: '',
			labelTempoAcionamentoCorte: '',
			exibeNp: false,
			habilitaPartida: false,
			ovns: [],
			edicao_mecanico_oleo_lubrificante: '',
			label_acionamento: 'acionamento',

			indexCadastro: 0,
			centrodeCusto: '',
			atualizaModal: 0,
			atualizaDb: 0,
			orgaos: [],
			cargas: [],
			listaFuncoesPassageiros: [],

			listaPassageiros: [],
			observer: null,
			limit: 5,
			search: '',
			timeBusca: null,

			tab: 'SISTEMA',
			maxDate: '',
			validaVfr: '',

			exibeContextoOperativo: false,
			exibeClassificacao: false,
			numeroOcorrenciaSamu: '',
			numeroOcorrencia193: '',

			exibeObjetivosMissao: '',

			solicitacaoEdicao: [],

			listaDeFuncoes: [],
			funcaoPrincipal: [],

			enableCargo: true,
			enableOrgao: true,
			passCpfObrigatorio: false,

			salvouSolicitacao: false,
			tipoDBModal: 'I',

			assinarESalvar: false,
			preencher: false,

			revisar: false,
			mostraacionamentoUTC: false,
			decolagemUTC: false,
			pousoUTC: false,
			corteUTC: false,
			tipoPassageiro: '',
			disablePaxPob: true,
			qtdEstPassageiros: 0,
			loadUnidade: false,
			timeOut: '',
			timeOutModal: '',
			dataNascimento: null,
			basesOperacao: [],
			bases: [],
			tiposDeMissoes: [],
			tiposDeNaturezas: [],
			descricoes: [],
			unidadesConservacao: [],
			contextos: [],
			orgaos: [],
			estados: [],
			rotaER: [],
			pilotos: [],
			aeronaves: [],
			subclassificacoes: [],
			mecanicos: [],
			load: true,
			//exibirTriuplacao: false,
			itemCopiar: '',

			tipo_planejada: '',

			cienteAssinatura: false,

			aerosImport: [],

			ciclo_nf: '',
			ciclo_nf: '',
			id_motor_esquerdo: null,
			id_motor_direito: null,
			sn_motor_esquerdo: '',
			sn_motor_direito: '',

			aeronave: {
				prefixo: '',
				codinome: '',
				categoria: ''
			},

			aeronave_import: '',

			podemSerPilotos: [],
			loadDe: false,
			loadPara: false,
			loadVor: false,
			editar: false,

			ordem: '',
			despacho: '',
			cidadesDe: [],
			cidadesPara: [],
			cidadesVor: [],
			passageirosSelecao: [],
			trecho: {},

			formPost: {},
			retornoWS: {},

			loadSub: false,
			assinar: false,
			unidadesArmazenamento: [],
			volume: '',
			numero_ce: '',
			id_unidade_armazenamento: '',
			mostraDadosMotor: false,
			mostraVor: false,

			dadosOleoLubrificante: {},
			habilitaOleoLubrificante: '',
			fornecedores: [],
			form: {
				id: 0,
				tipo_voo: '',
				auto_localizado: 0,
				milhas_navegacao: 0,
				trecho_motor: [],
				alteradoPeloMecanico: false,

				chave_validacao: '',
				descricao_ultima_inspecao: '',
				descricao_proxima_inspecao: '',

				labelPassageiro: '',

				pax: 0,
				pob: 0,

				ultima_intervencao: '',
				proxima_intervencao: '',
				horimetro_proxima: '',
				id_responsavel_retorno: '',
				codigo_anac_usuario_retorno: '',
				nome_usuario_retorno: '',
				hora_vfr_noturno: '00:00',
				hora_vfr_diurno: '00:00',
				hora_navegacao: '00:00',
				hora_ifr_simulado: '00:00',
				nome_usuario_inseriu: '',
				data_cadastro: '',
				arma_apreendida: 0,
				pessoa_salva: 0,
				pessoa_detida: 0,
				valor_recuperado: 0,
				//tempo_voo_celula: 0,
				voo_instrucao: '0',
				tempo_voo_motor: 0,
				finalizar_despacho: '',
				id_aeronave_import: '',
				nome_usuario_assinou: '',
				data_assinatura_piloto: '',
				nome_mecanico_assinou: '',
				nome_operador_assinou: '',
				data_assinatura_mecanico: '',
				data_assinatura_operador: '',
				voo: null,
				de: '',
				base: '',
				base_contratual: '',
				de_select: '',
				nome_estado_de: '',
				nome_cidade_de: '',
				unidade_combustivel: '',
				acionamento: '',
				corte: '',
				acionamento_utc: '',
				decolagem_utc: '',
				apresentacao_utc: '',
				pouso_utc: '',
				corte_utc: '',
				ocorrencia: '0',
				ocorrencias: [],

				para: '',
				para_select: '',
				nome_estado_para: '',
				nome_cidade_para: '',

				lat_inicio: '',
				lat_fim: '',
				lng_inicio: '',
				lng_fim: '',

				hora_vfr_noturno: '00:00',
				hora_vfr_diurno: '00:00',
				hora_ifr: '00:00',
				hora_vfr: '00:00',
				hora_navegacao: '00:00',

				vfr_noturno: '',
				vfr_diurno: '',
				ifr: '',
				vfr: '',
				navegacao: '',
				ifr_simulado: '',

				houve_contexto: '',
				contexto_operativo: '',
				numero_diario_anac: '',

				cargaArray: [],

				carga: false,
				descricao_carga: '',
				peso_carga: '',
				carga_liquida: '',
				monitoramento_motor: [],

				verificacao_vor: '',
				vor: '',
				radial_vor: '',
				afastamento_vor: '',
				erro_vor: '',

				decolagem: '',
				pouso: '',

				natureza_voo: '',
				numero_atividade: '',
				numero_bo: '',
				numero_chamada: '',
				existe_unidade_conservacao: '',

				total_ciclo_torque: '',
				total_gancho: '',
				total_guincho: '',
				total_partidas: '',
				total_pousos: '',

				habilitaPerformanceMotor: 0,
				quantidadeMotores: 0,
				horario_performance_motor: null,
				performance_fl: 0,
				performance_tat: 0,
				performance_ias: 0,
				performance_tas: 0,
				performance_boost: 0,
				performance_motor_esq: '',
				performance_motor_dir: '',
				performance_torque_esq: 0,
				performance_torque_dir: 0,
				performance_np_esq: 0,
				performance_np_dir: 0,
				performance_itt_esq: 0,
				performance_itt_dir: 0,
				performance_nh_esq: 0,
				performance_nh_dir: 0,
				performance_flow_esq: 0,
				performance_flow_dir: 0,
				performance_nl_esq: 0,
				performance_nl_dir: 0,

				ovn: '0',
				flir: '',
				ciclo_ng: '',
				ciclo_nf: '',
				ciclo_np: '',
				numero_voo: '',

				nome_arquivo: '',

				finalizar_ordem: '',
				ocorrencia193Obrigatoria: '',

				vfr_diurno: '',
				tempo_voo_piloto: '',

				vfr_noturno: '',
				ifr: '',
				navegacao: '',
				arquivo: '',
				total: '',

				horimetro_final: '',
				horimetro_inicial: '',

				horimetro_inicial_manutencao: '',
				horimetro_final_manutencao: '',

				horimetro_apu: '',

				combustivel: '',
				partidas: 1,
				pousos: 1,

				objetivo_alcancado: '',

				tipo_missao: '',
				tipo_natureza: '',
				observacao: '',
				descricao: '',

				classificacao: '',
				subclassificacao: '',

				unidade_conservacao: [
					{
						obj: '',
						erro: ''
					}
				],
				base_origem: '',

				id_assinatura_piloto: '',

				coracao: 0,
				rim: 0,
				figado: 0,
				cornea: 0,
				pancreas: 0,
				esclero: 0,
				baco: 0,

				gancho: 0,
				guincho: 0,

				socorrido: 0,
				bambi: 0,
				brigadista: 0,

				tripulacao: [
					{
						id_usuario: '',
						erroUsuario: '',
						funcao: '',
						anac: '',
						base: '',
						apresentacao: '',
						erroApresentacao: '',
						codigo_ovn: '',
						erroOVN: '',
						trigrama: '',
						uso_ovn: '',
						tempoOvn: '',
						id_ovn: '',
						erroUsoOvn: '',
						erroIdOvn: '',
						erroTempoOvn: '',
						erroDataCadastro: ''
					}
				],
				discrepancia: [],
				passageiro: [],
				orgao: [],
				id_abastecimento_comprovante: null,

				adicao_oleo_lubrificante: '',
				fornecedor_oleo_lubrificante: '',
				numero_ce_oleo_lubrificante: '',
				campo_lubrificacao_1: '',
				campo_lubrificacao_2: '',
				campo_lubrificacao_3: '',
				campo_lubrificacao_4: '',
				campo_lubrificacao_5: '',
				observacoes_oleo_lubrificante: ''
			},

			listaAtas: [],
			listaApus: [],

			erro: {
				diurnoNortuno: '',
				ifrVfr: '',
				tempo_voo_piloto: '',
				id_ordem_trecho: '',
				tempo_voo_motor: '',
				numero_atividade: '',
				unidade_combustivel: '',
				numero_bo: '',
				ocorrencia193Obrigatoria: '',
				base: '',
				acionamento: '',
				instrutor_voo: '',
				corte: '',
				existe_unidade_conservacao: '',

				objetivo_alcancado: '',

				numero_chamada: '',

				finalizar_ordem: '',

				observacao: '',

				classificacao: '',
				subclassificacao: '',

				descricao: '',

				houve_contexto: '',
				contexto_operativo: '',

				finalizar_despacho: '',

				orgao: '',
				de: '',
				nome_estado_de: '',
				nome_cidade_de: '',

				para: '',
				nome_estado_para: '',
				nome_cidade_para: '',

				decolagem: '',
				pouso: '',

				tipo_missao: '',
				tipo_natureza: '',

				ovn: '',
				flir: '',

				pax: '',

				carga: '',
				descricao_carga: '',
				peso_carga: '',
				carga_liquida: '',

				aprovado: '',

				vfr_diurno: '',
				vfr_noturno: '',
				ifr: '',
				ifr_simulado: '',
				vfr: '',
				navegacao: '',
				total: '',
				ciclo_ng: '',
				ciclo_nf: '',
				ciclo_np: '',
				numero_voo: '',
				horimetro_final: '',
				horimetro_inicial: '',
				combustivel: '',
				partidas: '',
				pousos: ''
			},
			utilizaTrigrama: true,
			homologadoAnac: false,
			labelTipoMissao: '',
			habilitaDescMissao: true,
			labelDescMissao: '',
			movimentacaoCombustivel: {
				exibeOrigem: false,
				origem: null,
				original: null
			},
			dbComercial: false,
			horasDeAcionamentoCorte: 'Horas de Acionamento ao Corte',
		}
	},

	computed: {
		__tiposDeMissoes() {
			this.tiposDeMissoes = this.tiposDeMissoes.filter(
				(item) => item.visualizar == 0
			)
			for (let index = 0; index < this.tiposDeMissoes.length; index++) {
				if (this.tiposDeMissoes[index].descricao === 'COMBATE A INCÊNDIO') {
					this.tiposDeMissoes[index].descricao =
						this.tiposDeMissoes[index].descricao +
						' (URBANO – MISSÃO TÍPICA DE BOMBEIRO)'
				}

				if (this.tiposDeMissoes[index].descricao === 'MEIO AMBIENTE') {
					this.tiposDeMissoes[index].descricao =
						this.tiposDeMissoes[index].descricao +
						' (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
				}
			}

			return this.tiposDeMissoes
		},

		listaFiltrada() {
			if (this.listaPassageiros._request) {
				return this.listaPassageiros.lista.filter(
					(pass) =>
						this.form.passageiro.findIndex(
							(pessoa) => pessoa.id_passageiro == pass.id_passageiro
						) == -1
				)
			} else {
				return this.listaPassageiros.lista
			}
		},

		hasNextPage() {
			return (
				this.listaPassageiros.pagination.page <
				this.listaPassageiros.pagination.pages
			)
		},

		tempoVooMotor() {
			if (this.form.decolagem == '' || this.form.pouso == '') {
				return ''
			} else if (this.form.decolagem != this.form.pouso) {
				var dec = moment(
					this.form.decolagem,
					$sessao.getDateFormat() + ' HH:mm'
				).locale(this._getLangDp)
				var pouso = moment(
					this.form.pouso,
					$sessao.getDateFormat() + ' HH:mm'
				).locale(this._getLangDp)

				var diff = pouso.diff(dec)
				var duration = moment.duration(diff)

				var $hours = duration.hours()
				var $days = duration.days()
				var $minutes = duration.minutes()

				var hora = ''
				var minuto = ''

				if (!_.isNil($hours)) {
					if (Number($hours) < 10) {
						hora = '0' + $hours
					} else {
						hora = $hours
					}
				} else {
					hora = '00'
				}

				if (!_.isNil($minutes)) {
					if (Number($minutes) < 10) {
						minuto = '0' + $minutes
					} else {
						minuto = $minutes
					}
				} else {
					minuto = '00'
				}

				var h = Number(hora) + $days * 24
				return (h < 10 ? '0' + h : h) + ':' + minuto
			} else {
				return '00:00'
			}
		},

		_pilotos() {
			return this.pilotos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})
		},

		_pilotos_mecanicos() {
			let pilotos = this.pilotos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})

			let mecanicos = this.mecanicos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})

			return _.concat(pilotos, mecanicos)
		},

		tempoVooPiloto() {
			if (this.form.acionamento == '' || this.form.corte == '') {
				return ''
			} else if (this.form.acionamento != this.form.corte) {
				var dec = moment(
					this.form.acionamento,
					$sessao.getDateFormat() + ' HH:mm'
				).locale(this._getLangDp)
				var pouso = moment(
					this.form.corte,
					$sessao.getDateFormat() + ' HH:mm'
				).locale(this._getLangDp)

				var diff = pouso.diff(dec)
				var duration = moment.duration(diff)

				var $hours = duration.hours()
				var $days = duration.days()
				var $minutes = duration.minutes()

				var hora = ''
				var minuto = ''

				if (!_.isNil($hours)) {
					if (Number($hours) < 10) {
						hora = '0' + $hours
					} else {
						hora = $hours
					}
				} else {
					hora = '00'
				}

				if (!_.isNil($minutes)) {
					if (Number($minutes) < 10) {
						minuto = '0' + $minutes
					} else {
						minuto = $minutes
					}
				} else {
					minuto = '00'
				}

				var h = Number(hora) + $days * 24
				return (h < 10 ? '0' + h : h) + ':' + minuto
			} else {
				return '00:00'
			}
		},

		exibeForm() {
			if (this.form.tipo_voo != '') {
				return true
			} else if (this.edicao) {
				return true
			}

			return false
		},

		edicao() {
			return this.form.id == 0 ? false : true
		},

		calculoDePax() {
			if (this.disablePaxPob) {
				if (this.qtdEstPassageiros) {
					if (this.form.passageiro.length < Number(this.qtdEstPassageiros)) {
						return Number(this.qtdEstPassageiros)
					} else {
						return this.form.passageiro.length
					}
				} else {
					return this.form.passageiro.length
				}
			} else {
				return Number(this.qtdEstPassageiros)
			}
		},

		calculoDePob() {
			return this.calculoDePax + this.form.tripulacao.length
		},

		flagSimples() {
			return this.flagComponenteCarga === 'basico' || 'simples'
		},
		flagCompleto() {
			return this.flagComponenteCarga === 'completo'
		},
		flagPeso(){
			return this.flagComponenteCarga === 'peso'
		},

		validaDisabledSalvar() {
			if (this.form.acionamento == '') {
				return true
			}

			if (this.form.corte == '') {
				return true
			}

			let total = this._somaTempos(
				this.form.hora_vfr_diurno ? this.form.hora_vfr_diurno : '00:00',
				this.form.hora_vfr_noturno ? this.form.hora_vfr_noturno : '00:00'
			)

			if (total == '00:00') {
				this.erro.diurnoNortuno =
					'Favor preencher o campo "Diurno" ou "Noturno".'
				return true
			} else {
				this.erro.diurnoNortuno = ''
			}

			return false
		}
	},

	watch: {
		'form.acionamento'(val, oldVal) {
			if (val !== oldVal) {
				this.carregaDisponibilidade()
			}
		},
		'form.de_select': function (val, oldVal) {
			if (val != null) {
				if (val.sigla == 'ZZZZ') {
					this.form.de = val.sigla
					if (!this.edicao) {
						this.nome_estado_de = ''
						this.nome_cidade_de = ''
					}
				} else {
					this.form.de = val.sigla
					this.form.nome_cidade_de = val.cidade
					this.form.nome_estado_de = val.uf
				}
				this.form.lat_inicio = this.form.de_select.grau_lat
				this.form.lng_inicio = this.form.de_select.grau_lng
			} else {
				this.form.de = ''
			}
		},

		'form.para_select': function (val, oldVal) {
			if (val != null) {
				if (val.sigla == 'ZZZZ') {
					this.form.para = val.sigla
					if (!this.edicao) {
						this.form.nome_estado_para = ''
						this.form.nome_cidade_para = ''
					}
				} else {
					this.form.para = val.sigla
					this.form.nome_cidade_para = val.cidade
					this.form.nome_estado_para = val.uf
				}
				this.form.lat_fim = this.form.para_select.grau_lat
				this.form.lng_fim = this.form.para_select.grau_lng
			} else {
				this.form.para = ''
			}
		},

		'form.horimetro_inicial': function (val, oldVal) {
			if (val != oldVal) {
				this.calculaTotal()
			}
		},

		'search'(novo, antigo) {
			if (novo != antigo) {
				clearTimeout(this.timeBusca)
				this.timeBusca = setTimeout(() => {
					this.listaPassageiros.pagination.page = 0
					this.listaPassageiros.pagination.pages = 1
					this.listaPassageiros.lista = []
				}, 400)
			}
		},

		'form.passageiro': {
			deep: true,
			handler(newVal) {
				this.form.pax = newVal.length
				this.form.pob = this.form.tripulacao.length + newVal.length
			}
		}
	},

	beforeDestroy() {
		this.limpaTimeOuts()
	},

	mounted() {
		//cria um intersectionObserver para a pesquisa de passageiro
		this.observer = new IntersectionObserver(this.infiniteScroll)
	},

	async created() {
		this.label_acionamento = await this._getParametro(74)

		this.parametros()
		this.utilizaTrigrama = $cliente.get('utiliza_trigrama') === '1'

		this._httpGet('Servico/get_data_atual', (retorno) => {
			if (retorno._request && retorno._status) {
				this.maxDate = this._SQLDateToDateTime(
					retorno.data,
					$sessao.getDateFormat() + ' HH:MM'
				)
			}
		})

		this.carregaDados()
		this.clickAddOrgao()
		this.carregaUnidadesArmazenamento()
		this.listaFuncoes()

		this.carregaDadosOap()
		this.carregaFuncoesPassageiro()

		window.bus.$on('atualiza-dados-oap', () => {
			this.carregaDadosOap()
		})

		this._httpGet('Fornecedor/get', (response) => {
			this.fornecedores = response.lista
		})
	},

	methods: {
		selectOvnTrue(item) {
			item.uso_ovn = true
			this.$forceUpdate()
		},

		selectOvnFalse(item) {
			item.uso_ovn = false
			this.$forceUpdate()
		},
		carregaDadosOleoLubrificante() {
			if (Object.keys(this.dadosOleoLubrificante).length == 0) {
				this._httpGet(
					`Aeronave/get_dados_oleo_lubrificante/${this.trecho.id_aeronave}`,
					(response) => {
						if (response._request && response._status) {
							this.dadosOleoLubrificante = response.lista
						}
					}
				)
			}
		},

		async preencherRotaer(response, tipo) {
			window.bus.$emit(
				'load-in',
				this._traducao('global', 'carregandoPosicaoDoVoo')
			)
			function ConvertDEGToDMS(deg, lat) {
				var absolute = Math.abs(deg)

				var degrees = Math.floor(absolute)
				var minutesNotTruncated = (absolute - degrees) * 60
				var minutes = Math.floor(minutesNotTruncated)
				var seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2)

				if (lat) {
					var direction = deg >= 0 ? 'N' : 'S'
				} else {
					var direction = deg >= 0 ? 'E' : 'W'
				}

				return (
					direction +
					degrees.toString().padStart(lat ? 2 : 3, '0') +
					'°' +
					minutes +
					"'" +
					seconds
				)
			}
			if (response === 'ZZZZ') {
				const posicoes = await new Promise((resolve) =>
					this._axios(
						`/Aeronave/get_posicoes_data/${this.trecho.acionamento}/${this.trecho.corte}/${this.trecho.id_aeronave}`,
						'get',
						{
							callback: (retorno) => {
								resolve(retorno)
							}
						}
					)
				)
				window.bus.$emit('load-out')
				if (posicoes?.length > 0) {
					const {lat, lng} =
						tipo == 'de' ? posicoes[0] : posicoes[posicoes.length - 1]
					const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this._googleKey}`
					this._httpGetExternal(url, (resposta) => {
						let endereco = procurarTipoEndereco(
							resposta.results,
							'administrative_area_level_2'
						)
						if (!endereco) {
							endereco = procurarTipoEndereco(
								resposta.results,
								'administrative_area_level_1'
							)
						}
						if (tipo == 'de') {
							this.form.nome_estado_de = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_1'
							).short_name.toUpperCase()
							this.blurCarregaCidades('de', false)
							this.form.nome_cidade_de = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_2'
							).long_name.toUpperCase()
						} else {
							this.form.nome_estado_para = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_1'
							).short_name.toUpperCase()
							this.blurCarregaCidades('para', false)
							this.form.nome_cidade_para = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_2'
							).long_name.toUpperCase()
						}
					})
					function procurarTipoEndereco(enderecos, tipo) {
						return enderecos.find((endereco) => endereco.types.includes(tipo))
					}
					if (tipo == 'de') {
						this.form.lat_inicio = ConvertDEGToDMS(lat, true)
						this.form.lng_inicio = ConvertDEGToDMS(lng, false)
					} else {
						this.form.lat_fim = ConvertDEGToDMS(lat, true)
						this.form.lng_fim = ConvertDEGToDMS(lng, false)
					}
				} else {
					window.bus.$emit('exibir-notificacao', {
						type: 'danger',
						text: this._traducao('global', 'nenhumaPosicaoEncontrada')
					})
				}
			}
		},

		mascaraLatitude() {
			if (this.form.lat_inicio.length <= 11 && form.de === 'ZZZZ') {
				return "'S00º00'0.00'"
			} else if (this.form.lat_inicio.length >= 12 && form.de === 'ZZZZ') {
				return "'S00º00'00.00'"
			} else {
				return "'S00º00'00'"
			}
		},

		mascaraLatitudeFinal() {
			if (this.form.lat_fim.length <= 11 && form.de === 'ZZZZ') {
				return "'S00º00'0.00'"
			} else if (this.form.lat_fim.length >= 12 && form.de === 'ZZZZ') {
				return "'S00º00'00.00'"
			} else {
				return "'S00º00'00'"
			}
		},

		abrirCadastroPassageiro(index) {
			this.$refs.formCadastroPassageiro.modalShow(80)
			this.indexCadastro = index
			this.$refs.componenteCadastroPassageiro.limpar()
		},

		carregarPassageiroRecemSalvo(passageiro) {
			this.$refs.formCadastroPassageiro.modalHide()
			passageiro.id_passageiro = passageiro.id
			this.carregarPassageiro(passageiro, this.indexCadastro)
		},
		buscaServeSide(search) {
			this.search = search
		},
		async onOpen() {
			if (this.hasNextPage) {
				await this.$nextTick()
				this.observer.observe(this.$refs.loadPassageiro[0])
			}
		},
		onClose() {
			this.observer.disconnect()
		},

		async infiniteScroll([{isIntersecting, target}]) {
			if (isIntersecting) {
				const ul = target.offsetParent
				const scrollTop = target.offsetParent.scrollTop
				const retorno = await new Promise((resolve) => {
					const page = Number(this.listaPassageiros.pagination.page) + 1
					const rota = this.search
						? `/Passageiro/lista?page=${page}&search=${this.search}`
						: `/Passageiro/lista?page=${page}`
					this._axios(rota, 'get', {
						callback: (retorno) => {
							if (retorno._request && retorno._status) {
								retorno.lista.map((passageiro) => {
									passageiro.id_passageiro = passageiro.id
									passageiro.orgao = passageiro.id_orgao_apoiado
									passageiro.peso = parseFloat(passageiro.peso, 2)
									return passageiro
								})

								resolve(retorno)
							}
						}
					})
				})
				this.listaPassageiros.lista = [
					...this.listaPassageiros.lista,
					...retorno.lista
				]
				this.listaPassageiros.pagination = retorno.pagination
				await this.$nextTick()
				ul.scrollTop = scrollTop
			}
		},

		carregaFuncoesPassageiro() {
			this._axios('Funcao/listar', 'get', {
				callback: ({lista}) => {
					this.listaFuncoesPassageiros = lista
				}
			})
		},

		validarCPF(cpf, index) {
			if (cpf) {
				this._httpGet('/Usuario/validador_de_cpf/' + cpf, (retorno) => {
					if (retorno.status == 'error') {
						this.form.passageiro[index].cpfErro = this._traducao(
							'global',
							'cpfInvalido'
						)
					} else {
						this.form.passageiro[index].cpfErro = ''
					}
				})
			} else if (cpf == '') {
				this.form.passageiro[index].cpfErro = this._traducao(
					'global',
					'cpfInvalido'
				)
			} else {
				this.form.passageiro[index].cpfErro = ''
			}
		},

		parametros() {
			this._getParametro(88).then((valor) => (this.exibeNp = valor))
			this._getParametro(78).then(
				(valor) => (this.exibeObjetivosMissao = valor)
			)
			this._getParametro(18).then(
				(valor) => (this.numeroOcorrenciaSamu = valor)
			)

			this._getParametro(19).then((valor) => (this.numeroOcorrencia193 = valor))

			this._getParametro(20).then(
				(valor) => (this.form.ocorrencia193Obrigatoria = valor == 1)
			)

			this._getParametro(23).then((valor) => (this.validaVfr = valor))

			this._getParametro(27).then(
				(valor) => (this.homologadoAnac = Number(valor) == 1)
			)
			this._getParametro(28).then((valor) => (this.labelTipoMissao = valor))
			this._getParametro(29).then(
				(valor) => (this.habilitaDescMissao = Number(valor) == 1)
			)
			this._getParametro(30).then((valor) => (this.labelDescMissao = valor))
			this._getParametro(36).then(
				(valor) => (this.exibeRedsSamu = Number(valor) == 1)
			)

			this._getParametro(40).then(
				(valor) => (this.disablePaxPob = Boolean(Number(valor)))
			)

			this._getParametro(42).then(
				(valor) => (this.enableCargo = Boolean(Number(valor)))
			)

			this._getParametro(43).then(
				(valor) => (this.enableOrgao = Boolean(Number(valor)))
			)

			this._getParametro(47).then(
				(valor) => (this.passCpfObrigatorio = Boolean(Number(valor)))
			)

			this._getParametro(48).then(
				(valor) => (this.mostraDadosMotor = Number(valor) === 1)
			)

			this._getParametro(49).then(
				(valor) => (this.mostraVor = Number(valor) === 1)
			)
			this._getParametro(52).then((valor) => (this.centrodeCusto = valor))

			this._getParametro(70).then(
				(valor) => (this.labelPassageiro = Boolean(Number(valor)))
			)

			this._getParametro(75).then(
				(valor) => (this.habilitaPerformanceMotor = Boolean(Number(valor)))
			)

			this._getParametro(84).then(
				(valor) => (this.habilitaOleoLubrificante = valor)
			)

			this._getParametro(89).then(
				(valor) => (this.exibeContextoOperativo = Number(valor) == 1)
			)

			this._getParametro(90).then(
				(valor) => (this.exibeClassificacao = Number(valor) == 1)
			)

			this._getParametro(91).then(
				(valor) => (this.habilitaPartida = Number(valor) == 1)
			)
			this._getParametro(94).then(
				(valor) => (this.exibeAssinaturaMecanico = Number(valor) == 1)
			)

			this._getParametro(110).then(
				(valor) => (this.dbComercial = Number(valor) == 1)
			)
			this._getParametro(117).then(
				(valor) => (this.horasDeAcionamentoCorte = valor)
			)
			this._getParametro(116).then(
				(valor) => (this.labelTempoAcionamentoCorte = valor)
			)
			this._getParametro(122).then(
				(valor) => (this.exibeFinalizarOrdemMissao = valor)
			)
		},

		exibeOrgaoPassageiro() {
			this.clickImportaPassageiros()
			for (let i = 0; i < this.form.passageiro.length; i++) {
				this.form.passageiro[i].orgao =
					this.form.passageiro[i].orgao == this.passageirosSelecao[i].orgao &&
					this.passageirosSelecao[i].orgao != null
						? this.passageirosSelecao[i].sigla_orgao
						: _traducao('global', 'naoInformado')
			}

			this._exibeModal('modal-ordem-escolha-cargas', 70)
		},

		abreModalOap() {
			this.$refs.orgaosApoiadosModal.modalShow(80)
			this.atualizaModal++
		},

		removePass() {
			if (this.form.passageiro.length >= Number(this.form.pax)) {
				this.form.pax = this.form.passageiro.length
			} else {
				this.form.pax--
			}
			this.form.pob = this.form.pax + this.form.tripulacao.length
		},

		inveterPilotoCopiloto() {
			const piloto = _.find(
				this.form.tripulacao,
				(o) => o.funcao.toUpperCase() == 'PILOTO EM COMANDO'
			)
			const copiloto = _.find(
				this.form.tripulacao,
				(o) => o.funcao.toUpperCase() == 'SEGUNDO EM COMANDO'
			)

			const dadosPiloto = Object.assign({}, piloto)

			piloto.id_usuario = copiloto.id_usuario
			piloto.erroUsuario = copiloto.erroUsuario
			piloto.anac = copiloto.anac
			piloto.codigo_ovn = copiloto.codigo_ovn
			piloto.erroOVN = copiloto.erroOVN
			piloto.trigrama = copiloto.trigrama
			piloto.load = copiloto.load
			piloto.usuarios = copiloto.usuarios
			piloto.nome = copiloto.nome

			copiloto.id_usuario = dadosPiloto.id_usuario
			copiloto.erroUsuario = dadosPiloto.erroUsuario
			copiloto.anac = dadosPiloto.anac
			copiloto.codigo_ovn = dadosPiloto.codigo_ovn
			copiloto.erroOVN = dadosPiloto.erroOVN
			copiloto.trigrama = dadosPiloto.trigrama
			copiloto.load = dadosPiloto.load
			copiloto.usuarios = dadosPiloto.usuarios
			copiloto.nome = dadosPiloto.nome

			this.$forceUpdate()
		},

		preencherDiario(data) {
			// se não tiver carregando chama a função que verifica se todas as listas foram carregadas
			if (!this.load) {
				this.editar = false
				this.preencher = true
				this.form.acionamento = data.trecho._dataAcionamento
				this.form.corte = data.trecho._dataCorte

				if (data.trecho.gerado_pelo_service) {
					this.form.decolagem = this._SQLDateToDateTime(
						data.trecho.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.form.pouso = this._SQLDateToDateTime(
						data.trecho.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					)
				}

				if (data.trecho.trecho_motor.length == 1) {
					this.id_motor_esquerdo = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[0].serial_number
					this.form.quantidadeMotores = 1
				} else if (data.trecho.trecho_motor.length == 2) {
					this.form.quantidadeMotores = 2
					this.id_motor_esquerdo = data.trecho.trecho_motor[1].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[1].serial_number
					this.id_motor_direito = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_direito = data.trecho.trecho_motor[0].serial_number
				}

				// seta true pra atualizar as datas
				this.mostraacionamentoUTC = true
				this.decolagemUTC = true
				this.pousoUTC = true
				this.corteUTC = true
				this.assinar = data.assinar
				this.aeronave = data.aero
				this.trecho = data.trecho

				this.form.trecho_motor = data.trecho.trecho_motor.map((item) => {
					item.erro_ciclo_nf = ''
					item.erro_ciclo_ng = ''
					item.erro_ciclo_np = ''
					item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
					item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
					item.ciclo_np = this.toNumber2Casa(item.ciclo_np)
					return item
				})

				this.carregaHorimetro()

				// carrega os usuários pilotos
				this.carregaUsuariosTripulacao('piloto em comando', 0, true, false)

				this.iniciaVerificacaoFechamento()

				if (data.trechoCopiar != null) {
					this.itemCopiar = data.trechoCopiar
					this.getDadosEdicao(data.trechoCopiar, true) // false pra copiar
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				if (this.trecho.id_despacho_emergencial) {
					this.carregaDadosDb()
				}
			} else {
				this.editar = false
				this.preencher = true

				this.aeronave = data.aero
				this.trecho = data.trecho

				if (data.trecho.trecho_motor.length == 1) {
					this.id_motor_esquerdo = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[0].serial_number
					this.form.quantidadeMotores = 1
				} else if (data.trecho.trecho_motor.length == 2) {
					this.form.quantidadeMotores = 2
					this.id_motor_esquerdo = data.trecho.trecho_motor[1].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[1].serial_number
					this.id_motor_direito = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_direito = data.trecho.trecho_motor[0].serial_number
				}

				this.form.trecho_motor = data.trecho.trecho_motor.map((item) => {
					item.erro_ciclo_nf = ''
					item.erro_ciclo_ng = ''
					item.erro_ciclo_np = ''
					item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
					item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
					item.ciclo_np = this.toNumber2Casa(item.ciclo_np)
					return item
				})

				this._httpGet(
					`Aeronave/get_dados_oleo_lubrificante/${this.trecho.id_aeronave}`,
					(response) => {
						if (response._request && response._status) {
							this.dadosOleoLubrificante = response.lista
						}
					}
				)

				bus.$emit('load-in', {
					text: this._traducao('global', 'carregandoListas')
				})
				this.carregando(data, 'preencherDiario') // função que verivica se todas as listas foram carregadas
				window.bus.$emit('load-out')
			}
		},

		carregando(data, funcao) {
			// seta um timeout de 1 segundo pra ficar verificando se todas as listas foram carregadas
			setTimeout(() => {
				if (
					this.basesOperacao.length > 0 &&
					this.bases.length > 0 &&
					this.tiposDeMissoes.length > 0 &&
					this.tiposDeNaturezas.length > 0 &&
					this.descricoes.length > 0 &&
					this.unidadesConservacao.length > 0 &&
					this.contextos.length > 0 &&
					this.orgaos.length > 0 &&
					this.estados.length > 0 &&
					this.rotaER.length > 0 &&
					this.pilotos.length > 0 &&
					this.aeronaves.length > 0 &&
					this.subclassificacoes.length > 0 &&
					this.mecanicos.length > 0
				) {
					this.load = false
					this[funcao](data) // caso sim, chama a função
				} else {
					this.carregando(data, funcao)
				}
			}, 1000)
		},

		editarDiarioDeBordo(data) {
			if (!this.load) {
				this.aeronave = data.aero
				this.trecho = data.trecho
				this.form.acionamento = data.trecho._dataAcionamento
				this.form.corte = data.trecho._dataCorte
				this.editar = !data.trecho.bloqueado_editar
				this.assinar = data.assinar
				this.carregaDisponibilidade()
				if (data.trecho.trecho_motor.length == 1) {
					this.id_motor_esquerdo = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[0].serial_number
					this.form.quantidadeMotores = 1

					if (data.trecho.trecho_motor[0].data != null) {
						data.trecho.trecho_motor[0].data = new moment(
							data.trecho.trecho_motor[0].data
						).format('DD/MM/YYYY HH:mm')
					} else {
						data.trecho.trecho_motor[0].data = null
					}

					this.form.horario_performance_motor = data.trecho.trecho_motor[0].data
					this.form.performance_fl = data.trecho.trecho_motor[0].fl
					this.form.performance_tat = data.trecho.trecho_motor[0].tat
					this.form.performance_ias = data.trecho.trecho_motor[0].ias
					this.form.performance_tas = data.trecho.trecho_motor[0].tas
					this.form.performance_boost = data.trecho.trecho_motor[0].boost

					this.form.performance_torque_esq = data.trecho.trecho_motor[0].tq
					this.form.performance_np_esq = data.trecho.trecho_motor[0].np
					this.form.performance_itt_esq = data.trecho.trecho_motor[0].itt
					this.form.performance_nh_esq = data.trecho.trecho_motor[0].nh
					this.form.performance_flow_esq = data.trecho.trecho_motor[0].fuel_flow
					this.form.performance_nl_esq = data.trecho.trecho_motor[0].nl
				} else if (data.trecho.trecho_motor.length == 2) {
					this.form.quantidadeMotores = 2
					this.id_motor_esquerdo = data.trecho.trecho_motor[1].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[1].serial_number
					this.id_motor_direito = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_direito = data.trecho.trecho_motor[0].serial_number

					if (data.trecho.trecho_motor[1].data != null) {
						data.trecho.trecho_motor[1].data = new moment(
							data.trecho.trecho_motor[1].data
						).format('DD/MM/YYYY HH:mm')
					} else {
						data.trecho.trecho_motor[1].data = null
					}

					this.form.horario_performance_motor = data.trecho.trecho_motor[1].data
					this.form.performance_fl = data.trecho.trecho_motor[1].fl
					this.form.performance_tat = data.trecho.trecho_motor[1].tat
					this.form.performance_ias = data.trecho.trecho_motor[1].ias
					this.form.performance_tas = data.trecho.trecho_motor[1].tas
					this.form.performance_boost = data.trecho.trecho_motor[1].boost

					this.form.performance_torque_esq = data.trecho.trecho_motor[1].tq
					this.form.performance_np_esq = data.trecho.trecho_motor[1].np
					this.form.performance_itt_esq = data.trecho.trecho_motor[1].itt
					this.form.performance_nh_esq = data.trecho.trecho_motor[1].nh
					this.form.performance_flow_esq = data.trecho.trecho_motor[1].fuel_flow
					this.form.performance_nl_esq = data.trecho.trecho_motor[1].nl

					this.form.performance_torque_esq = data.trecho.trecho_motor[0].tq
					this.form.performance_np_esq = data.trecho.trecho_motor[0].np
					this.form.performance_itt_esq = data.trecho.trecho_motor[0].itt
					this.form.performance_nh_esq = data.trecho.trecho_motor[0].nh
					this.form.performance_flow_esq = data.trecho.trecho_motor[0].fuel_flow
					this.form.performance_nl_esq = data.trecho.trecho_motor[0].nl
				}

				this.form.hora_vfr = data.trecho.hora_vfr
				this.form.hora_ifr = data.trecho.hora_ifr
				this.getDadosEdicao(this.trecho, false) // false pra copiar

				if (this.visualizar) {
					bus.$emit('load-in', {
						text: this._traducao('global', 'carregandoDiario')
					})
				} else {
					this.iniciaVerificacaoFechamento()
				}
			} else {
				bus.$emit('load-in', {
					text: this._traducao('global', 'carregandoListas')
				})
				this.carregando(data, 'editarDiarioDeBordo')
				window.bus.$emit('load-out')
			}
		},

		carregaHistorico(data) {
			if (!this.load) {
				this.aeronave = data.aeronave
				this.trecho = data.trecho
				this.form.acionamento = this._SQLDateToDateTime(
					data.trecho.acionamento,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.form.corte = this._SQLDateToDateTime(
					data.trecho.corte,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.editar = true
				this.assinar = false
				this.carregaDadosEdicao(data.trecho, false)
			} else {
				bus.$emit('load-in', {text: 'Carregando listas'})
				this.carregando(data, 'carregaHistorico')
			}
		},

		carregaDisponibilidade() {
			let url = 'Disponibilidade/get_ultima_by_data/' + this.aeronave.id
			if (this.form.acionamento) {
				url +=
					'/' +
					this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM:SS'
					).split(' ')[0]
			}
			this._httpGet(url, (retorno) => {
				//.log("disponibilidade", retorno)
				if (retorno._status && retorno._request) {
					this.form.ultima_intervencao = retorno.lista.data_ultima
					this.form.proxima_intervencao = retorno.lista.data_proxima
					this.form.horimetro_proxima = retorno.lista.horimetro_proxima
					this.form.id_responsavel_retorno =
						retorno.lista.id_usuario_responsavel
					this.form.nome_usuario_retorno =
						retorno.lista.nome_usuario_responsavel
					this.form.descricao_ultima_inspecao = retorno.lista.descricao_ultima
					this.form.descricao_proxima_inspecao = retorno.lista.descricao
					this.form.codigo_anac_usuario_retorno =
						retorno.lista.codigo_anac_usuario_retorno
				}
			})
		},

		despachoSelecionado(despacho) {
			this.form.tipo_voo = despacho.tipo

			this._axios(
				`Motor_aeronave/get_by_aeronave/${this.trecho.id_aeronave}`,
				'get',
				{
					callback: ({lista}) => {
						if (lista) {
							this.form.monitoramento_motor = []
							for (let elem of lista) {
								this.form.monitoramento_motor.push({
									altitude: '',
									oat: '',
									ias: '',
									rpm: '',
									ng: '',
									id_motor: elem.id_motor,
									nl: '',
									fuel_flow: '',
									itt: '',
									tq: '',
									abastecimento_oleo: '',
									serial_number: elem.serial_number,
									descricao: elem.descricao
								})
							}
						}
					}
				}
			)

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			// CARREGA O DESPACHO PARA A EDICAO
			this._httpGet(
				'mg-siga/Despacho_emergencial/get/' + despacho.id,
				(retorno) => {
					if (retorno._request && retorno._status) {
						bus.$emit('load-out')
						this.despacho = retorno.lista
						this.form.numero_bo = retorno.lista.reds
						this.form.numero_chamada = retorno.lista.chamada
						this.form.numero_atividade = retorno.lista.atividade
						this.form.observacao = retorno.lista.historico
						this.form.tripulacao = retorno.lista.aeronave[0].tripulacao.map(
							(item, idx) => {
								;(item.erroUsuario = ''),
									(item.erroApresentacao = ''),
									(item.erroIdOvn = '')
								item.uso_ovn = true
								item.apresentacao = item.apresentacao
									? this._SQLDateToDateTime(
											item.apresentacao,
											$sessao.getDateFormat() + ' HH:MM'
									  )
									: ''
								this.carregaUsuariosTripulacao(item.funcao, idx, false, true)
								return item
							}
						)
						if (retorno.lista.aeronave[0].tripulacao.length) {
							this.form.voo_instrucao =
								retorno.lista.aeronave[0].tripulacao[0].funcao.toLowerCase() ==
								'piloto em comando'
									? '0'
									: '1'
						} else {
							this.form.voo_instrucao = '0'
						}
						// se não tiver editando importa os dados
						if (!this.edicao) {
							// se existir ordem, carrega os dados da ordem, tripulação, passageiros e orgão apoiados
							if (
								despacho.id_ordem_missao != null &&
								despacho.id_ordem_missao != '0'
							) {
								bus.$emit('load-in', {
									text: this._traducao('global', 'carregando')
								})

								// CARREGA O DESPACHO PARA A EDICAO
								this._httpGet(
									'mg-siga/Ordem_missao/editar/' + despacho.id_ordem_missao,
									(retorno) => {
										if (retorno._request) {
											bus.$emit('load-out')
											this.carregaCamposOrdem(retorno, false)
											this.qtdEstPassageiros =
												retorno.aeronave[0].quantidade_estimada_passageiros
											if (!Boolean(Number(this.disablePaxPob))) {
												this.form.pax =
													retorno.aeronave[0].quantidade_estimada_passageiros
												this.form.pob =
													Number(this.form.pax) + this.form.tripulacao.length
											}
										}
									}
								)
							} else {
								// caso não tenha ordem, importa os dados do despacho
								this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
									return o.id == retorno.lista.id_tipo_missao
								})
								retorno.lista.aeronave = retorno.lista.aeronave.map((item) => {
									item._aero = _.find(this.aeronaves, (o) => {
										return o.id == item.id_aeronave
									})

									return item
								})

								var aero = _.find(retorno.lista.aeronave, (o) => {
									return o.id_aeronave == this.aeronave.id
								})
								this.form.houve_contexto = this.validaNull(
									despacho.houve_contexto
								)
								if (this._idCliente != 41) {
									this.form.subclassificacao =
										despacho.id_subclassificacao != null
											? this.getSubclassificacaoById(
													despacho.id_subclassificacao
											  )
											: ''
								}

								if (_.isNil(aero)) {
									this.aerosImport = retorno.lista.aeronave
									this.$refs.modalAero.modalShow(50)
								} else {
									this.aeronave_import = aero
									this.form.base = aero.base
									this.carregaDadosAero()
								}

								if (this.form.houve_contexto != '0') {
									for (var i in this.contextos) {
										if (
											this.contextos[i].id == despacho.id_contexto_operativo
										) {
											this.form.contexto_operativo = this.contextos[i]
										}
									}
								}

								if (retorno.lista.id_orgao_apoiado) {
									this.form.orgao[0].orgao = _.find(this.orgaos, (o) => {
										return o.id == retorno.lista.id_orgao_apoiado
									})
								}
							}
						}
					}
				}
			)
		},

		setaAcionamento(val) {
			this.form.acionamento = val

			if (val != '') {
				if (this.mostraacionamentoUTC && !this.edicao) {
					this.converteDataUTC(this.form.acionamento).then((res) => {
						this.form.acionamento_utc = res
						this.mostraacionamentoUTC = true
						this.$forceUpdate()
					})
				} else {
					this.mostraacionamentoUTC = true
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			}
		},

		setaDecolagem(val) {
			this.form.decolagem = val

			if (val != '') {
				if (this.decolagemUTC && !this.edicao) {
					this.converteDataUTC(this.form.decolagem).then((res) => {
						this.form.decolagem_utc = res
						this.decolagemUTC = true
						this.$forceUpdate()
					})
				} else {
					this.decolagemUTC = true
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			}
		},

		setaPouso(val) {
			this.form.pouso = val

			if (val != '') {
				if (this.pousoUTC && !this.edicao) {
					this.converteDataUTC(this.form.pouso).then((res) => {
						this.form.pouso_utc = res
						this.pousoUTC = true
						this.$forceUpdate()
					})
				} else {
					this.pousoUTC = true
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			}
		},

		setaCorte(val) {
			this.form.corte = val
			if (val != '') {
				if (this.corteUTC && !this.edicao) {
					this.calculaTempoDeVooPiloto()

					this.converteDataUTC(this.form.corte).then((res) => {
						this.form.corte_utc = res
						this.corteUTC = true
						this.$forceUpdate()
					})
					this.calculaTempoVooOrgao()
				} else {
					this.corteUTC = true
				}

				this.calculaTempoManutencao()
				this.calculaTotal()
			}
		},

		//recebe data utc
		converteDataUTC(data) {
			return new Promise((resolve) => {
				var dataRetorno
				data = this._dateTimeToDateSQL(
					data,
					$sessao.getDateFormat() + ' HH:MM:SS'
				)
				data = data + ':00'

				var dataEnvio = {
					data: data
				}
				this.mostraUTC = true
				// return data
				this._httpPost('Servico/converte_utc', dataEnvio, (resposta) => {
					dataRetorno = this._SQLDateToDateTime(
						resposta['data'],
						$sessao.getDateFormat() + ' HH:MM'
					)
					resolve(dataRetorno)
				})
			})
		},

		calculaIdade(ano_aniversario, mes_aniversario, dia_aniversario) {
			var d = new Date(),
				ano_atual = d.getFullYear(),
				mes_atual = d.getMonth() + 1,
				dia_atual = d.getDate(),
				ano_aniversario = +ano_aniversario,
				mes_aniversario = +mes_aniversario,
				dia_aniversario = +dia_aniversario,
				idade = ano_atual - ano_aniversario

			if (
				mes_atual < mes_aniversario ||
				(mes_atual == mes_aniversario && dia_atual < dia_aniversario)
			) {
				idade--
			}

			return idade < 0 ? 0 : idade
		},

		alteraIdade(dataNascimento) {
			var dia = dataNascimento.substring(0, 2)
			var mes = dataNascimento.substring(3, 5)
			var ano = dataNascimento.substring(6, 10)
			var idade = this.calculaIdade(ano, mes, dia)

			if (dataNascimento != '') {
				this.form.passageiro = this.form.passageiro.map((item) => {
					if (item.data_nascimento == dataNascimento) {
						item.idade_aparente = idade
					}
					return item
				})
			}
		},

		iniciaVerificacaoFechamento() {
			this.limpaTimeOuts()
			this.timeOut = setTimeout(() => {
				this._exibeModal('modal-ordem-tempo-expirado', 60)
			}, 600000)
			//this.timeOut = setTimeout(() => { this._exibeModal('modal-ordem-tempo-expirado', 60)}, 4000);
			this.timeOutModal = setTimeout(() => {
				this.voltaLista()
			}, 660000)
			//this.timeOut = setTimeout(() => { this.voltaLista() },4000);
		},

		clickPrintVisualizar() {
			this._print()
		},

		clickPrint() {
			this.$refs.printDiario.carregaDados({
				data: this.form,
				ovns: this.ovns,
				aero: this.aeronave,
				pilotos: this._pilotos_mecanicos,
				trecho: this.trecho,
				utilizaTrigrama: this.utilizaTrigrama,
				homologadoAnac: this.homologadoAnac,
				labelTipoMissao: this.labelTipoMissao,
				habilitaDescMissao: this.habilitaDescMissao,
				labelDescMissao: this.labelDescMissao,
				labelPassageiro: this.labelPassageiro
			})

			if (this.despacho != '' && this.form.nome_arquivo == '') {
				this.$refs.printDiario.carregaDespacho(this.despacho)
			}

			this.$nextTick(() => {
				window.print()
			})
		},

		getDadosEdicao(trecho, copiar) {
			if (copiar) {
				bus.$emit('load-in', {text: this._traducao('global', 'copiandoDiario')})
			} else {
				bus.$emit('load-in', {
					text: this._traducao('global', 'carregandoDiario')
				})
			}

			this._httpGet(
				'mg-siga/Relatorio_voo_trecho/get/' + trecho.id,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						if (copiar) {
							delete response.lista.trecho_motor
						}
						this.carregaDadosEdicao(response.lista, copiar)
					}
				}
			)
		},

		carregaDadosEdicao(data, copiar) {
			this.qtdEstPassageiros = data.quantidade_estimada_passageiros
			this.form.pax = data.pax ? data.pax : this.calculoDePax
			this.form.pob = data.pob ? data.pob : this.calculoDePob
			this.form.milhas_navegacao = parseFloat(data.milhas_navegacao).toFixed(1)
			// se o usuario fez alguma solicitacao de edicao de db
			if (!_.isNil(data.solicitacao_edicao)) {
				this.solicitacaoEdicao = data.solicitacao_edicao
			}

			// motivo da assinatura
			if (!_.isNil(data.solicitacao_edicao_bloqueada)) {
				this.$refs.modalMotivoAssinatura.exibeModal(
					data.solicitacao_edicao_bloqueada
				)
			}

			if (data.id_usuario_piloto == $sessao.getId()) {
				// this.preencher = true;
				//this.editar = false;
			}

			//console.log("data", data)

			this.form.id_aeronave_import =
				data.id_aeronave_import == null ? '' : data.id_aeronave_import
			this.form.tipo_voo = data.origem

			// carrega o despacho caso tenha
			if (data.id_despacho_emergencial != null) {
				this._httpGet(
					'mg-siga/Despacho_emergencial/get/' + data.id_despacho_emergencial,
					(retorno) => {
						bus.$emit('load-out')

						if (retorno._request) {
							this.despacho = retorno.lista

							if (this.visualizar) {
								this.$refs.printVisualizar.carregaDespacho(this.despacho)
							}
						}
					}
				)
			}
			// this.form.clico_ng = data.clico_ng == null ? '' : data.clico_ng
			// this.form.clico_nf = data.clico_nf == null ? '' : data.clico_nf
			this.form.total_ciclo_torque =
				data.total_ciclo_torque == null ? '' : data.total_ciclo_torque
			this.form.total_gancho =
				data.total_gancho == null ? '' : data.total_gancho
			this.form.total_guincho =
				data.total_guincho == null ? '' : data.total_guincho
			this.form.total_partidas =
				data.total_partidas == null ? '' : data.total_partidas
			this.form.total_pousos =
				data.total_pousos == null ? '' : data.total_pousos
			this.form.existe_unidade_conservacao = data.existe_unidade_conservacao

			this.form.horimetro_apu =
				data.horimetro_apu == null ? '' : data.horimetro_apu

			this.form.numero_ce = data.numero_ce
			this.form.id_unidade_armazenamento = data.id_unidade_armazenamento
			this.form.volume = this.toNumber1Casa(data.volume)
			if (data.id_tipo_lancamento == 9 || data.id_tipo_lancamento == 10) {
				this.movimentacaoCombustivel.exibeOrigem = true
				this.movimentacaoCombustivel.origem = data.razao_social
				this.movimentacaoCombustivel.original =
					data.id_abastecimento_comprovante
			}

			this.form.verificacao_vor = data.verificacao_vor
			this.form.vor = data.vor
			this.form.radial_vor = data.radial_vor
			this.form.afastamento_vor = data.afastamento_vor
			this.form.erro_vor = data.erro_vor

			// se tiver editando
			if (!copiar) {
				if (!_.isNil(data.numero_diario_anac)) {
					this.form.numero_diario_anac =
						data.numero_diario_anac == ''
							? this.trecho.numero_diario
							: data.numero_diario_anac
				} else {
					this.form.numero_diario_anac = this.trecho.numero_diario
				}

				this.form.id_assinatura_piloto =
					data.id_assinatura_piloto == null ? '' : data.id_assinatura_piloto
				this.form.arquivo = data.arquivo == null ? '' : data.arquivo

				this.form.nome_usuario_assinou =
					data.nome_usuario_assinou == null ? '' : data.nome_usuario_assinou
				this.form.nome_mecanico_assinou =
					data.nome_mecanico_assinou == null ? '' : data.nome_mecanico_assinou
				this.form.nome_operador_assinou =
					data.nome_operador_assinou == null ? '' : data.nome_operador_assinou

				this.form.data_assinatura_piloto =
					data.data_assinatura_piloto == null ? '' : data.data_assinatura_piloto
				this.form.data_assinatura_mecanico =
					data.data_assinatura_mecanico == null
						? ''
						: data.data_assinatura_mecanico
				this.form.data_assinatura_operador =
					data.data_assinatura_operador == null
						? ''
						: data.data_assinatura_operador
				this.form.nome_arquivo =
					data.nome_arquivo == null ? '' : data.nome_arquivo

				this.form.id = data.id
				this.form.finalizar_ordem = data.finalizar_ordem
				this.form.id_ordem = data.id_ordem_missao
				this.form.id_despacho = data.id_despacho_emergencial
				this.form.voo_instrucao = data.voo_instrucao
				this.form.finalizar_despacho = data.finalizar_despacho
				this.form.hora_vfr_diurno =
					data.hora_vfr_diurno == null ? '00:00' : data.hora_vfr_diurno
				// this.form.vfr_diurno = this._timeToDecimal("28/01/1991 00:00", "28/01/1991 " + this.form.hora_vfr_diurno)
				this.form.hora_vfr_noturno =
					data.hora_vfr_noturno == null ? '00:00' : data.hora_vfr_noturno
				// this.form.vfr_noturno = this._timeToDecimal("28/01/1991 00:00", "28/01/1991 " + this.form.hora_vfr_noturno)
				this.form.hora_ifr = data.hora_ifr == null ? '00:00' : data.hora_ifr
				this.form.hora_vfr = data.hora_vfr == null ? '00:00' : data.hora_vfr
				this.form.hora_navegacao =
					data.hora_navegacao == null ? '00:00' : data.hora_navegacao

				// this.form.ciclo_ng = this.toNumber2Casa(data.ciclo_ng)
				// this.form.ciclo_nf = this.toNumber2Casa(data.ciclo_nf)
				this.form.nome_usuario_inseriu = data.nome_usuario_inseriu
				this.form.data_cadastro = data.data_cadastro

				this.form.ultima_intervencao = data.ultima_intervencao
				this.form.proxima_intervencao = data.proxima_intervencao
				this.form.horimetro_proxima = data.horimetro_proxima
				this.form.descricao_ultima_inspecao =
					data.descricao_ultima_inspecao == null
						? ''
						: data.descricao_ultima_inspecao
				this.form.descricao_proxima_inspecao =
					data.descricao_proxima_inspecao == null
						? ''
						: data.descricao_proxima_inspecao
				this.form.id_responsavel_retorno = data.id_responsavel_retorno
				this.form.codigo_anac_usuario_retorno = data.codigo_anac_usuario_retorno
				this.form.nome_usuario_retorno = data.nome_usuario_retorno
				this.form.objetivo_alcancado =
					data.objetivo_alcancado == null ? '' : data.objetivo_alcancado

				// PMSP
				this.form.valor_recuperado = this.toNumber2Casa(data.valor_recuperado)
				this.form.auto_localizado = Number(data.auto_localizado)
				this.form.arma_apreendida = Number(data.arma_apreendida)
				this.form.pessoa_salva = Number(data.pessoa_salva)
				this.form.pessoa_detida = Number(data.pessoa_detida)
				// FIM PMSP

				this.form.numero_voo = Number(data.numero_voo)
				this.form.decolagem = this._SQLDateToDateTime(
					data.decolagem,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.setaDecolagem(this.form.decolagem)
				this.form.pouso = this._SQLDateToDateTime(
					data.pouso,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.setaPouso(this.form.pouso)

				if (data.pouso_utc != null) {
					this.form.pouso_utc = this._SQLDateToDateTime(
						data.pouso_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.pouso_utc = ''
				}

				if (data.decolagem_utc != null) {
					this.form.decolagem_utc = this._SQLDateToDateTime(
						data.decolagem_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.decolagem_utc = ''
				}

				if (data.corte_utc != null) {
					this.form.corte_utc = this._SQLDateToDateTime(
						data.corte_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.corte_utc = ''
				}

				if (data.acionamento_utc != null) {
					this.form.acionamento_utc = this._SQLDateToDateTime(
						data.acionamento_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.acionamento_utc = ''
				}

				this.form.horimetro_inicial = this.toNumber1Casa(data.horimetro_partida)
				this.form.horimetro_final = this.toNumber1Casa(data.horimetro_corte)

				this.form.horimetro_inicial_manutencao = this.toNumber1Casa(
					data.horimetro_inicial_manutencao
				)
				this.form.horimetro_final_manutencao = this.toNumber1Casa(
					data.horimetro_final_manutencao
				)

				// ouve alteração do horimetro
				if (
					(
						this.form.horimetro_inicial_manutencao +
						Number(this.form.tempo_voo_motor)
					).toFixed(1) != this.form.horimetro_final_manutencao
				) {
					this.form.alteradoPeloMecanico = true
				}

				this.form.combustivel = Number(data.combustivel).toFixed(0)
				this.form.partidas = Number(data.partidas)
				this.form.gancho = Number(data.gancho)
				this.form.pousos = Number(data.pousos)
				this.form.guincho = Number(data.guincho)
				this.form.unidade_combustivel = data.unidade_combustivel
				this.form.flir = data.flir
				this.form.ovn = data.ovn
				this.form.voo = data.voo

				if (data.discrepancia.length > 0) {
					this.form.discrepancia = data.discrepancia.map((item) => {
						item.id_usuario = item.id_usuario_discrepancia
						item.descricao = item.descricao_discrepancia
						var pilot = _.find(this._pilotos_mecanicos, (o) => {
							return o.id_usuario == item.id_usuario_discrepancia
						})
						let ata = _.find(this.listaAtas, (o) => o.id == item.id_ata)

						item.trigrama = _.isNil(pilot) ? '' : pilot.trigrama
						item.anac = _.isNil(pilot)
							? ''
							: pilot.codigo_anac != ''
							? pilot.codigo_anac
							: 'N/A'
						item.nome = _.isNil(pilot) ? '' : pilot.nome
						item.erroUsuario = ''
						item.erroDescricao = ''
						item.erroTipo = ''
						item.ata = _.isNil(ata) ? '' : ata
						return item
					})
				}
			}

			if (!_.isNil(data.trecho_motor)) {
				this.form.monitoramento_motor = data.trecho_motor.map((item) => {
					item.rpm = Number(item.rpm)
					item.ng = Number(item.ng)
					item.nl = Number(item.nl)
					item.fuel_flow = Number(item.fuel_flow)
					item.itt = Number(item.itt)
					item.tq = Number(item.tq)
					return item
				})

				this.form.trecho_motor = data.trecho_motor.map((item) => {
					item.erro_ciclo_nf = ''
					item.erro_ciclo_ng = ''
					item.erro_ciclo_np = ''
					item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
					item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
					item.ciclo_np = this.toNumber2Casa(item.ciclo_np)
					item.total_horimetro = this.toNumber2Casa(item.total_horimetro)
					return item
				})
			}

			if (!_.isNil(data.ocorrencias)) {
				if (data.ocorrencias.length > 0) {
					this.form.ocorrencias = data.ocorrencias.map((item) => {
						item.erro_data = ''
						item.erro_local = ''
						item.erro_codigo_classificacao = ''
						item.erro_qualificacao_civil = ''
						item.erro_descricao_fatos = ''
						item.data = this._SQLDateToDateTime(
							item.data,
							$sessao.getDateFormat() + ' HH:MM'
						)

						return item
					})
				}
			}

			this.form.para = data.para
			this.form.para_select = _.find(this.rotaER, (o) => {
				return o.sigla == data.para
			})
			this.form.nome_estado_para = data.estado_termino_missao
			if (this.form.nome_estado_para) {
				var estado = _.find(this.estados, (o) => {
					return (
						o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
					)
				})
			}
			this.loadPara = true
			if (estado) {
				this.carregaCidades((callback) => {
					this.loadPara = false
					this.cidadesPara = callback.lista
					this.form.nome_cidade_para = data.cidade_termino_missao
					this.form.nome_estado_para = data.estado_termino_missao
					this.form.lat_fim = data.lat_fim
					this.form.lng_fim = data.lng_fim
					// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
				}, estado.id)
			}

			this.form.de = data.de
			this.form.de_select = _.find(this.rotaER, (o) => {
				return o.sigla == data.de
			})
			this.form.nome_estado_de = data.estado_inicio_missao
			if (this.form.nome_estado_de) {
				var estado = _.find(this.estados, (o) => {
					return o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
				})
			}
			this.loadDe = true
			if (estado) {
				this.carregaCidades((callback) => {
					this.loadDe = false
					this.cidadesDe = callback.lista
					this.form.nome_cidade_de = data.cidade_inicio_missao
					this.form.nome_estado_de = data.estado_inicio_missao
					this.form.lat_inicio = data.lat_inicio
					this.form.lng_inicio = data.lng_inicio
					// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
				}, estado.id)
			}
			// pega os dados do piloto
			if (
				!this.isVisualizarDiarioOperadorOuPiloto &&
				this.form.tripulacao.length > 0 &&
				data.tripulacao.length > 0
			) {
				this.form.tripulacao[0].id_usuario = data.tripulacao[0].id_usuario
				this.form.tripulacao[0].erroUsuario = ''
				this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
					data.tripulacao[0].apresentacao,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.form.tripulacao[0].erroApresentacao = ''
				this.form.tripulacao[0].codigo_ovn = data.tripulacao[0].codigo_ovn
				this.form.tripulacao[0].erroOVN = ''
				this.form.tripulacao[0].usuarios = []

				this.form.tripulacao[0].uso_ovn =
					data.tripulacao[0].id_ovn == null ? false : data.tripulacao[0].uso_ovn
				this.form.tripulacao[0].tempoOvn = parseFloat(
					data.tripulacao[0].tempo_ovn
				)
				this.form.tripulacao[0].erroTempoOvn = ''
				this.form.tripulacao[0].erroUsoOvn = ''
				this.form.tripulacao[0].id_ovn = data.tripulacao[0].id_ovn
				this.form.tripulacao[0].erroIdOvn = ''

				this.carregaUsuariosTripulacao(
					data.tripulacao[0].funcao,
					0,
					false,
					true
				)

				var verificaComando =
					this.form.voo_instrucao == 0
						? 'piloto em comando'
						: 'piloto em instrução'
				for (var i in data.tripulacao) {
					if (data.tripulacao[i].funcao != null) {
						if (
							Number(data.tripulacao[i].id_usuario) != 0 &&
							data.tripulacao[i].funcao.toLowerCase() != verificaComando
						) {
							this.form.tripulacao.push({
								id_usuario: data.tripulacao[i].id_usuario,
								erroUsuario: '',
								funcao: data.tripulacao[i].funcao,
								anac: data.tripulacao[i].anac,
								apresentacao: this._SQLDateToDateTime(
									data.tripulacao[i].apresentacao,
									$sessao.getDateFormat() + ' HH:MM'
								),
								erroApresentacao: '',
								codigo_ovn: data.tripulacao[i].codigo_ovn,
								usuarios: [],
								nome: '',
								trigrama: '',
								erroFuncao: '',
								uso_ovn:
									data.tripulacao[i].id_ovn == null
										? false
										: data.tripulacao[i].uso_ovn,
								tempoOvn: parseFloat(data.tripulacao[i].tempo_ovn),
								erroUsoOvn: '',
								id_ovn: data.tripulacao[i].id_ovn,
								erroIdOvn: '',
								erroTempoOvn: '',
								erroOVN: ''
							})

							this.carregaUsuariosTripulacao(
								data.tripulacao[i].funcao,
								i,
								false,
								true
							)
						}
					}
				}
			} else {
				this.form.tripulacao = data.tripulacao.map((tripulacao) => ({
					...tripulacao,
					apresentacao: this._SQLDateToDateTime(
						tripulacao.apresentacao,
						window.$sessao.getDateFormat() + ' HH:MM'
					),
					erroUsuario: '',
					erroApresentacao: '',
					erroFuncao: '',
					erroUsoOvn: '',
					erroIdOvn: '',
					erroOVN: ''
				}))
			}

			this.form.passageiro = data.passageiro.map((it) => {
				it._tipo = it.tipo
				it.nomeErro = ''
				it.orgaoErro = ''
				it.cargoErro = ''
				it.cpfErro = ''
				it.telefoneErro = ''
				it.sexoErro = ''

				if (!_.isNil(it.data_nascimento)) {
					it.data_nascimento = this._SQLDateToDate(
						it.data_nascimento,
						$sessao.getDateFormat()
					)
				}
				return it
			})
			if (Array.isArray(data.trecho_carga) && data.trecho_carga.length > 0) {
				this.form.carga = true
				this.form.peso_carga = parseFloat(data.trecho_carga.reduce((acumulador, carga) => parseFloat(acumulador) + parseFloat(carga.peso), 0));
			}

			if (data.descricao_carga) {
				this.form.cargaArray.push({
					id: 0,
					descricao: data.descricao_carga,
					carga_liquida: false,
					peso: data.peso_carga,
					volume: '',
					altura: '',
					comprimento: '',
					largura: '',
					tipo_embalagem: '',
					tipo_carga: '',
					carga_perigosa: false,
					carga_fragil: false,
					id_passageiro: '',
					selecionado: true,
					id_pass_erro: '',
					erroEmbalagem: '',
					descricaoErro: '',
					pesoErro: '',
					erro_tipo_carga: ''
				})

				this.form.descricao_carga = null
				this.form.carga_liquida = null
			}

			this.form.cargaArray = []

			if (Array.isArray(data.trecho_carga)) {
				this.form.cargaArray = data.trecho_carga.map((carga) => {
					carga.descricaoErro = ''
					carga.pesoErro = ''
					carga.erro_tipo_carga = ''
					carga.id_pass_erro = ''
					carga.erroEmbalagem = ''
					carga.tipo_carga = carga.id_tipo_carga
					carga.tipo_embalagem = carga.id_tipo_embalagem_carga
					carga.peso = parseFloat(carga.peso)
					return carga
				})
			}

			this.form.base = data.base
			this.form.numero_bo = data.numero_bo
			this.form.numero_chamada = data.numero_chamado
			this.form.numero_atividade = data.numero_atividade

			// para o histórico, antes tinha so a descrição, depois criamos uma tabela, então para não dar pau no histórico
			// verifico se o id e null, se for carrega pela descrição, se tiver id, carrega pelo id
			if (_.isNil(data.id_tipo_missao)) {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.descricao == data.descricao_tipo_missao
				})
			} else {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.id == data.id_tipo_missao
				})
			}

			if (!_.isNil(data.id_tipo_natureza)) {
				this.form.tipo_natureza = _.find(this.tiposDeNaturezas, (o) => {
					return o.id == data.id_tipo_natureza
				})
			}

			// this.form.tipo_missao = _.find(this.tiposDeMissoes, o => {return o.id == data.id_tipo_missao})
			this.form.descricao = data.descricao_missao
			if (this._idCliente != 41) {
				this.form.subclassificacao =
					data.id_subclassificacao != null
						? this.getSubclassificacaoById(data.id_subclassificacao)
						: ''
			}
			this.form.houve_contexto = this.validaNull(data.houve_contexto)

			if (this.form.houve_contexto != null) {
				for (var i in this.contextos) {
					if (this.contextos[i].id == data.id_contexto_operativo) {
						this.form.contexto_operativo = this.contextos[i]
					}
				}
			}

			// orgaos recebidos
			this.form.orgao = []
			_.forEach(data.orgao, (org) => {
				var orgao_apoiado = {}
				var orgao = _.find(this.orgaos, (o) => {
					return o.id == org.id
				})
				orgao_apoiado.erroOrgao = ''
				orgao_apoiado.erroTempoVoo = ''
				orgao_apoiado.orgao = orgao
				orgao_apoiado.tempo_voo = Number(org.tempo_voo).toFixed(2)
				var unidades = []

				_.forEach(org.unidade, (unidade) => {
					var uni = _.find(orgao_apoiado.orgao.unidade, (o) => {
						return o.id == unidade.id_orgao_apoiado_unidade
					})

					if (!_.isNil(uni)) {
						uni.erroUnidade = ''
						unidades.push({unidade: uni, erroUnidade: ''})
					}
				})

				orgao_apoiado.unidade = unidades
				this.form.orgao.push(orgao_apoiado)
			})

			this.form.observacao = data.observacao

			this.form.coracao = Number(data.coracao)
			this.form.rim = Number(data.rim)
			this.form.figado = Number(data.figado)
			this.form.cornea = Number(data.cornea)
			this.form.esclero = Number(data.esclero)
			this.form.pancreas = Number(data.pancreas)
			this.form.baco = Number(data.baco)

			this.form.socorrido = Number(data.socorrido)
			this.form.bambi = Number(data.bambi)
			this.form.brigadista = Number(data.brigadista)
			this.form.natureza_voo = data.natureza_voo

			// se for um array
			if (_.isArray(data.unidade_conservacao)) {
				// se existir unidade de conservação
				if (data.unidade_conservacao.length > 0) {
					this.form.unidade_conservacao = data.unidade_conservacao.map(
						(item) => {
							return {
								obj: _.find(this.unidadesConservacao, (o) => {
									return item.id_unidade_conservacao == o.id
								}),
								erro: ''
							}
						}
					)

					//console.log(this.form.unidade_conservacao)
				}
			} else {
				// antes era uma string
				if (data.unidade_conservacao != '') {
					this.form.unidade_conservacao.push({
						obj: _.find(this.basesOperacao, (o) => {
							o.sigla == data.unidade_conservacao
						})
					})
				}
			}

			this.form.base_origem = data.base_origem

			this.calculaTempoDeVooPiloto()
			this.calculaTempoManutencao()

			if (this.visualizar) {
				this.$nextTick(() => {
					this.$refs.printVisualizar.carregaDados({
						data: this.form,
						aero: this.aeronave,
						pilotos: this._pilotos_mecanicos,
						trecho: this.trecho,
						ovns: this.ovns
					})
				})
			}

			this.form.adicao_oleo_lubrificante = data.adicao_oleo_lubrificante
			this.form.fornecedor_oleo_lubrificante =
				data.id_fornecedor_oleo_lubrificante
			this.form.numero_ce_oleo_lubrificante = data.numero_ce_oleo_lubrificante
			this.form.campo_lubrificacao_1 = data.campo_lubrificacao_1
			this.form.campo_lubrificacao_2 = data.campo_lubrificacao_2
			this.form.campo_lubrificacao_3 = data.campo_lubrificacao_3
			this.form.campo_lubrificacao_4 = data.campo_lubrificacao_4
			this.form.campo_lubrificacao_5 = data.campo_lubrificacao_5
			this.form.observacoes_oleo_lubrificante =
				data.observacoes_oleo_lubrificante
			this.edicao_mecanico_oleo_lubrificante =
				data.edicao_mecanico_oleo_lubrificante

			this.form.ifr_simulado = data.ifr_simulado
			this.form.hora_ifr_simulado = data.hora_ifr_simulado

			this._httpGet(
				`Aeronave/get_dados_oleo_lubrificante/${this.trecho.id_aeronave}`,
				(response) => {
					if (response._request && response._status) {
						this.dadosOleoLubrificante = response.lista
					}
				}
			)
		},

		toNumber1Casa(val) {
			return Number(Number(val).toFixed(1))
		},

		toNumber2Casa(val) {
			return Number(Number(val).toFixed(2))
		},

		blurCarregaCidades(tipo, reseta) {
			if (tipo == 'de') {
				if (this.form.nome_estado_de != '') {
					if (reseta) {
						this.form.nome_cidade_de = ''
					}

					var estado = _.find(this.estados, (o) => {
						return (
							o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
						)
					})

					this.loadDe = true
					this.carregaCidades((callback) => {
						this.loadDe = false
						this.cidadesDe = callback.lista
						// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}

			if (tipo == 'para') {
				if (this.form.nome_estado_para != '') {
					if (reseta) {
						this.form.nome_cidade_para = ''
					}

					var estado = _.find(this.estados, (o) => {
						return (
							o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
						)
					})
					this.loadPara = true
					this.carregaCidades((callback) => {
						this.loadPara = false
						this.cidadesPara = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}

			if (tipo == 'vor' && this.mostraVor) {
				if (this.form.verificacao_vor[0].id_estado != '') {
					if (reseta) {
						this.form.verificacao_vor[0].id_cidade = ''
					}

					var estado = _.find(this.estados, (o) => {
						return o.id == this.form.verificacao_vor[0].id_estado
					})

					this.loadVor = true
					this.carregaCidades((callback) => {
						this.loadVor = false
						this.cidadesVor = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}
		},

		clickExibeModalSalvar() {
			if (this.validaForm() == true) {
				if (!this.editar) {
					// se o piloto for quem estiver preenchendo o diário, pede pra assinar
					if (this.form.tripulacao[0].id_usuario == $sessao.getId()) {
						this.assinar = true
					}
				}

				this.revisar = false
				this.cienteAssinatura = false
				this.$refs.modalConfirmacao.modalShow(50)
				//this._exibeModal('modal-ordem-confirma-salvar', 50)
			} else {
				bus.$emit('exibir-notificacao', {
					type: 'danger',
					text: 'Corrija os campos em vermelho.'
				})
			}
		},

		clickSolicitarEdicao() {
			this.$refs.modalSolicitacaoEdicao.exibirModal(this.form.id, 'SOLICITACAO')
		},

		solicitacaoSalva() {
			if (this.editar && this.form.id_assinatura_piloto != '') {
				this.salvouSolicitacao = true
			}
		},

		clickSalvar(assinarSalvar = null) {
			if (this.validaForm()) {
				var id_usuario_piloto = 0
				if (this.editar && this.form.id_assinatura_piloto != '') {
					if (!this.salvouSolicitacao) {
						this.$refs.modalSolicitacaoEdicao.exibirModal(
							this.form.id,
							'ASSINATURA'
						)
						return false
					}
				}

				if (
					this.form.horimetro_inicial == '' ||
					this.form.horimetro_inicial == 0 ||
					_.isNil(this.form.horimetro_inicial) ||
					_.isNaN(this.form.horimetro_inicial)
				) {
					return false
				}

				if (
					this.form.horimetro_final == '' ||
					this.form.horimetro_final == 0 ||
					_.isNil(this.form.horimetro_final) ||
					_.isNaN(this.form.horimetro_final)
				) {
					return false
				}

				this.formPost = {
					milhas_navegacao: this.form.milhas_navegacao,
					id_usuario: $sessao.getId(),
					id_aeronave: this.aeronave.id,
					//tempo_voo_celula: this.form.tempo_voo_celula,
					voo_instrucao: this.form.voo_instrucao,
					pax: this.disablePaxPob ? '' : this.form.pax,
					pob: this.disablePaxPob ? '' : this.form.pob,
					tempo_voo_motor: this.form.tempo_voo_motor,
					horimetro_inicial: this.form.horimetro_inicial,
					horimetro_final: this.form.horimetro_final,
					decolagem: this._dateTimeToDateSQL(
						this.form.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					),
					pouso: this._dateTimeToDateSQL(
						this.form.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					),
					id: this.trecho.id,
					tipo_voo: this.form.tipo_voo,
					acionamento: this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					),
					corte: this._dateTimeToDateSQL(
						this.form.corte,
						$sessao.getDateFormat() + ' HH:MM'
					),
					acionamento_utc: this._dateTimeToDateSQL(
						this.form.acionamento_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),
					decolagem_utc: this._dateTimeToDateSQL(
						this.form.decolagem_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),
					pouso_utc: this._dateTimeToDateSQL(
						this.form.pouso_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),
					corte_utc: this._dateTimeToDateSQL(
						this.form.corte_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),

					lat_inicio: this.form.lat_inicio,
					lat_fim: this.form.lat_fim,
					lng_inicio: this.form.lng_inicio,
					lng_fim: this.form.lng_fim,

					horimetro_apu:
						this.aeronave.apu_aeronave.length > 0
							? this.form.horimetro_apu
							: '',

					id_aeronave_import:
						this.aeronave_import != ''
							? this.aeronave_import.id_aeronave
							: null,

					ultima_intervencao: this.form.ultima_intervencao,
					proxima_intervencao: this.form.proxima_intervencao,
					horimetro_proxima: this.form.horimetro_proxima,
					numero_ce: this.form.numero_ce,
					volume: this.form.volume,
					id_unidade_armazenamento: this.form.id_unidade_armazenamento,
					id_abastecimento_comprovante: this.form.id_abastecimento_comprovante,
					abastecimento_original: this.movimentacaoCombustivel.original,
					abastecimento_origem: this.movimentacaoCombustivel.origem,
					id_responsavel_retorno: this.form.id_responsavel_retorno,
					nome_usuario_retorno: this.form.nome_usuario_retorno,
					descricao_ultima_inspecao: this.form.descricao_ultima_inspecao,
					descricao_proxima_inspecao: this.form.descricao_proxima_inspecao,

					monitoramento_motor: this.form.monitoramento_motor.map((item) => {
						return {
							altitude: item.altitude,
							oat: item.oat,
							ias: item.ias,
							rpm: item.rpm,
							id_motor: item.id_motor,
							ng: item.ng,
							nl: item.nl,
							fuel_flow: item.fuel_flow,
							itt: item.itt,
							tq: item.tq,
							abastecimento_oleo: item.abastecimento_oleo
						}
					}),

					verificacao_vor: this.form.verificacao_vor,
					vor: this.form.vor,
					radial_vor: this.form.radial_vor,
					afastamento_vor: this.form.afastamento_vor,
					erro_vor: this.form.erro_vor,

					objetivo_alcancado: this.form.objetivo_alcancado,

					finalizar_ordem: this.form.finalizar_ordem,
					finalizar_despacho: this.form.finalizar_despacho,
					id_despacho: this.despacho != '' ? this.despacho.id : null,

					de: this.form.de,
					nome_estado_de: this.form.nome_estado_de,
					nome_cidade_de: this.form.nome_cidade_de,
					unidade_combustivel: this.form.unidade_combustivel,

					gancho: this.form.gancho,
					guincho: this.form.guincho,
					base: this.form.base,

					trecho_carga: this.form.cargaArray.map((carga) => {
						carga.id_tipo_embalagem_carga = carga.tipo_embalagem
						carga.id_tipo_carga = carga.tipo_carga
						return carga
					}),

					para: this.form.para,
					nome_estado_para: this.form.nome_estado_para,
					nome_cidade_para: this.form.nome_cidade_para,
					horimetro_inicial_manutencao: this.form.horimetro_inicial_manutencao,
					horimetro_final_manutencao: this.form.horimetro_final_manutencao,

					vfr_diurno: this.form.vfr_diurno,
					hora_vfr_diurno: this.form.hora_vfr_diurno,
					vfr_noturno: this.form.vfr_noturno,
					hora_vfr_noturno: this.form.hora_vfr_noturno,
					ifr: this.form.ifr,
					vfr: this.form.vfr,
					hora_ifr: this.form.hora_ifr,
					hora_vfr: this.form.hora_vfr,
					navegacao: this.form.navegacao,
					hora_navegacao: this.form.hora_navegacao,
					ifr_simulado: this.form.ifr_simulado,
					hora_ifr_simulado: this.form.hora_ifr_simulado,
					//instrucao: this.form.instrucao,
					total: this.form.total,
					// ciclo_ng: this.form.ciclo_ng,
					// ciclo_nf: this.form.ciclo_nf,
					numero_voo: this.form.numero_voo,

					combustivel: this.form.combustivel,
					partidas: this.form.partidas,
					pousos: this.form.pousos,

					id_tipo_missao: this.form.tipo_missao.id,
					id_tipo_natureza: this.form.tipo_natureza.id,
					observacao: this.form.observacao,

					// missao_inicio: this._dateTimeToDateSQL(this.form.missao_inicio, $sessao.getDateFormat() + ' HH:MM'),
					// missao_fim: this._dateTimeToDateSQL(this.form.missao_fim, $sessao.getDateFormat() + ' HH:MM'),
					natureza_voo: this.form.natureza_voo,

					descricao: this.form.descricao.descricao || this.form.descricao,

					//id_classificacao: this.form.classificacao.id,
					id_subclassificacao: this.form.subclassificacao
						? this.form.subclassificacao.id
						: '',

					unidade_conservacao: this.form.unidade_conservacao.map((item) => {
						return {id: _.isNil(item.obj.id) ? 0 : item.obj.id}
					}),
					base_origem: this.form.base_origem,

					coracao: this.form.coracao,
					rim: this.form.rim,
					figado: this.form.figado,
					cornea: this.form.cornea,
					esclero: this.form.esclero,
					pancreas: this.form.pancreas,
					baco: this.form.baco,

					carga: this.form.carga,
					descricao_carga: this.form.descricao_carga,
					carga_liquida: this.form.carga_liquida,
					peso: this.form.peso_carga,

					socorrido: this.form.socorrido,
					existe_unidade_conservacao: this.form.existe_unidade_conservacao,
					bambi: this.form.bambi,
					brigadista: this.form.brigadista,

					auto_localizado: this.form.auto_localizado,
					arma_apreendida: this.form.arma_apreendida,
					pessoa_salva: this.form.pessoa_salva,
					pessoa_detida: this.form.pessoa_detida,
					valor_recuperado: this.form.valor_recuperado,

					houve_contexto: this.form.houve_contexto,
					contexto_operativo:
						this.form.contexto_operativo == ''
							? ''
							: this.form.contexto_operativo.id,

					numero_atividade: this.form.numero_atividade,
					numero_bo: this.form.numero_bo,
					numero_chamado: this.form.numero_chamada,

					ovn: this.form.ovn,
					flir: this.form.flir,

					adicao_oleo_lubrificante: this.form.adicao_oleo_lubrificante,
					id_fornecedor_oleo_lubrificante:
						this.form.fornecedor_oleo_lubrificante,
					numero_ce_oleo_lubrificante: this.form.numero_ce_oleo_lubrificante,
					campo_lubrificacao_1: this.form.campo_lubrificacao_1,
					campo_lubrificacao_2: this.form.campo_lubrificacao_2,
					campo_lubrificacao_3: this.form.campo_lubrificacao_3,
					campo_lubrificacao_4: this.form.campo_lubrificacao_4,
					campo_lubrificacao_5: this.form.campo_lubrificacao_5,
					observacoes_oleo_lubrificante:
						this.form.observacoes_oleo_lubrificante,

					trecho_motor: this.form.trecho_motor.map((item) => {
						return {
							id: item.id,
							ciclo_nf: item.ciclo_nf,
							ciclo_ng: item.ciclo_ng,
							ciclo_np: item.ciclo_np,
							descricao: item.descricao,
							id_motor: item.id_motor,
							id_relatorio_voo_trecho: item.id_relatorio_voo_trecho,
							serial_number: item.serial_number,
							tempo_voo: item.tempo_voo,
							tipo_aeronave: item.tipo_aeronave
						}
					}),
					tripulacao: this.form.tripulacao.map((item) => {
						var trip = {
							id_usuario: item.id_usuario,
							apresentacao:
								item.apresentacao != ''
									? this._dateTimeToDateSQL(
											item.apresentacao,
											$sessao.getDateFormat() + ' HH:MM'
									  )
									: '',
							codigo_ovn: item.codigo_ovn,
							anac: item.anac,
							funcao: item.funcao,
							nome: item.nome,
							trigrama: item.trigrama,
							uso_ovn: item.uso_ovn,
							tempoOvn: item.tempoOvn,
							id_ovn: item.id_ovn
						}

						if (item.funcao.toUpperCase() == 'PILOTO EM COMANDO') {
							id_usuario_piloto = item.id_usuario
						}

						return trip
					}),

					discrepancia: this.form.discrepancia.map((item) => {
						return {
							id: item.id,
							id_usuario: item.id_usuario,
							descricao: item.descricao,
							anac: item.anac,
							tipo: item.tipo,
							id_ata: _.isNil(item.ata) ? '' : item.ata.id
						}
					}),

					passageiro: this.form.passageiro.map((item) => {
						var pass = {
							tipo: item.tipo,
							nome: item.nome,
							orgao: item.orgao,
							cargo: item.cargo,
							cpf: item.cpf,
							telefone: item.telefone,
							data_nascimento: this._dateToDateSQL(
								item.data_nascimento,
								$sessao.getDateFormat()
							),
							idade_aparente: item.idade_aparente,
							sexo: item.sexo,
							id_passageiro: item.id_passageiro
						}
						return pass
					}),

					ocorrencias: this.form.ocorrencias.map((item) => {
						return {
							id: item.id,
							data:
								item.data != ''
									? this._dateTimeToDateSQL(
											item.data,
											$sessao.getDateFormat() + ' HH:MM'
									  )
									: '',
							local: item.local,
							codigo_classificacao: item.codigo_classificacao,
							qualificacao_civil: item.qualificacao_civil,
							descricao_fatos: item.descricao_fatos
						}
					}),

					ocorrencia: this.form.ocorrencias.length > 0 ? '1' : '0',
					orgao: this.form.orgao.map((item) => {
						var org = {
							id: item.orgao.id,
							tempo_voo: item.tempo_voo,
							unidade: []
						}

						if (item.unidade.length > 0) {
							org.unidade = item.unidade.map((it) => {
								return {id: it.unidade.id}
							})
						}

						return org
					}),

					assinar_salvar: assinarSalvar
				}

				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

				if (this.habilitaPerformanceMotor == 1) {
					if (this.form.quantidadeMotores == 1) {
						const id_motor_esquerdo = this.form.monitoramento_motor[0].id_motor

						var monitoramentoMotorEsquerdo = new Object()
						monitoramentoMotorEsquerdo.data =
							this.form.horario_performance_motor
						monitoramentoMotorEsquerdo.id_motor = this.id_motor_esquerdo
						monitoramentoMotorEsquerdo.fl = this.form.performance_fl
						monitoramentoMotorEsquerdo.tat = this.form.performance_tat
						monitoramentoMotorEsquerdo.ias = this.form.performance_ias
						monitoramentoMotorEsquerdo.tas = this.form.performance_tas
						monitoramentoMotorEsquerdo.boost = this.form.performance_boost

						monitoramentoMotorEsquerdo.tq = this.form.performance_torque_esq
						monitoramentoMotorEsquerdo.np = this.form.performance_np_esq
						monitoramentoMotorEsquerdo.itt = this.form.performance_itt_esq
						monitoramentoMotorEsquerdo.nh = this.form.performance_nh_esq
						monitoramentoMotorEsquerdo.fuel_flow =
							this.form.performance_flow_esq
						monitoramentoMotorEsquerdo.nl = this.form.performance_nl_esq

						this.formPost.monitoramento_motor[0] = monitoramentoMotorEsquerdo
					} else if (this.form.quantidadeMotores == 2) {
						const id_motor_esquerdo = this.form.monitoramento_motor[1].id_motor
						const id_motor_direito = this.form.monitoramento_motor[0].id_motor

						var monitoramentoMotorEsquerdo = new Object()
						monitoramentoMotorEsquerdo.data =
							this.form.horario_performance_motor
						monitoramentoMotorEsquerdo.id_motor = this.id_motor_esquerdo
						monitoramentoMotorEsquerdo.fl = this.form.performance_fl
						monitoramentoMotorEsquerdo.tat = this.form.performance_tat
						monitoramentoMotorEsquerdo.ias = this.form.performance_ias
						monitoramentoMotorEsquerdo.tas = this.form.performance_tas
						monitoramentoMotorEsquerdo.boost = this.form.performance_boost

						monitoramentoMotorEsquerdo.tq = this.form.performance_torque_esq
						monitoramentoMotorEsquerdo.np = this.form.performance_np_esq
						monitoramentoMotorEsquerdo.itt = this.form.performance_itt_esq
						monitoramentoMotorEsquerdo.nh = this.form.performance_nh_esq
						monitoramentoMotorEsquerdo.fuel_flow =
							this.form.performance_flow_esq
						monitoramentoMotorEsquerdo.nl = this.form.performance_nl_esq
						this.formPost.monitoramento_motor[1] = monitoramentoMotorEsquerdo

						var monitoramentoMotorDireito = new Object()
						monitoramentoMotorDireito.data = this.form.horario_performance_motor
						monitoramentoMotorDireito.id_motor = this.id_motor_direito
						monitoramentoMotorDireito.fl = this.form.performance_fl
						monitoramentoMotorDireito.tat = this.form.performance_tat
						monitoramentoMotorDireito.ias = this.form.performance_ias
						monitoramentoMotorDireito.tas = this.form.performance_tas
						monitoramentoMotorDireito.boost = this.form.performance_boost

						monitoramentoMotorDireito.tq = this.form.performance_torque_dir
						monitoramentoMotorDireito.np = this.form.performance_np_dir
						monitoramentoMotorDireito.itt = this.form.performance_itt_dir
						monitoramentoMotorDireito.nh = this.form.performance_nh_dir
						monitoramentoMotorDireito.fuel_flow = this.form.performance_flow_dir
						monitoramentoMotorDireito.nl = this.form.performance_nl_dir
						this.formPost.monitoramento_motor[0] = monitoramentoMotorDireito
					}
				}

				this.formPost.id_usuario_piloto = id_usuario_piloto

				// se não for meio ambiente, limpa as unidades
				if (this.formPost.id_tipo_missao != 3) {
					this.formPost.unidade_conservacao = []
				} else {
					// se for meio ambiente, verifica se existe unidades
					if (this.formPost.existe_unidade_conservacao == '0') {
						this.formPost.unidade_conservacao = []
					}
				}

				// console.log("ESTOU LHE ENVIANDO", this.formPost)

				this._httpPost(
					'mg-siga/Relatorio_voo_trecho/salvar',
					this.formPost,
					(response) => {
						//console.log("ESTOU RECEBENDO", response)
						bus.$emit('load-out')

						if (response._request) {
							// ao fechar o modal roda a função modalCarregaAssinatura()
							this.$refs.modalConfirmacao.modalHide()
							this.limpaTimeOuts()

							// se for somente salvar, exibe a msg de diario salvo e volta pra lista
							if (this.assinarESalvar) {
								bus.$emit('exibir-notificacao', {
									type: 'success',
									text: `${_traducao('global', 'alteracoesEdicao')}`
								})
								bus.$off('modal-fechou')
								this.$refs.modalSalvarModificacoes.modalHide()
								this.voltaLista()
							} else {
								bus.$off('modal-fechou')
								this.$refs.modalSalvarModificacoes.modalHide()
								this.voltaLista()
							}
						}
					}
				)
			}
		},

		modalCarregaAssinatura() {
			this.$refs.modalConfirmacao.modalHide()

			if (!this.revisar) {
				if (this.assinar) {
					var obj = {
						id_usuario: $sessao.getId(),
						id_aeronave: this.aeronave.id,
						tempo_voo_celula: this.form.tempo_voo_celula,
						tempo_voo_motor: this.form.tempo_voo_motor,
						horimetro_inicial: this.form.horimetro_inicial,
						horimetro_final: this.form.horimetro_final,
						decolagem: this.form.decolagem,
						pouso: this.form.pouso,
						id: this.trecho.id,
						tipo_voo: this.form.tipo_voo,
						acionamento: this.form.acionamento,
						corte: this.form.corte
						//nome_pdf: this.aeronave.prefixo +'-'+ this.trecho.numero_diario + '.pdf'
					}

					// chama o component de assinatura
					this.$refs.assinatura.carregaAssinatura(obj)
				} else {
					bus.$emit('exibir-notificacao', {
						type: 'success',
						text: this._traducao('global', 'salvo')
					})
					//
					this.voltaLista()
				}
			}
		},

		// retorno da assinatura
		validaAssinatura(retorno) {
			bus.$emit('load-in', {text: this._traducao('global', 'assinando')})
			var data = {
				id_assinatura: retorno.assinatura.id,
				id_usuario: $sessao.getId(),
				id_relatorio_voo_trecho: retorno.data.id
			}

			//bus.$emit('load-in', {text: this._traducao('global', 'assinando')})
			if (this.form.tripulacao[0].id_usuario == data.id_usuario) {
				this.assinarESalvar = true
			}
			// salva a assinatura
			this._httpPost(
				'mg-siga/Relatorio_voo_trecho/assinatura_piloto',
				data,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						if (this.assinarESalvar) {
							this.clickSalvar(data.id_assinatura)
						} else {
							this.voltaLista()
							bus.$emit('exibir-notificacao', {
								type: 'success',
								text: this._traducao('global', 'trechoAssinado')
							})
							bus.$off('modal-fechou')
						}
					}
				}
			)
		},

		calculaTempoDeVooPiloto() {
			if (this.form.acionamento != '' && this.form.corte != '') {
				this.form.tempo_voo_piloto = this._timeToDecimal(
					this.form.acionamento,
					this.form.corte
				)
			}
		},

		calculaTempoManutencao() {
			if (this.form.decolagem != '' && this.form.pouso != '') {
				this.form.tempo_voo_motor = this._timeToDecimal(
					this.form.decolagem,
					this.form.pouso
				)
			}
		},

		calculaTotal() {
			if(!this.editar){
				if (this.aeronave.tipo == 'H') {
				this.form.horimetro_final =
					this.form.horimetro_inicial + Number(this.form.tempo_voo_piloto)
				this.form.horimetro_final_manutencao =
					this.form.horimetro_inicial_manutencao +
					Number(this.form.tempo_voo_motor)
				} else {
				this.form.horimetro_final =
					this.form.horimetro_inicial + Number(this.form.tempo_voo_motor)
				this.form.horimetro_final_manutencao =
					this.form.horimetro_inicial_manutencao +
					Number(this.form.tempo_voo_motor)
				}
			}
		},

		validaForm() {
			var erroData = this._traducao('global', 'erroDataOvn')
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')
			var obrig = this._traducao('global', 'obrigacao') + '.'
			var preenchaPeloMenosUmCampo = this._traducao(
				'global',
				'preenchaPeloMenosUmCampo'
			)
			// valida o corte e o acionamento do motor
			if (this.form.acionamento == '') {
				this.erro.acionamento = obrig
				passou = false
			} else {
				this.erro.acionamento = ''
			}

			if (this.form.ocorrencia193Obrigatoria) {
				if (this.form.numero_bo == '') {
					this.erro.numero_bo = obrigatorio
					passou = false
				} else {
					this.erro.numero_bo = ''
				}
			}

			// decolagem
			if (this.form.decolagem == '') {
				this.erro.decolagem = obrig
				passou = false
			} else {
				this.erro.decolagem = ''
			}

			if (this.form.corte == '') {
				this.erro.corte = obrig
				passou = false
			} else {
				this.erro.corte = ''
			}

			//checa se ao menos um dos campos ifr ou vfr esta preenchido
			if (this.form.hora_ifr != '00:00' || this.form.hora_vfr != '00:00' || this.form.hora_ifr_simulado != '00:00') {
				this.erro.ifr = ''
				this.erro.vfr = ''
				this.erro.ifr_simulado = ''
			} else {
				this.erro.ifr = preenchaPeloMenosUmCampo
				this.erro.vfr = preenchaPeloMenosUmCampo
				this.erro.ifr_simulado = preenchaPeloMenosUmCampo
				passou = false
			}

			if (this.erro.navegacao != '') {
				passou = false
			}

			// pouso
			if (this.form.pouso == '') {
				this.erro.pouso = obrig
				passou = false
			} else {
				this.erro.pouso = ''
			}

			// quer dizer q todos campos tao preenchindos
			if (passou) {
				var dtAcionamento = new moment(
					this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				var dtDecolagem = new moment(
					this._dateTimeToDateSQL(
						this.form.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				var dtPouso = new moment(
					this._dateTimeToDateSQL(
						this.form.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				var dtCorte = new moment(
					this._dateTimeToDateSQL(
						this.form.corte,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)

				if (moment(dtAcionamento).isAfter(dtDecolagem)) {
					this.erro.decolagem = 'Decolagem menor que acionamento.'
					passou = false
				} else {
					this.erro.decolagem = ''
				}

				if (moment(dtDecolagem).isAfter(dtPouso)) {
					this.erro.pouso = 'Pouso menor que decolagem.'
					passou = false
				} else {
					this.erro.pouso = ''
				}

				if (moment(dtPouso).isAfter(dtCorte)) {
					this.erro.corte = 'Corte menor que pouso.'
					passou = false
				} else {
					this.erro.corte = ''
				}
			}

			if (this.form.tempo_voo_motor > 8) {
				this.erro.tempo_voo_motor = 'Tempo de voo muito grande'
				passou = false
			} else {
				this.erro.tempo_voo_motor = ''
			}

			if (this.form.tempo_voo_piloto > 8) {
				this.erro.tempo_voo_piloto = 'Tempo de voo muito grande'
				passou = false
			} else {
				this.erro.tempo_voo_piloto = ''
			}

			// valida base
			if (this.form.base == '') {
				passou = false
				this.erro.base = obrigatorio
			} else {
				this.erro.base = ''
			}

			// combustivel
			if (this.form.combustivel == 0) {
				this.erro.combustivel = obrig
				passou = false
			} else {
				this.erro.combustivel = ''
			}

			// unidade de combustivel
			if (this.form.unidade_combustivel == '') {
				this.erro.unidade_combustivel = obrig
				passou = false
			} else {
				this.erro.unidade_combustivel = ''
			}

			// de
			if (this.form.de == '') {
				this.erro.de = obrig
				passou = false
			} else {
				this.erro.de = ''
			}

			// para
			if (this.form.para == '') {
				this.erro.para = obrig
				passou = false
			} else {
				this.erro.para = ''
			}

			if (this.form.horimetro_inicial == 0) {
				this.erro.horimetro_inicial = this._traducao('global', 'erroHorimetro')
				passou = false
			} else {
				this.erro.horimetro_inicial = ''
			}

			// nome_cidade_de
			if (this.form.nome_cidade_de == '') {
				this.erro.nome_cidade_de = obrig
				passou = false
			} else {
				this.erro.nome_cidade_de = ''
			}

			// nome_cidade_para
			if (this.form.nome_cidade_para == '') {
				this.erro.nome_cidade_para = obrig
				passou = false
			} else {
				this.erro.nome_cidade_para = ''
			}

			// nome_estado_de
			if (this.form.nome_estado_de == '') {
				this.erro.nome_estado_de = obrig
				passou = false
			} else {
				this.erro.nome_estado_de = ''
			}

			// nome_estado_para
			if (this.form.nome_estado_para == '') {
				this.erro.nome_estado_para = obrig
				passou = false
			} else {
				this.erro.nome_estado_para = ''
			}

			// valida flir
			if (this.aeronave.tipo == 'H' && this.aeronave.habilita_flir == '1') {
				if (this.form.flir == '') {
					this.erro.flir = obrig
					passou = false
				} else {
					this.erro.flir = ''
				}
			}

			// valida ovn
			/*if (this.aeronave.tipo == 'H' && this.form.ovn == 1) {
				if (this.form.ovn == '') {
					this.erro.ovn = obrig
					passou = false
				} else {
					this.erro.ovn = ''
				}
			}*/

			if (this.aeronave.numero_voo == '1') {
				if (this.form.numero_voo == '') {
					this.erro.numero_voo = obrig
					passou = false
				} else {
					this.erro.numero_voo = ''
				}
			}

			// insere os ciclos manuais
			if (this.aeronave.ciclo_total == '1') {
				_.forEach(this.form.trecho_motor, (item) => {
					if (item.ciclo_ng === '' && this.aeronave.tipo == 'H') {
						item.erro_ciclo_ng = obrig
						passou = false
					} else {
						item.erro_ciclo_ng = ''
					}

					if (item.ciclo_nf === '') {
						item.erro_ciclo_nf = obrig
						passou = false
					} else {
						item.erro_ciclo_nf = ''
					}

					if (item.ciclo_np === '') {
						item.erro_ciclo_np = obrig
						passou = false
					} else {
						item.erro_ciclo_np = ''
					}
				})
			}

			// PILOTO
			if (this.form.tripulacao[0].id_usuario == '') {
				this.form.tripulacao[0].erroUsuario = obrigatorio
				passou = false
			} else {
				this.form.tripulacao[0].erroUsuario = ''
			}
			// valida apresentacao do piloto
			if (this.form.tripulacao[0].apresentacao == '') {
				this.form.tripulacao[0].erroApresentacao = obrigatorio
				passou = false
			} else {
				this.form.tripulacao[0].erroApresentacao = ''

				var dtAcionamento = new moment(
					this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				var apresentacao = new moment(
					this._dateTimeToDateSQL(
						this.form.tripulacao[0].apresentacao,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				if (this._idCliente == 41) {
					if (moment(dtAcionamento).diff(apresentacao, 'minutes') < 30) {
						if (moment(dtAcionamento).diff(apresentacao, 'minutes') >= 0) {
							this.form.tripulacao[0].erroApresentacao =
								'Menor que 30 min anterior ao acionamento.'
						} else {
							this.form.tripulacao[0].erroApresentacao =
								'Maior que o acionamento'
						}
						passou = false
					} else {
						this.form.tripulacao[0].erroApresentacao = ''
					}
				} else {
					if (moment(apresentacao).isAfter(dtAcionamento)) {
						this.form.tripulacao[0].erroApresentacao =
							'Maior que o acionamento.'
						passou = false
					} else {
						this.form.tripulacao[0].erroApresentacao = ''
					}
				}
			}

			//passa a propriedade data_cadastro para a lista de tripulantes para verificacao individual
			for (let tripulante of this.form.tripulacao) {
				const ovnObj = this.ovns.find((ovn) => ovn.id === tripulante.id_ovn)
				if (ovnObj) {
					tripulante.data_cadastro = ovnObj.data_cadastro
				}
			}

			if (
				this.form.tripulacao[0].uso_ovn == null &&
				this.aeronave.habilita_ovn
			) {
				this.form.tripulacao[0].erroUsoOvn = obrig
				passou = false
			} else {
				this.form.tripulacao[0].erroUsoOvn = ''
			}

			if (
				this.form.tripulacao[0].uso_ovn &&
				this.aeronave.habilita_ovn != '0'
			) {
				if (
					this.form.tripulacao[0].id_ovn == null ||
					this.form.tripulacao[0].id_ovn == ''
				) {
					this.form.tripulacao[0].erroIdOvn = obrig
					passou = false
				} else {
					this.form.tripulacao[0].erroIdOvn = ''
				}
			}

			if (this.form.tripulacao[0].uso_ovn && this.aeronave.habilita_ovn != 0) {
				if (
					this.form.tripulacao[0].tempoOvn == null ||
					this.form.tripulacao[0].tempoOvn == 0
				) {
					this.form.tripulacao[0].erroTempoOvn = obrig
					passou = false
				} else {
					this.form.tripulacao[0].erroTempoOvn = ''
				}
			}
			if (
				this.form.tripulacao[0].uso_ovn &&
				this.aeronave.habilita_ovn != '0'
			) {
				let arrayDataAcionamento = this.form.acionamento.split('/')
				arrayDataAcionamento[2] = arrayDataAcionamento[2].slice(0, 4)
				let dataAcionamento =
					arrayDataAcionamento[2] +
					'-' +
					arrayDataAcionamento[1] +
					'-' +
					arrayDataAcionamento[0]

				let dataAcionamentoDate = new Date(dataAcionamento)
				let dataCadastro = new Date(this.form.tripulacao[0].data_cadastro)

				if (dataCadastro > dataAcionamentoDate) {
					this.form.tripulacao[0].erroDataCadastro = erroData
					passou = false
				} else {
					this.form.tripulacao[0].erroDataCadastro = ''
				}
			}

			// valida o codigo ovn do piloto
			// if (this.aeronave.tipo == 'H') {
			// 	if (this.form.ovn == '1') {
			// 		if (this.form.tripulacao[0].codigo_ovn == '') {
			// 			this.form.tripulacao[0].erroOVN = obrigatorio
			// 			passou = false
			// 		} else {
			// 			this.form.tripulacao[0].erroOVN = ''
			// 		}
			// 	}
			// }

			// se tiver mais de 2 tripulantes, quer dizer q tem trip op, valida os campos
			if (this.form.tripulacao.length > 1) {
				for (var i = 1; i < this.form.tripulacao.length; i++) {
					if (this.form.tripulacao[i].funcao == '') {
						this.form.tripulacao[i].erroFuncao = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroFuncao = ''
					}
					// valida o nome
					if (this.form.tripulacao[i].id_usuario == '') {
						this.form.tripulacao[i].erroUsuario = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroUsuario = ''

						var pass = true
						_.forEach(this.form.tripulacao, (value, key) => {
							if (key != i) {
								if (value.id_usuario == this.form.tripulacao[i].id_usuario) {
									pass = false
								}
							}
						})

						if (!pass) {
							this.form.tripulacao[i].erroUsuario = 'Tripulante repetido.'
							passou = false
						} else {
							this.form.tripulacao[i].erroUsuario = ''
						}
					}
					const funcao = this.form.tripulacao[i].funcao.toLowerCase()

					if (
						this.form.tripulacao[i].uso_ovn == null &&
						this.aeronave.habilita_ovn &&
						this.aeronave.tipo == 'H' &&
						(funcao == 'piloto em comando' ||
							funcao == 'operador aerotático' ||
							funcao == 'copiloto')
					) {
						if (this.form.tripulacao[i].codigo_ovn == '') {
							this.form.tripulacao[i].erroOVN = obrigatorio
							passou = false
						} else {
							this.form.tripulacao[i].erroOVN = ''
						}
					}

					// valida a apresentacao
					if (this.form.tripulacao[i].apresentacao == '') {
						this.form.tripulacao[i].erroApresentacao = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroApresentacao = ''
						var dtAcionamento = new moment(
							this._dateTimeToDateSQL(
								this.form.acionamento,
								$sessao.getDateFormat() + ' HH:MM'
							)
						)
						var apresentacao = new moment(
							this._dateTimeToDateSQL(
								this.form.tripulacao[i].apresentacao,
								$sessao.getDateFormat() + ' HH:MM'
							)
						)

						if (moment(apresentacao).isAfter(dtAcionamento)) {
							this.form.tripulacao[i].erroApresentacao =
								'Maior que o acionamento.'
							passou = false
						} else {
							if (moment(apresentacao).isAfter(dtAcionamento)) {
								this.form.tripulacao[i].erroApresentacao =
									'Maior que o acionamento.'
								passou = false
							} else {
								this.form.tripulacao[i].erroApresentacao = ''
							}
						}

						if (this._idCliente == 41) {
							if (moment(dtAcionamento).diff(apresentacao, 'minutes') < 30) {
								if (moment(dtAcionamento).diff(apresentacao, 'minutes') >= 0) {
									this.form.tripulacao[i].erroApresentacao =
										'Menor que 30 min anterior ao acionamento.'
								} else {
									this.form.tripulacao[i].erroApresentacao =
										'Maior que o acionamento'
								}
								passou = false
							} else {
								this.form.tripulacao[i].erroApresentacao = ''
							}
						} else {
							if (moment(apresentacao).isAfter(dtAcionamento)) {
								this.form.tripulacao[i].erroApresentacao =
									'Maior que o acionamento.'
								passou = false
							} else {
								this.form.tripulacao[i].erroApresentacao = ''
							}
						}
					}

					if (
						this.form.tripulacao[i].uso_ovn == null &&
						this.aeronave.habilita_ovn != '0'
					) {
						this.form.tripulacao[i].erroUsoOvn = obrig
						passou = false
					} else {
						this.form.tripulacao[i].erroUsoOvn = ''
					}

					if (
						this.form.tripulacao[i].uso_ovn &&
						this.aeronave.habilita_ovn != '0'
					) {
						if (
							this.form.tripulacao[i].id_ovn == null ||
							this.form.tripulacao[i].id_ovn == ''
						) {
							this.form.tripulacao[i].erroIdOvn = obrig
							passou = false
						} else {
							this.form.tripulacao[i].erroIdOvn = ''
						}
					}

					if (
						this.form.tripulacao[i].uso_ovn &&
						this.aeronave.habilita_ovn != '0'
					) {
						if (
							this.form.tripulacao[i].tempoOvn == null ||
							this.form.tripulacao[i].tempoOvn === 0
						) {
							this.form.tripulacao[i].erroTempoOvn = obrig
							passou = false
						} else {
							this.form.tripulacao[i].erroTempoOvn = ''
						}
					}
					if (
						this.form.tripulacao[i].uso_ovn &&
						this.aeronave.habilita_ovn != '0'
					) {
						let arrayDataAcionamento_ = this.form.acionamento.split('/')
						arrayDataAcionamento_[2] = arrayDataAcionamento_[2].slice(0, 4)
						let dataAcionamento_ =
							arrayDataAcionamento_[2] +
							'-' +
							arrayDataAcionamento_[1] +
							'-' +
							arrayDataAcionamento_[0]

						const dataAcionamentoData = new Date(dataAcionamento_)
						let dataCadastro = new Date(this.form.tripulacao[i].data_cadastro)
						if (dataCadastro > dataAcionamentoData) {
							this.form.tripulacao[i].erroDataCadastro = erroData
							passou = false
						} else {
							this.form.tripulacao[i].erroDataCadastro = ''
						}
					}
				}
			}

			if (this.form.tipo_missao) {
				if (
					this.form.existe_unidade_conservacao == '' &&
					this.form.tipo_missao.descricao ==
						'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
				) {
					this.erro.existe_unidade_conservacao = 'Obrigatório.'
					passou = false
				} else {
					this.erro.existe_unidade_conservacao = ''
				}

				// obriga a inserir unidades de conservação
				if (
					this.form.existe_unidade_conservacao == '1' &&
					this.form.tipo_missao.descricao ==
						'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
				) {
					this.form.unidade_conservacao = this.form.unidade_conservacao.map(
						(item) => {
							if (item.obj == '') {
								item.erro = 'Campo obrigatório.'
								passou = false
							} else {
								item.erro = ''
							}
							return item
						}
					)
				}
			}

			// se for um voo de instrucao
			if (this.form.voo_instrucao == '1') {
				var pilotoInstrucao = _.find(this.form.tripulacao, function (o) {
					return o.funcao.toLowerCase() == 'piloto em instrução'
				})

				if (_.isNil(pilotoInstrucao)) {
					passou = false
					this.erro.instrutor_voo = _traducao('global', 'vooDeveConterPiloto')
				} else {
					this.erro.instrutor_voo = ''
				}
			}

			// valida os passageiros
			if (this.form.passageiro.length > 0) {
				for (var i in this.form.passageiro) {
					// if (this.form.passageiro[i].tipo == 'V') {
					// 	// valida nome
					// 	if (this.form.passageiro[i].nome == '') {
					// 		this.form.passageiro[i].nomeErro = obrig
					// 		passou = false
					// 	} else {
					// 		this.form.passageiro[i].nomeErro = ''
					// 	}

					// 	//valida sexo
					// 	if (this.form.passageiro[i].sexo == '') {
					// 		this.form.passageiro[i].sexoErro = obrig
					// 		passou = false
					// 	} else {
					// 		this.form.passageiro[i].sexoErro = ''
					// 	}

					// 	//valida idade
					// 	if (this.form.passageiro[i].idade == '') {
					// 		this.form.passageiro[i].idadeErro = obrig
					// 		passou = false
					// 	} else {
					// 		this.form.passageiro[i].idadeErro = ''
					// 	}
					// }

					if (this.form.passageiro[i].tipo == 'P') {
						// valida nome
						if (this.form.passageiro[i].nome == '') {
							this.form.passageiro[i].nomeErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].nomeErro = ''
						}

						if (this.passCpfObrigatorio) {
							if (this.form.passageiro[i].cpf == '') {
								this.form.passageiro[i].cpfErro = obrig + 'cpf válido'
								passou = false
							} else {
								this.form.passageiro[i].cpfErro = ''
							}
						} else {
							this.form.passageiro[i].cpfErro = ''
						}

						// valida orgao
						if (this.enableOrgao) {
							if (this.form.passageiro[i].orgao == '') {
								this.form.passageiro[i].orgaoErro = obrig
								passou = false
							} else {
								this.form.passageiro[i].orgaoErro = ''
							}
						}

						// valida cargo
						if (this.enableCargo) {
							if (this.form.passageiro[i].cargo == '') {
								this.form.passageiro[i].cargoErro = obrig
								passou = false
							} else {
								this.form.passageiro[i].cargoErro = ''
							}
						}
					}
					if ((this.form.passageiro[i].id_passageiro = '')) {
						this.form.passageiro[i].nomeErro =
							'Passageiro inválido, selecione novamente.'

						passou = false
					} else {
						this.form.passageiro[i].nomeErro = ''
					}
				}
			}
			// VALIDA CASO TENHA CARGA
			if (this.form.carga) {
				if(this.flagPeso){
					for (let carg of this.form.cargaArray) {
						if (carg.peso == 0) {
							carg.pesoErro = obrig
							passou = false
						} else {
							carg.descricao = 'Bagagem'
							carg.pesoErro = ''
						}
					}
				}else{
					for (let carg of this.form.cargaArray) {
						if (carg.descricao == '') {
							carg.descricaoErro = obrig
							passou = false
						} else {
							carg.descricaoErro = ''
						}

						if (carg.peso == '') {
							carg.pesoErro = obrig
							passou = false
						} else {
							carg.pesoErro = ''
						}

						if (carg.tipo_carga == '' && this.flagCompleto) {
							carg.erro_tipo_carga = obrig
							passou = false
						} else {
							carg.erro_tipo_carga = ''
						}

						if (carg.id_passageiro == '' && this.flagCompleto) {
							carg.id_pass_erro = obrig
							passou = false
						} else {
							carg.id_pass_erro = ''
						}

						if (carg.tipo_embalagem == '' && this.flagCompleto) {
							carg.erroEmbalagem = obrig
							passou = false
						} else {
							carg.erroEmbalagem = ''
						}
					}
				}
			}

			// PMSP
			if (this._idCliente == 14) {
				var soma = 0
				this.form.orgao = this.form.orgao.map((item) => {
					soma += item.tempo_voo

					return item
				})

				if (
					Number(this.form.tempo_voo_piloto).toFixed(1) !=
					Number(soma).toFixed(1)
				) {
					passou = false
					this.form.orgao = this.form.orgao.map((item) => {
						item.erroTempoVoo = 'A soma é diferente que o tempo do piloto'
						return item
					})
				} else {
					this.form.orgao = this.form.orgao.map((item) => {
						item.erroTempoVoo = ''
						return item
					})
				}
			}

			// valida a discrepancia
			if (this.form.discrepancia.length > 0) {
				for (var i in this.form.discrepancia) {
					if (this.form.discrepancia[i].id_usuario == '') {
						this.form.discrepancia[i].erroUsuario = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroUsuario = ''
					}

					if (this.form.discrepancia[i].descricao == '') {
						this.form.discrepancia[i].erroDescricao = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroDescricao = ''
					}
				}
			}

			// valida a ocorrencia
			if (this.form.ocorrencias.length > 0) {
				this.form.ocorrencias = this.form.ocorrencias.map((item) => {
					if (item.data == '') {
						item.erro_data = obrigatorio
						passou = false
					} else {
						item.erro_data = ''
					}

					if (item.local == '') {
						item.erro_local = obrigatorio
						passou = false
					} else {
						item.erro_local = ''
					}

					if (item.codigo_classificacao == '') {
						item.erro_codigo_classificacao = obrigatorio
						passou = false
					} else {
						item.erro_codigo_classificacao = ''
					}

					if (item.qualificacao_civil == '') {
						item.erro_qualificacao_civil = obrigatorio
						passou = false
					} else {
						item.erro_qualificacao_civil = ''
					}

					if (item.descricao_fatos == '') {
						item.erro_descricao_fatos = obrigatorio
						passou = false
					} else {
						item.erro_descricao_fatos = ''
					}

					return item
				})
			}

			/*	OBRIGATÓRIEDADE
			if (this.form.numero_chamada == '') {
				this.erro.numero_chamada = obrigatorio
				passou = false
			} else {
				this.erro.numero_chamada = ''
			}
			*/

			if (
				this.form.objetivo_alcancado == '' &&
				this.exibeObjetivosMissao == '1'
			) {
				this.erro.objetivo_alcancado = obrigatorio
				passou = false
			} else {
				this.erro.objetivo_alcancado = ''
			}

			// tipo de missao
			if (!this.form.tipo_missao) {
				this.erro.tipo_missao = obrigatorio
				passou = false
			} else {
				this.erro.tipo_missao = ''
			}

			// tipo de natureza
			if (!this.homologadoAnac && !this.form.tipo_natureza) {
				this.erro.tipo_natureza = obrigatorio
				passou = false
			} else {
				this.erro.tipo_natureza = ''
			}

			// descricao
			if (this.habilitaDescMissao && !this.form.descricao) {
				this.erro.descricao = obrigatorio
				passou = false
			} else {
				this.erro.descricao = ''
			}

			// subclassificacao
			if (this._idCliente != 41 && this.form.subclassificacao) {
				if (
					this.form.subclassificacao == null ||
					this.form.subclassificacao == ''
				) {
					this.erro.subclassificacao = obrigatorio
					passou = false
				} else {
					this.erro.subclassificacao = ''
				}
			}

			// orgao
			if (this.form.orgao.length == 0) {
				this.erro.orgao = obrigatorio
				passou = false
			} else {
				this.erro.orgao = ''

				for (var i in this.form.orgao) {
					if (this.form.orgao[i].orgao == '') {
						this.form.orgao[i].erroOrgao = obrigatorio
						passou = false
					} else {
						this.form.orgao[i].erroOrgao = ''

						// se o orgao tiver unidades
						if (this.form.orgao[i].orgao.unidade.length > 0) {
							if (this.form.orgao[i].unidade.length == 0) {
								this.form.orgao[i].erroOrgao =
									this._traducao('global', 'voceTemQueEscolherUnidade') +
									' ---->'
								passou = false
							} else {
								this.form.orgao[i].erroOrgao = ''
							}

							for (var j in this.form.orgao[i].unidade) {
								if (this.form.orgao[i].unidade[j].unidade == '') {
									this.form.orgao[i].unidade[j].erroUnidade = obrig
									passou = false
								} else {
									this.form.orgao[i].unidade[j].erroUnidade = ''
								}
							}
						}
					}
				}
			}

			// houve contexto
			if (this.form.houve_contexto == '') {
				this.erro.houve_contexto = obrigatorio
				passou = false
			} else {
				this.erro.houve_contexto = ''

				if (this.form.houve_contexto == '1') {
					if (this.form.contexto_operativo == '') {
						this.erro.contexto_operativo = obrigatorio
						passou = false
					} else {
						this.erro.contexto_operativo = ''
					}
				}
			}

			if (this.despacho != '') {
				// se tiver ordem
				if (
					this.despacho.id_ordem_missao != null &&
					this.despacho.id_ordem_missao != '0'
				) {
					if (this.dbComercial) {
						this.form.finalizar_ordem = 1
					}
					if (this.form.finalizar_ordem == '' && this.exibeFinalizarOrdemMissao == '1') {
						this.erro.finalizar_ordem = obrigatorio
						passou = false
					} else {
						this.erro.finalizar_ordem = ''
					}
				}

				if (this.form.finalizar_despacho == '') {
					this.erro.finalizar_despacho = obrigatorio
					passou = false
				} else {
					this.erro.finalizar_despacho = ''
				}
			}
			this.$forceUpdate()
			return passou
		},

		voltaLista() {
			this.limpaTimeOuts()
			this._escondeModal('modal-ordem-tempo-expirado')
			this.$emit('volta-diario-piloto')
			//bus.$emit('volta-diario-piloto', this.name)
		},

		limpaTimeOuts() {
			clearTimeout(this.timeOut)
			clearTimeout(this.timeOutModal)
		},

		carregaDados() {
			// ROTA AE
			// bus.$emit('load-in', {text: this._traducao('global','carregando')})
			this._providerRotaer((lista) => {
				this.rotaER = lista
				this.rotaER.push({sigla: 'ZZZZ'})
			})

			// AERONAVE
			this.loadAero = true
			this._providerAeronave((lista) => {
				this.loadAero = false
				this.aeronaves = lista
			})
			// ESTADOS
			this._providerEstado((lista) => {
				this.estados = lista
			})

			// SUBCLASSIFICACAO
			this._providerSubclassificacao((lista) => {
				this.subclassificacoes = lista
			})

			// UNIDADE CONSERVACAO
			this._providerUnidadeConservacao((lista) => {
				this.unidadesConservacao = lista
			})

			// BASE ORIGEM
			this._providerBaseOrigem((lista) => {
				this.basesOperacao = lista
			})

			this._httpGet('Ata/get', (response) => {
				this.listaAtas = response.lista
			})

			// carrega pilotos
			this._httpGet('Usuario/get_by_perfil/' + 14, (retorno) => {
				if (retorno._request) {
					this.pilotos = retorno.lista
				}
			})

			// mecanicos
			this._httpGet('Usuario/get_by_perfil/' + 16, (retorno) => {
				if (retorno._request) {
					this.mecanicos = retorno.lista
				}
			})

			this._httpGet('Ovn/get', (response) => {
				if (response._request && response._status) {
					this.ovns = response.lista
				}
			})

			this._providerContextoOperativo((lista) => {
				this.contextos = lista
			})

			this._providerOrgaoApoiado((lista) => {
				this.orgaos = lista
			})

			this._providerBaseOperacional((lista) => (this.bases = lista))
			this._providerDescricaoDaMissao((lista) => (this.descricoes = lista))
			this._providerTipoDeMissao((lista) => (this.tiposDeMissoes = lista))

			this._axios('Tipo_natureza/get_tipo_natureza', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.tiposDeNaturezas = retorno.lista.map((item) => {
							item.label = `${item.sigla} - ${item.descricao}`
							return item
						})
					}
				}
			})

			this.carregarListaPassageiros()
		},

		async verificaCe() {
			if (this.aeronave.id && this.form.numero_ce) {
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'carregando')
				})
				const dadosMovimentacoesCombustivel =
					await this.getMovimentacaoCombustivel(
						this.aeronave.id,
						this.form.numero_ce
					)
				window.bus.$emit('load-out')
				if (
					Array.isArray(dadosMovimentacoesCombustivel) &&
					dadosMovimentacoesCombustivel.length >= 1
				) {
					this.$refs.movimentacoesCombustivel.carregaDados(
						dadosMovimentacoesCombustivel
					)
				} else {
					this.movimentacaoCombustivel.exibeOrigem = false
					this.movimentacaoCombustivel.origem = null
				}
			}
		},

		async getMovimentacaoCombustivel(idAeronave, numeroCe) {
			return new Promise((resolve) => {
				this._axios(
					`/mg-siga/Relatorio_voo_trecho/get_movimentacao_combustivel/${idAeronave}/${numeroCe}`,
					'get',
					{
						callback: (retorno) => {
							if (retorno._request && retorno._status) {
								resolve(retorno.lista)
							}
						}
					}
				)
			})
		},
		movimentacaoSelecionado(movimentacao) {
			this.form.volume = parseFloat(movimentacao.volume)
			this.form.id_abastecimento_comprovante = movimentacao.id
			this.form.id_unidade_armazenamento = movimentacao.id_unidade_armazenamento
			if (movimentacao.id_movimentacao) {
				this.movimentacaoCombustivel.exibeOrigem = true
				this.movimentacaoCombustivel.origem = movimentacao.origem
			}
		},
		exibirRemover() {
			if (
				this.movimentacaoCombustivel.exibeOrigem === null ||
				this.movimentacaoCombustivel.origem === null
			) {
				return false
			}
			return true
		},

		limpardb() {
			this.form.numero_ce = null
			this.form.volume = 0
			this.form.id_abastecimento_comprovante = null
			this.form.id_unidade_armazenamento = null
			this.movimentacaoCombustivel.exibeOrigem = false
			this.movimentacaoCombustivel.origem = null
			this.exibirRemover()
		},

		async trocarPiloto(vooInstrucao, funcao, index, zeraId, carregaAnac) {
			this.clickSetaVooInstrucao(vooInstrucao)
			await this.carregaUsuariosTripulacao(funcao, index, zeraId, carregaAnac)
		},

		carregaDadosDb() {
			this._httpGet(
				'mg-siga/Relatorio_voo_trecho/get/' + this.trecho.id,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						this.carregaDadosPreenchimento(response.lista)
					}
				}
			)
		},
		carregaDadosPreenchimento(data) {
			this.form.tipo_voo = data.origem

			// carrega o despacho caso tenha
			if (data.id_despacho_emergencial != null) {
				this._httpGet(
					'mg-siga/Despacho_emergencial/get/' + data.id_despacho_emergencial,
					(retorno) => {
						bus.$emit('load-out')

						if (retorno._request) {
							this.despacho = retorno.lista
						}
					}
				)
			}
			this.form.total_ciclo_torque =
				data.total_ciclo_torque == null ? '' : data.total_ciclo_torque
			this.form.total_gancho =
				data.total_gancho == null ? '' : data.total_gancho
			this.form.total_guincho =
				data.total_guincho == null ? '' : data.total_guincho
			this.form.total_partidas =
				data.total_partidas == null ? '' : data.total_partidas
			this.form.total_pousos =
				data.total_pousos == null ? '' : data.total_pousos
			this.form.existe_unidade_conservacao = data.existe_unidade_conservacao

			if (data.verificacao_vor) {
				if (data.verificacao_vor.length == 0) {
					this.form.verificacao_vor[0].verifica_vor = 'N'
				} else {
					this.form.verificacao_vor[0].verifica_vor = 'S'
					this.form.verificacao_vor[0].id = data.verificacao_vor[0].id
					this.form.verificacao_vor[0].data = data.verificacao_vor[0].data
					this.form.verificacao_vor[0].id_estado =
						data.verificacao_vor[0].id_estado
					this.loadVor = true
					this.carregaCidades((callback) => {
						this.loadVor = false
						this.cidadesVor = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, data.verificacao_vor[0].id_estado)
					this.form.verificacao_vor[0].id_cidade =
						data.verificacao_vor[0].id_cidade
					this.form.verificacao_vor[0].defasagem1 =
						data.verificacao_vor[0].defasagem1
					this.form.verificacao_vor[0].defasagem2 =
						data.verificacao_vor[0].defasagem2
					this.form.verificacao_vor[0].aprovado =
						data.verificacao_vor[0].aprovado == '1' ? 'S' : 'N'
				}
			}

			this.form.numero_diario_anac = this.trecho.numero_diario

			this.form.id = data.id
			this.form.id_despacho = data.id_despacho_emergencial
			this.form.voo_instrucao = data.voo_instrucao
			this.form.finalizar_despacho = data.finalizar_despacho

			this.form.nome_usuario_inseriu = data.nome_usuario_inseriu
			this.form.data_cadastro = data.data_cadastro

			this.form.objetivo_alcancado =
				data.objetivo_alcancado == null ? '' : data.objetivo_alcancado

			this.form.decolagem = this._SQLDateToDateTime(
				data.decolagem,
				$sessao.getDateFormat() + ' HH:MM'
			)
			this.setaDecolagem(this.form.decolagem)
			this.form.pouso = this._SQLDateToDateTime(
				data.pouso,
				$sessao.getDateFormat() + ' HH:MM'
			)
			this.setaPouso(this.form.pouso)

			if (data.pouso_utc != null) {
				this.form.pouso_utc = this._SQLDateToDateTime(
					data.pouso_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.pouso_utc = ''
			}

			if (data.decolagem_utc != null) {
				this.form.decolagem_utc = this._SQLDateToDateTime(
					data.decolagem_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.decolagem_utc = ''
			}

			if (data.corte_utc != null) {
				this.form.corte_utc = this._SQLDateToDateTime(
					data.corte_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.corte_utc = ''
			}

			if (data.acionamento_utc != null) {
				this.form.acionamento_utc = this._SQLDateToDateTime(
					data.acionamento_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.acionamento_utc = ''
			}

			// if (!_.isNil(data.trecho_motor)) {
			// 	this.form.monitoramento_motor = data.trecho_motor.map((item) => {
			// 		item.rpm = Number(item.rpm)
			// 		item.ng = Number(item.ng)
			// 		item.nl = Number(item.nl)
			// 		item.fuel_flow = Number(item.fuel_flow)
			// 		item.itt = Number(item.itt)
			// 		item.tq = Number(item.tq)
			// 		return item
			// 	})

			// 	this.form.trecho_motor = data.trecho_motor.map((item) => {
			// 		item.erro_ciclo_nf = ''
			// 		item.erro_ciclo_ng = ''
			// 		item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
			// 		item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
			// 		return item
			// 	})
			// }

			this.form.para = data.para
			this.form.para_select = _.find(this.rotaER, (o) => {
				return o.sigla == data.para
			})
			this.form.nome_estado_para = data.estado_termino_missao
			if (this.form.nome_estado_para) {
				var estado = _.find(this.estados, (o) => {
					return (
						o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
					)
				})
			}
			if (estado) {
				this.carregaCidades((callback) => {
					this.cidadesPara = callback.lista
					this.form.nome_cidade_para = data.cidade_termino_missao
					this.form.nome_estado_para = data.estado_termino_missao
					this.form.lat_fim = data.lat_fim
					this.form.lng_fim = data.lng_fim
					// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
				}, estado.id)
			}

			this.form.de = data.de
			this.form.de_select = _.find(this.rotaER, (o) => {
				return o.sigla == data.de
			})
			this.form.nome_estado_de = data.estado_inicio_missao
			if (this.form.nome_estado_de) {
				var estado = _.find(this.estados, (o) => {
					return o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
				})
			}
			if (estado) {
				this.carregaCidades((callback) => {
					this.cidadesDe = callback.lista
					this.form.nome_cidade_de = data.cidade_inicio_missao
					this.form.nome_estado_de = data.estado_inicio_missao
					this.form.lat_inicio = data.lat_inicio
					this.form.lng_inicio = data.lng_inicio
					// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
				}, estado.id)
			}

			// pega os dados do piloto
			if (
				!this.isVisualizarDiarioOperadorOuPiloto &&
				this.form.tripulacao.length > 0 &&
				data.tripulacao.length > 0
			) {
				this.form.tripulacao[0].id_usuario = data.tripulacao[0].id_usuario
				this.form.tripulacao[0].erroUsuario = ''
				this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
					data.tripulacao[0].apresentacao,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.form.tripulacao[0].erroApresentacao = ''
				this.form.tripulacao[0].codigo_ovn = data.tripulacao[0].codigo_ovn
				this.form.tripulacao[0].erroOVN = ''
				this.form.tripulacao[0].usuarios = []

				this.carregaUsuariosTripulacao(
					data.tripulacao[0].funcao,
					0,
					false,
					true
				)

				var verificaComando =
					this.form.voo_instrucao == 0
						? 'piloto em comando'
						: 'piloto em instrução'
				for (var i in data.tripulacao) {
					if (data.tripulacao[i].funcao != null) {
						if (
							Number(data.tripulacao[i].id_usuario) != 0 &&
							data.tripulacao[i].funcao.toLowerCase() != verificaComando
						) {
							this.form.tripulacao.push({
								id_usuario: data.tripulacao[i].id_usuario,
								erroUsuario: '',
								funcao: data.tripulacao[i].funcao,
								anac: data.tripulacao[i].anac,
								apresentacao: this._SQLDateToDateTime(
									data.tripulacao[i].apresentacao,
									$sessao.getDateFormat() + ' HH:MM'
								),
								erroApresentacao: '',
								codigo_ovn: data.tripulacao[i].codigo_ovn,
								usuarios: [],
								nome: '',
								trigrama: '',
								erroFuncao: '',
								erroOVN: ''
							})

							this.carregaUsuariosTripulacao(
								data.tripulacao[i].funcao,
								i,
								false,
								true
							)
						}
					}
				}
			} else {
				this.form.tripulacao = data.tripulacao.map((tripulacao) => ({
					...tripulacao,
					apresentacao: this._SQLDateToDateTime(
						tripulacao.apresentacao,
						window.$sessao.getDateFormat() + ' HH:MM'
					),
					erroUsuario: '',
					erroApresentacao: '',
					erroFuncao: '',
					erroOVN: ''
				}))
			}

			this.form.base = data.base

			// para o histórico, antes tinha so a descrição, depois criamos uma tabela, então para não dar pau no histórico
			// verifico se o id e null, se for carrega pela descrição, se tiver id, carrega pelo id
			if (_.isNil(data.id_tipo_missao)) {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.descricao == data.descricao_tipo_missao
				})
			} else {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.id == data.id_tipo_missao
				})
			}

			if (!_.isNil(data.id_tipo_natureza)) {
				this.form.tipo_natureza = _.find(this.tiposDeNaturezas, (o) => {
					return o.id == data.id_tipo_natureza
				})
			}

			// this.form.tipo_missao = _.find(this.tiposDeMissoes, o => {return o.id == data.id_tipo_missao})
			this.form.descricao = data.descricao_missao

			this.form.subclassificacao =
				data.id_subclassificacao != null
					? this.getSubclassificacaoById(data.id_subclassificacao)
					: ''

			this.form.houve_contexto = this.validaNull(data.houve_contexto)

			if (this.form.houve_contexto != null) {
				for (var i in this.contextos) {
					if (this.contextos[i].id == data.id_contexto_operativo) {
						this.form.contexto_operativo = this.contextos[i]
					}
				}
			}

			// orgaos recebidos
			this.form.orgao = []
			_.forEach(data.orgao, (org) => {
				var orgao_apoiado = {}
				var orgao = _.find(this.orgaos, (o) => {
					return o.id == org.id
				})
				orgao_apoiado.erroOrgao = ''
				orgao_apoiado.erroTempoVoo = ''
				orgao_apoiado.orgao = orgao
				orgao_apoiado.tempo_voo = Number(org.tempo_voo).toFixed(2)
				var unidades = []

				_.forEach(org.unidade, (unidade) => {
					var uni = _.find(orgao_apoiado.orgao.unidade, (o) => {
						return o.id == unidade.id_orgao_apoiado_unidade
					})

					if (!_.isNil(uni)) {
						uni.erroUnidade = ''
						unidades.push({unidade: uni, erroUnidade: ''})
					}
				})

				orgao_apoiado.unidade = unidades
				this.form.orgao.push(orgao_apoiado)
			})

			this.form.observacao = data.observacao

			// se for um array
			if (_.isArray(data.unidade_conservacao)) {
				// se existir unidade de conservação
				if (data.unidade_conservacao.length > 0) {
					this.form.unidade_conservacao = data.unidade_conservacao.map(
						(item) => {
							return {
								obj: _.find(this.unidadesConservacao, (o) => {
									return item.id_unidade_conservacao == o.id
								}),
								erro: ''
							}
						}
					)
				}
			} else {
				if (data.unidade_conservacao != '') {
					this.form.unidade_conservacao.push({
						obj: _.find(this.basesOperacao, (o) => {
							o.sigla == data.unidade_conservacao
						})
					})
				}
			}
		},

		clickPrintPassageiro(item, tipo, id_diario = null) {
			let url = `mg-siga/Ordem_missao/${tipo}/${item.id_ordem}/${
				item.id_despacho
			}/${id_diario}/${$sessao.getToken()}`
			url = this.getURL_WS(url)
			let a = document.createElement('a')
			a.href = url
			a.target = '_blank'
			document.body.appendChild(a)
			a.click()

			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._axios(url, 'get', {
				callback: (response) => {
					window.bus.$emit('load-out')

					if (response._request) {
						if (!_.isNil(response.lista)) {
							this.lista = response.lista
							this.buscou = true
						} else {
							bus.$emit('exibir-notificacao', {
								text: 'Nenhum resultado foi encontrado.',
								type: 'danger'
							})
						}
					}
				}
			})
		}
	}
}
</script>

<style scoped>
.table-hover-tr:hover td {
	background: #f0f0f0;
}

.bk-success td {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
.inveter-tripulacao {
	position: absolute;
	padding: 2px 4px;
	cursor: pointer;
	display: inline-block;
	right: -10px;
	top: 45%;
	z-index: 99999;
	border-radius: 2px;
	color: #2196f3;
}
.inveter-tripulacao:hover {
	color: #2174f3;
}

.loader {
	text-align: center;
	color: #bbbbbb;
}

.color {
	color: #2196f3;
}

.border-color {
	border-color: #2196f3;
}
</style>
